const zhCn = {
  "menu.overview": "概览",
  "menu.sales": "销售",
  "menu.inventory-management": "商品与库存",
  "menu.crm": "客户与伙伴",
  "menu.finance": "财务与税务",
  "menu.utilities": "实用工具",
  "product.tax-rate": "税率",
  "table.import.tax-rate": "税率 (%)",
  /* 00.General */
  "general.copyright": "Coffee Management © 2019 保留所有权利。",
  "general.refresh": "刷新列表",
  "general.btn-update": "更新",
  "general.btn-update-count": "更新数量",
  "general.btn-add": "添加",
  "general.btn-order": "立即订购！",
  "general.btn-order-preview": "查看产品",
  "general.product-unit": "产品",
  "general.btn-create-make-product": "创建配方",
  "general.btn-update-make-product": "更新配方",
  "general.btn-cancel": "取消",
  "role.default.cashier": "收银员",
  "role.default.kitchen": "吧台 / 厨房",
  "role.default.table-pending-payment": "跑堂",
  "general.info": "信息",
  "general.setting": "设置",
  "general.function": "功能",
  timeCreated: "创建时间",
  "print.cashier": "收银员",
  "print.invoice": "发票",
  "print.name-product": "名称",
  "print.quantity": "数量",
  "print.price": "价格",
  "print.total-price": "总计",
  "print.discount": "折扣",
  "print.tax": "税",
  "print.fee-other": "其他费用",
  "print.shipping": "运输",
  "print.amount-to-pay": "应付金额",
  "print.info-bill": "账单信息",
  "print.thank-you": "非常感谢！",
  "print.copy-right": "vmass.vn 版权所有。",

  /* 01.Order */
  "order.to-pending": "送往厨房",
  "order.to-done": "去付款",
  "order.done": "完成",
  "order.to-refund": "退款",
  "order.to-change": "更改",
  "order.to-bill-draft": "打印临时发票",
  "order.to-bill": "打印账单",
  "order.to-end": "已完成",
  "order.print-bill": "打印账单",
  "order.to-excel": "下载 Excel",
  "order.to-destroy": "作废",
  "order.transfer-table": "换桌",
  "order.to-bill-now": "打印",
  "order.to-bill-all": "全部打印",
  "order.open-menu": "添加产品",
  "order.search": "搜索发票",
  "order.list-product-in-table": "桌上产品列表",

  /* 02. Profile */
  "company-uuid": "店铺代码",
  "company-name": "店铺名称",
  "profile.fullname": "全名",
  "profile.username": "用户名",
  "profile.email": "电子邮件",
  "profile.address": "地址",
  "profile.description": "描述",
  "profile.avatar": "头像",
  "profile.company-address": "公司地址",
  "profile.company-website": "网站",
  "profile.company-logo": "店铺 Logo",
  "profile.company-image": "店铺封面照片",
  "profile.company-start-time": "营业时间",
  "profile.company-end-time": "打烊时间",
  "profile.company-menu-hash": "店铺菜单代码",
  "profile.company-menu-hash-create": "新增",
  "profile.phone": "电话",
  "profile.birth-day": "生日",
  "profile.btn-update": "更新",
  "pages.responsibilities": "专长",
  "menu.contact": "社交",
  "profile.update-personal": "更新个人信息",
  "profile.update-company": "更新公司信息",
  "profile.companyName": "店铺名称",
  "profile.bankPay": "银行名称",
  "profile.namePay": "账户持有人姓名",
  "profile.numberPay": "账号",

  /* 03.User Login, Logout, Register */
  "user.login-title": "登录",
  "user.register": "注册",
  "user.forgot-password": "忘记密码",
  "user.username": "用户名",
  "user.email": "电子邮件",
  "user.phone": "电话",
  "user.password": "密码",
  "user.re-password": "确认密码",
  "user.forgot-password-question": "忘记密码？",
  "user.reset-password-button": "接收新代码",
  "user.reset-password-button-submit": "更改密码",
  "user.fullname": "全名",
  "user.login-button": "登录",
  "user.register-button": "注册",
  "user.no-account": "没有账号？ ",
  "user.register-link": "立即注册",
  "user.code": "代码",

  /* 04.Menu */
  "menu.partner": "个人",
  "menu.money": "财务",
  "menu.m": "产品",
  "menu.warehouse": "库存",
  "menu.invoice": "发票",
  "menu.sales-invoice": "销售发票",
  "menu.einvoice": "电子发票",
  "menu.order": "发票",
  "menu.app": "首页",
  "menu.affiliates": "联盟",
  "menu.affiliate-list": "联盟列表",
  "menu.affiliate-payouts": "联盟支付",
  "menu.affiliate-commission": "佣金配置",
  "menu.affiliate-reports": "联盟报告",
  "menu.affiliate-fraud": "欺诈控制",
  "menu.calendars": "日历",
  "menu.analytics": "分析",
  "menu.faq": "常见问题",
  "menu.view": "问答",
  "menu.default": "概况",
  "menu.content": "内容",
  "menu.product": "产品",
  "menu.menu": "产品",
  "menu.pages": "管理",
  "menu.thumb-list": "产品管理",
  // 'menu.order': 'Order',
  "menu.search": "搜索",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.company": "店铺信息",
  "menu.profile": "信息",
  "menu.forgot-password": "更改密码",
  "menu.applications": "账户",
  "menu.promotion": "促销",
  "menu.todo": "事件",
  "menu.category": "产品类型",
  "menu.ui": "界面",
  "menu.table-setting": "桌椅",
  "menu.stock": "库存",
  "menu.warehouse-import": "入库单",
  "menu.warehouse-export": "出库单",
  "menu.warehouse-transfer": "调拨单",
  "menu.make-product": "配方",
  "menu.payment": "待付款桌位",
  "menu.table-pending-payment": "待付款",
  "menu.message": "消息",
  "menu.ref": "联盟",
  "menu.upgrade": "升级",
  "menu.setting": "设置",
  "menu.root": "VMASS",
  "menu.user-staff": "员工",
  "menu.customer": "客户",
  "menu.company-provider": "供应商",
  "menu.treasury": "资金",
  "menu.income": "收入",
  "menu.outcome": "支出",
  "menu.cash-flow": "现金流",
  "menu.role": "权限创建",
  "menu.form-dynamic": "自定义表单",
  "menu.user-role": "创建账户",
  "menu.qrcode": "二维码",
  "menu.companies": "关联店铺",
  "menu.shipping": "运输",
  "menu.facebook-settings": "Facebook 粉丝页",
  "menu.zalo-settings": "Zalo OA",
  "menu.dashboards": "仪表板",
  "menu.calendars": "日历",
  "menu.booking": "预订",
  "menu.analytics": "分析",
  "menu.pages": "管理",
  "menu.todo": "待办事项",
  "menu.invoice": "发票",
  "menu.promotion": "促销",
  "menu.partner": "合作伙伴",
  "menu.money": "现金账簿",
  "menu.m": "仓库管理",
  "menu.thumb-list": "产品列表",
  "menu.warehouse": "仓库",
  "menu.stock": "库存",
  "menu.inventory-audit": "库存盘点",
  "menu.stock-return": "库存退货",
  "menu.stock-disposal": "库存报废",
  "menu.stock-out": "库存出库",
  "stock-out.subtitle": "统一管理内部领用、退供应商和报废，并保留审批记录。",
  "stock-out.create": "新建出库单",
  "menu.table-setting": "餐桌设置",
  "menu.message": "消息",
  "menu.facebook-ads": "Facebook Ads",
  "menu.fb-ads-dashboard": "Dashboard",
  "menu.fb-ads-campaigns": "Campaigns",
  "menu.fb-ads-reports": "Reports",
  "menu.fb-ads-settings": "Settings",
  "menu.applications": "应用",
  "menu.profile": "个人资料",
  "menu.upgrade": "升级",
  "menu.setting": "设置",
  "warehouse.export": "库存出库",
  "warehouse.transfer": "库存调拨",

  /* Shift Session */
  "menu.shift-session": "班次结算",
  "menu.tax-accounting": "账簿 & 税务",
  "menu.ai-copilot": "AI 助手",
  "shift.title": "班次管理",
  "shift.open": "开班",
  "shift.close": "结班",
  "shift.current": "当前班次",
  "shift.history": "班次历史",
  "shift.no-open": "目前没有开启的班次",
  "shift.open-hint": '点击"开班"开始新的班次',
  "shift.open-modal-title": "开启班次",
  "shift.close-modal-title": "结班 & 现金对账",
  "shift.detail-modal-title": "班次详情",
  "shift.shift-name": "班次名称",
  "shift.shift-name-placeholder": "例如：早班、午班...",
  "shift.staff-name": "员工",
  "shift.opened-at": "开班时间",
  "shift.closed-at": "结班时间",
  "shift.opening-cash": "期初现金",
  "shift.opening-cash-hint": "班次开始时收银台内的现金",
  "shift.actual-cash": "班次结束实际现金",
  "shift.actual-cash-placeholder": "输入实际清点的现金",
  "shift.expected-cash": "理论现金",
  "shift.cash-difference": "差异",
  "shift.total-revenue": "总收入",
  "shift.total-cash": "现金",
  "shift.total-transfer": "银行转账",
  "shift.total-card": "信用卡",
  "shift.total-credit": "赊账",
  "shift.total-orders": "总订单数",
  "shift.total-products": "总商品数",
  "shift.note": "备注",
  "shift.note-optional": "备注（可选）",
  "shift.note-explain": "差异说明",
  "shift.note-explain-required": "必填 - 请输入现金差异原因",
  "shift.status": "状态",
  "shift.status-open": "进行中",
  "shift.status-closed": "已结班",
  "shift.confirm-open": "确认开班",
  "shift.confirm-close": "确认结班",
  "shift.require-open": "请先开班再进行销售",
  "shift.print": "打印结班报告",
  "shift.print-title": "结班报告",
  "shift.revenue-in-shift": "班次营收",
  "shift.cash-reconciliation": "现金对账",
  "shift.cash-revenue-add": "+ 现金营收",
  "shift.expected-cash-equals": "= 理论现金",
  "shift.no-data": "暂无班次数据",
  "shift.detail": "详情",
  "shift.page-prev": "← 上一页",
  "shift.page-next": "下一页 →",
  "shift.page-of": "第 {current} / {total} 页",
  "shift.open-success": "开班成功",
  "shift.close-success": "结班成功",
  "shift.open-error": "开班失败",
  "shift.close-error": "结班失败",
  "shift.close-warn-difference": "存在现金差异。请在结班前输入差异说明。",
  "shift.store-name": "店铺",
  "shift.copyright": "版权所有 vmass.vn",
  "shift.cancel": "取消",

  /* 05.Dashboards */
  "dashboards.pending-orders": "接收订单",
  "dashboards.completed-orders": "长期订单",
  "dashboards.refund-requests": "退款订单",
  "dashboards.sales": "销售",
  "dashboards.sales-chart": "销售图表",
  "dashboards.orders": "订单",
  "dashboards.refunds": "退款",
  "dashboards.calendar": "日历",
  "dashboards.best-sellers": "热销列表",
  "dashboards.this-week": "本周",
  "dashboards.this-month": "本月",
  "dashboards.this-all-sales": "总收入",
  "dashboards.recent-orders": "最近订单",
  "dashboards.stock-status": "库存状态",
  "dashboards.logs": "日志",
  "dashboards.message": "消息",
  "dashboards.area": "区域",
  "dashboards.status-order": "订单状态摘要",
  "dashboards.pending-order": "未收货产品列表",
  "dashboards.order-undelivery": "未发货产品列表",
  "dashboards.order-pending-payment": "未收款桌位列表",
  "dashboards.total-order": "订购产品总数",
  "dashboards.product-not-receive": "未收货产品",
  "dashboards.product-not-delivery": "未发货产品",
  "dashboards.table-notyet-pay": "未收款桌位",
  "dashboards.product-received-full": "所有产品已收货",
  "dashboards.total-product-received": "已收货产品总数",
  "dashboards.product-delivery-full": "所有产品已发货",
  "dashboards.total-table-has-customer": "当天有客人的桌位总数",
  "dashboards.table-payment-full": "桌位已全部付款",
  "dashboards.list-empty": "列表为空",
  "dashboards.total": "总计",
  "dashboards.counter": "柜台",
  "dashboards.table": "桌位",
  "dashboards.ice": "冰",
  "dashboards.sugar": "甜度",
  "dashboards.all": "全部",
  "dashboards.completed": "已完成",
  "dashboards.destroy": "作废",
  "dashboards-empty-product": "列表中尚无产品",

  /** Analytics */
  "analytics.dashboards": "概况",
  "analytics.user-staff": "员工",
  "analytics.customer": "客户",
  "analytics.company-provider": "供应商",
  "analytics.treasury": "资金",
  "analytics.income": "收入",
  "analytics.outcome": "支出",
  "analytics.cash-flow": "现金流",
  "analytics.role": "权限创建",
  "analytics.user-role": "创建账户",
  "analytics.form-dynamic": "自定义表单",
  "analytics.companies": "关联店铺",
  "analytics.dashboards.outcome": "成本统计",
  "analytics.dashboards.income": "收入统计",
  "analytics.dashboards.stock-log": "入库统计",
  "analytics.dashboards.order-payment": "已售产品统计列表",
  "analytics.dashboards.debt": "债务统计",
  "analytics.dashboards.make-product": "库存使用统计",
  "analytics.dashboards.order-table": "桌位统计",
  "analytics.today": "今天",
  "analytics.yesterday": "昨天",
  "analytics.7-days-ago": "7天前",
  "analytics.this-week": "本周",
  "analytics.last-week": "上周",
  "analytics.30-days-ago": "30天前",
  "analytics.this-month": "本月",
  "analytics.last-month": "上月",
  "analytics.all": "全部",
  "analytics.compare": "比较",
  // 'analytics.update': 'Update',
  "analytics.revenue": "收入",
  "analytics.costs": "固定成本",
  "analytics.profit": "利润",
  "analytics.invoice-quantity": "发票数量",
  "analytics.number-products-sold": "已售产品数量",
  "analytics.average-selling-price": "平均售价",
  "analytics.total-product": "总产品",
  "analytics.product": "产品",
  "analytics.amount-of-inventory": "库存数量",
  "analytics.items": "项目",
  "analytics.inventory-value": "库存价值",

  /* product */
  "product.title": "添加产品",
  "product.title.update": "更新产品",
  "product.add-new": "添加 1 个产品",
  "product.tab.import-excel": "从 Excel 导入",
  "product.tab.import-image": "从图片导入",
  "product.tooltip.category":
    "这是产品的父类别。此类别在创建产品之前创建。（注意：如果父类别被删除，属于它的所有产品也将被删除，请小心！）。",
  "product.tooltip.categories":
    "这是产品的父类别。此类别在创建产品之前创建。（注意：如果父类别被删除，属于它的所有产品也将被删除，请小心！）。",
  "product.tooltip.price": "如果未选中“促销价格”，这就是销售价格。",
  "product.tooltip.topping": "添加额外项目或附加组件及其相应的额外费用。",
  "product.tooltip.ice": "勾选 5 个框以允许客户选择冰量。",
  "product.tooltip.sugar": "勾选 5 个框以允许客户选择甜度。",
  "product.notify.create-stock-success": "创建新库存成功",
  "product.notify.create-stock-error": "创建新库存出错",
  "product.notify.no-detail": "无法加载产品详情。",
  "product.import.result": "导入结果",
  "product.import.choose-file": "选择 Excel 文件导入产品",
  "product.import.support-format": "支持 .xlsx 和 .xls 格式",
  "product.import.download-template": "下载模板",
  "product.validation.barcode-min": "至少需要 10 个字符 ({count}/10)",
  "product.placeholder.select-category": "选择或创建类别...",
  "product.image.change": "更改图片",
  "product.image.select": "选择图片",
  "product.confirm.delete": "您确定要删除选定的产品吗？",
  "category.confirm.delete": "您确定要删除此类别吗？",
  "category.confirm.delete-all": "您确定要删除选定的类别吗？",
  "product.confirm.delete-category": "您确定要删除此类别吗？",
  "product.confirm.apply-master":
    "您确定要将这些值应用于所有变体吗？这将覆盖单独输入的值。",
  "product.error.invalid-data": "无效数据",
  "product.error.name-required": "产品名称是必填项",
  "product.error.category-required": "产品类别是必填项",
  "product.error.price-required": "销售价格是必填项",
  "product.error.variant-required": "请输入所有变体的价格和数量",
  "product.error.select-size": "创建前请至少选择一个尺寸。",

  /* Backend API validation messages */
  "product.api.error.price-invalid": "商品价格无效（必须 >= 0）",
  "product.api.error.promo-price-invalid": "促销价格无效（必须 >= 0）",
  "product.api.error.barcode-invalid": "条形码无效（需要8-13位数字）",
  "product.api.error.sku-duplicate": "该SKU已存在于系统中",
  "product.api.error.category-not-found": "商品分类不存在",
  "product.api.error.duplicate": "该商品已存在于系统中",
  "product.api.error.limit-reached": "已达到商品数量上限，请升级套餐以创建更多！",
  "product.api.error.not-found": "未找到商品或无访问权限",
  "product.api.error.variant-price-invalid": "变体价格无效（必须 >= 0）",
  "product.api.error.variant-promo-invalid": "变体促销价格无效（必须 >= 0）",
  "product.api.error.import-missing-fields": "商品缺少名称或分类",

  /* Product OCR */
  "product.ocr.title": "从图片提取商品",
  "product.ocr.description": "上传菜单/价目表图片，AI自动识别商品。",
  "product.ocr.prompt-placeholder": "留空 = 按业务类型自动识别",
  "product.ocr.choose-images": "选择图片",
  "product.ocr.more-images": "张其他图片",
  "product.ocr.show-prompt": "自定义AI提示",
  "product.ocr.hide-prompt": "隐藏自定义提示",
  "product.ocr.extract-btn": "提取数据",
  "product.ocr.extracting": "处理中...",
  "product.ocr.save-btn": "保存",
  "product.ocr.saving": "保存中...",
  "product.ocr.save-success": "商品导入成功！",
  "product.ocr.items": "个商品",
  "product.ocr.col-name": "商品名称",
  "product.ocr.col-category": "分类",
  "product.ocr.col-size": "规格",
  "product.ocr.col-price": "售价",
  "product.ocr.col-price-sale": "促销价",
  "product.ocr.col-barcode": "条形码",
  "product.ocr.step-upload": "上传图片",
  "product.ocr.step-mapping": "匹配列",
  "product.ocr.step-preview": "预览保存",
  "product.ocr.mapping-title": "匹配数据列",
  "product.ocr.mapping-desc": "AI已识别左侧的列。请将它们匹配到右侧对应的商品字段。",
  "product.ocr.ai-column": "AI列",
  "product.ocr.db-field": "数据字段",
  "product.ocr.status": "状态",
  "product.ocr.skip-column": "-- 跳过 --",
  "product.ocr.mapped": "已匹配",
  "product.ocr.rows-found": "行数据",
  "product.ocr.cols-mapped": "列已匹配",
  "product.ocr.back": "返回",
  "product.ocr.next": "继续",
  "product.ocr.reset": "重置",
  "product.ocr.preview-title": "预览 & 保存",
  "product.ocr.stat-products": "商品",
  "product.ocr.stat-categories": "分类",
  "product.ocr.stat-with-price": "有价格",
  "product.ocr.import-done": "完成！",
  "product.ocr.created": "新建",
  "product.ocr.updated": "更新",
  "product.ocr.skipped": "跳过",
  "product.ocr.raw-result": "AI原始结果：",
  "product.ocr.error-no-image": "请至少选择一张图片。",
  "product.ocr.error-no-data": "无法从图片提取数据，请重试。",
  "product.ocr.error-extract": "分析图片时出错。",
  "product.ocr.error-empty": "没有数据可保存。",
  "product.ocr.error-save": "发生错误，请重试。",
  "product.ocr.error-name-required": "必须匹配「商品名称」列才能继续。",

  "pages.add-new": "新增",
  "pages.add-new-user-staff": "新增员工",
  "pages.add-new-log": "再添加一个",
  "pages.order-new": "订购",
  "pages.image": "产品图片",
  "pages.add-new-modal-title": "添加产品",
  "pages.order-new-modal-title": "订购新产品",
  "pages.update-modal-title": "更新产品",
  "pages.display-options": "显示选项",
  "pages.orderby": "排序：",
  "pages.product-name": "产品名称",
  "pages.product-barcode": "条形码",
  "pages.product-sku": "产品代码",
  "pages.category": "产品类型",
  "pages.description": "描述",
  "pages.status": "状态",
  "pages.cancel": "取消",
  "pages.submit": "提交",
  "pages.delete": "删除",
  "pages.delete-forever": "永久删除",
  "pages.another-action": "其他操作",
  "pages.update": "更新",
  "pages.price": "价格",
  "pages.select-category": "选择 1 个产品类型",
  "pages.select-product": "选择 1 个产品",
  "pages.order-number": "重量",
  "pages.no-selected": "无操作",
  "pages.order-more": "添加产品",
  "pages.total-order-price": "总价",
  "pages.current-order-price": "当前订单价格",
  "pages.error-title": "糟糕... 出错了！",
  "pages.error-code": "错误",
  "pages.go-back-home": "返回首页",
  "pages.softhide": "软隐藏产品",
  "pages.un-softhide": "取消软隐藏产品",
  "pages.bestter": "推荐使用",
  "pages.un-bestter": "关闭 - 推荐使用",
  "pages.print-tem": "打印标签",
  "pages.expand": "查看变体",
  "pages.collapse": "收起",
  "product.title": "产品信息",
  "product.price.original": "价格",
  "product.price.sale": "促销价格",
  "product.price.cost": "成本价",
  "product.quantity": "数量",
  "product.inventory": "库存",
  "product.ice": "冰量",
  "product.sugar": "甜度",
  "product.size": "尺寸",
  "product.topping": "配料",
  "product.color": "颜色",
  "product.material": "材料",
  "product.add.name": "名称",
  "product.add.value": "额外金额",
  "product.add_price": "额外价格",
  "product.update_cost": "更新成本",
  "product.edit_cost": "编辑成本",
  "product.search": "搜索产品名称",
  "product.variants": "变体",
  "product.variant-name": "变体名称",
  "product.sku": "SKU",
  "product.price": "售价",
  "product.stock": "库存",
  "product.promo-time": "促销时间",

  /* 07.Category */
  "category.add-new-modal-title": "添加产品类型",
  "category.update-title": "更新产品类别",
  "category.title": "产品名称",
  "category.thumb-list": "产品类型",
  "category.nav-tab": "类别",
  "category.add-new-category": "添加类别",
  "category.btn-add": "添加类别",

  /* 08.Todo */
  "todo.add-new": "新增",
  "todo.thumb-list": "事件",
  "todo.add-new-modal-title": "新增事件",
  "todo.update-modal-title": "更新事件",
  "todo.title": "事件标题",
  "todo.description": "描述",
  "todo.date": "日期",
  "todo.time": "时间",
  "todo.update-done": "完成",
  "todo.update-pending": "待处理",
  "todo.delete": "删除",
  "todo.no-selected": "无操作",
  "todo.update": "更新",
  "todo.date-time": "时间",
  "todo.orderby": "排序：",
  "todo.btn-add": "添加事件",

  /*table setting */
  "table-setting.row": "行",
  "table-setting.col": "列",
  "table-setting.floor": "区域",
  "table-setting.btn-generate": "生成桌位",
  "table-setting.map": "地图",
  "table-setting.btn-save": "保存",
  "table-setting.title": "设置桌椅模型",

  /* stock */
  "stock.thumb-list": "库存",
  "stock.add-new-modal-title": "添加库存",
  "stock.name": "库存名称",
  "stock.unit": "单位",
  "stock.unit-price": "采购价格",
  "stock.unit-price-update": "采购价格",
  "stock.unit-price-new": "新采购价格",
  "stock.price": "入款",
  "stock.count": "数量",
  "stock.count-new": "数量",
  "stock.delete": "删除库存",
  "stock.reset": "重置为 0",
  "stock.count-update": "更新库存",
  "stock.count-edit": "编辑库存",
  "stock.count-current": "剩余",
  "stock.count-total": "总入库",
  "stock.update-title": "更新更多库存",
  "stock.search": "搜索库存名称",
  "stock.btn-add": "添加库存",

  /* warehouse */
  "warehouse.add-new-modal-title": "新增",
  "warehouse.phone": "电话",
  "warehouse.address": "地址",
  "warehouse.code": "库存代码",
  "warehouse.unit": "单位",
  "warehouse.description": "描述",
  "warehouse.btn-add": "添加",

  "warehouse.import-search": "搜索入库单名称",
  "warehouse.import": "入库单",
  "warehouse.import-stock": "入库项目",
  "warehouse.import-title": "更新入库单",
  "warehouse.import-name": "入库人姓名",
  "warehouse.import-quantity": "数量",
  "warehouse.import-price": "入库价格",
  "warehouse.btn-add-import": "创建",

  "warehouse.export-search": "搜索出库单名称",
  "warehouse.export": "出库单",
  "warehouse.export-stock": "出库项目",
  "warehouse.export-title": "更新出库单",
  "warehouse.export-name": "出库人姓名",
  "warehouse.export-quantity": "数量",
  "warehouse.export-price": "出库价格",
  "warehouse.btn-add-export": "创建",

  "warehouse.transfer-search": "搜索调拨单名称",
  "warehouse.transfer": "调拨单",
  "warehouse.transfer-stock": "调拨项目",
  "warehouse.transfer-title": "更新调拨单",
  "warehouse.transfer-name": "调拨人姓名",
  "warehouse.transfer-quantity": "数量",
  "warehouse.transfer-price": "调拨价格",
  "warehouse.transfer-name-carrier": "承运人姓名",
  "warehouse.transfer-phone-carrier": "承运人电话",
  "warehouse.transfer-receiving-warehouse": "移至仓库",
  "warehouse.transportation": "运输方式",
  "warehouse.cost-transfer": "运输费用",
  "warehouse.btn-add-transfer": "创建",

  /* make product */
  "make-product.thumb-list": "配方",
  "make-product.add-new-modal-title": "添加新配方",
  "make-product.name": "名称",
  "make-product.unit": "单位",
  "make-product.count": "数量",
  "make-product.make-more": "添加",
  "make-product.product-name": "产品名称",
  "make-product.stock-name": "库存名称",
  "make-product.select-stock": "选择 1 个库存",
  "make-product.add-modal-title": "新增",
  "make-product.update-modal-title": "编辑",
  "make-product.number-product-used": "使用的库存数量",
  "make-product.price": "价格",
  "make-product.cost": "成本价",
  "make-product.percent-cost": "成本/售价百分比",
  "make-product.btn-add": "创建",

  /* FAQ */
  "faq.title": "指南",
  "faq.text-title": "问题",
  "faq.text-content": "回答",
  "faq.modal-title": "问答",

  /** Ref */
  "ref.name": "所有者姓名",
  "ref.companyName": "店铺名称",
  "ref.email": "电子邮件",
  "ref.phone": "电话",
  "ref.address": "地址",
  "ref.content": "消息",
  "ref.title": "推荐人信息",
  "ref.sub-title":
    "您的推荐佣金目前为与 VMASS 签订的推荐合同金额的 30%。您的信息将根据您提供的个人信息自动发送给 VMASS。",
  "ref.btn-submit": "发送",

  /** Chat */
  "chat.messages": "消息",
  "chat.messages-inbox": "收件箱",
  "chat.messages-new": "通讯录",
  "chat.start-conversation": "开始对话！",

  /** Discount */
  "discount.add-new-modal-title": "添加折扣",
  "discount.note": "备注",
  "discount.type": "折扣类型",
  "discount.value": "折扣值",
  "discount.user": "员工",
  "discount.products": "产品",
  "discount.select-all-products": "所有产品",
  "discount.select-one-type": "选择数值类型",
  "discount.select-one-product": "选择 1 个产品",
  "discount.select-one-type-product": "选择 1 个产品类型",
  "discount.to-bill": "再添加一个",
  "discount.add-feetax": "添加折扣、税、费用",
  "discount.discount": "折扣",
  "discount.tax": "税",
  "discount.fee-other": "其他费用",
  "order.adjustment.add-products-first": "输入代码前请先添加商品",
  "order.adjustment.invalid-code": "促销代码无效",
  "order.adjustment.apply": "应用",
  "order.adjustment.note-optional": "备注（可选）",
  "order.adjustment.promo-code": "促销代码",
  "order.adjustment.promo-placeholder": "输入促销代码",
  "order.adjustment.coupon-help": "输入代码并点击应用以获得折扣。",
  "order.adjustment.remove-code": "移除促销代码",
  "order.adjustment.discount-value": "折扣值",
  "order.adjustment.estimated-discount": "预计折扣",
  "order.adjustment.discount-note-placeholder": "例如：忠实客户",
  "order.adjustment.subtotal": "小计",
  "order.adjustment.total-after-discount": "折后总计",
  "order.adjustment.tax-title": "添加税费",
  "order.adjustment.tax-rate": "税率",
  "order.adjustment.other": "其他",
  "order.adjustment.tax-value": "税值",
  "order.adjustment.estimated-tax": "预计税额",
  "order.adjustment.calculation": "计算方式",
  "order.adjustment.tax-added": "添加到订单",
  "order.adjustment.tax-added-help": "税费将添加到付款总额。",
  "order.adjustment.tax-included": "已含税",
  "order.adjustment.tax-included-help": "税费已包含在商品或服务价格中。",
  "order.adjustment.tax-note-placeholder": "例如：零售增值税",
  "order.adjustment.total-payment": "付款总额",
  "order.adjustment.fee-title": "添加附加费",
  "order.adjustment.fee-name": "附加费名称",
  "order.adjustment.shipping-fee": "运费",
  "order.adjustment.service-fee": "服务费",
  "order.adjustment.packing-fee": "包装费",
  "order.adjustment.other-fee": "其他费用",
  "order.adjustment.fee-value": "附加费金额",
  "order.adjustment.estimated-fee": "预计附加费",
  "order.adjustment.apply-on": "应用于",
  "order.adjustment.calculation-base": "附加费计算基数",
  "order.adjustment.fixed-fee-base-help":
    "固定VND附加费不取决于计算基数。",
  "order.adjustment.after-discount": "折后总计",
  "order.adjustment.fee-note-placeholder": "例如：市内配送",

  /** Customer */
  "customer.add-new-modal-title": "新增",
  "customer.title": "信息",
  "customer.name": "姓名",
  "customer.phone": "电话",
  "customer.email": "电子邮件",
  "customer.address": "地址",
  "customer.point": "积分",
  "customer.armorial": "徽章",
  "customer.used-item": "使用次数",
  "customer.tags": "标签",
  "customer.info": "信息",
  "customer.used": "已购产品",
  "customer.setting": "设置",
  "customer.search": "按电话查找",
  "customer.btn-add": "创建",
  "customer.amount-spent": "消费金额",
  "customer.debt": "债务",

  /** Income, Outcome, Treasury */
  action: "操作",
  name: "名称",
  phone: "电话",
  email: "电子邮件",
  address: "地址",
  price: "价格",
  note: "描述",
  time: "统计",
  "time-created": "创建时间",
  "user.created": "创建用户",
  "select-one-time": "选择一种类型",
  "select-one-time-discount": "选择 1 种折扣类型",
  "select-one-time-gift": "选择 1 种赠品类型",

  "income.title": "收入",
  "income.sub_title": "标题",
  "income.add-new-modal-title": "添加新收入",
  "income.name": "提交人姓名",
  "income.search": "按收入名称搜索",
  "income.btn-add": "创建",

  "outcome.title": "支出",
  "outcome.sub_title": "标题",
  "outcome.add-new-modal-title": "添加新支出",
  "outcome.name": "接收人姓名",
  "outcome.search": "按支出名称搜索",
  "outcome.btn-add": "创建",

  "treasury.name": "金库名称",
  "treasury.title": "金库",
  "treasury.add-new-modal-title": "添加新金库",
  "treasury.timeCreated": "创建时间",
  "treasury.search": "按金库名称搜索",
  "treasury.btn-add": "创建",

  /** Break Event */
  "breakeven.title": "盈亏平衡点",

  /** Company Provider */
  "company-provider.info": "信息",
  "company-provider.title": "供应商",
  "company-provider.title-log": "添加交易",
  "company-provider.title-log-add": "添加交易",
  "company-provider.title-log-add-more": "追加付款",
  "company-provider.add-new-modal-title": "添加新供应商",
  "company-provider.name": "名称",
  "company-provider.item_name": "项目",
  "company-provider.total_price_income": "总入库金额",
  "company-provider.total_price_outcome": "已付",
  "company-provider.total_price_pending": "剩余",
  "company-provider.item_product": "供应项目",
  "company-provider.price": "价格",
  // 'company-provider.name': 'Name of supplier',
  "company-provider.search": "按供应商名称搜索",
  "company-provider.btn-add": "创建",
  "company-provider.transaction": "交易",
  "company-provider.sku": "SKU",
  "company-provider.price_new": "价格",
  "company-provider.quantity": "数量",
  "company-provider.debt": "债务",
  "company-provider.total": "总计",
  "company-provider.time": "时间",
  "company-provider.action": "操作",

  /** User Staff */
  "user-staff.title": "员工信息",
  "user-staff.add-new-modal-title": "新增",
  "user-staff.add-new-logs-modal-title": "再添加一个",
  // 'user-staff.title': 'Staff',
  "user-staff.permission_name": "职位",
  "user-staff.date_join": "入职日期",
  "user-staff.date_get_salary": "发薪日",
  "user-staff.hour_working_on_day": "每日工作时长",
  "user-staff.status_working": "工作状态",
  "user-staff.salary_by": "薪资计算方式",
  "user-staff.salary_value": "工资",
  "user-staff.working_hours": "工作时间",
  "user-staff.current_commission": "佣金",
  "user-staff.current_bonus": "奖金",
  "user-staff.current_overtime": "加班费",
  "user-staff.current_advence": "预支",
  "user-staff.current_fined": "罚款",
  "user-staff.current_dayoff": "休假工资",
  "user-staff.current_day_working": "本月工作日",
  "user-staff.current_salary": "本月工资",
  "user-staff.total_salary": "总薪资",
  "user-staff.total_day_working": "总工作日",
  "user-staff.working_hours_from": "* 上班时间",
  "user-staff.working_hours_to": "* 下班时间",
  "user-staff.logs_users_staff": "姓名",
  "user-staff.logs_type": "类型",
  "user-staff.logs_value_salary": "金额",
  "user-staff.logs_value_hour": "小时",
  "user-staff.overtime_coefficient": "加班系数",
  "user-staff.select-all-users": "选择员工",
  "user-staff.select-one": "选择 1 种类型",
  "user-staff.name": "姓名",
  "user-staff.phone": "电话",
  "user-staff.address": "地址",
  "user-staff.email": "电子邮件",
  "user-staff.search": "按员工姓名搜索",
  "user-staff.btn-add": "创建",
  "user-staff.add-log-title": "添加员工薪资信息",
  "user-staff.kpi.total": "员工总数",
  "user-staff.kpi.active": "在职",
  "user-staff.kpi.inactive": "离职",
  "user-staff.kpi.manager": "管理者",
  "user-staff.kpi.revenue-today": "今日收入",
  "user-staff.kpi.current": "当前数据",
  "user-staff.kpi.current-page": "当前页",
  "user-staff.kpi.today": "今天",
  "user-staff.search-placeholder": "搜索员工...",
  "user-staff.filter.position-all": "职位：全部",
  "user-staff.filter.status-all": "状态：全部",
  "user-staff.filter.shift-all": "班次：全部",
  "user-staff.filter.clear": "筛选",
  "user-staff.table.employee": "员工",
  "user-staff.table.position": "职位",
  "user-staff.table.shift": "班次",
  "user-staff.table.phone": "电话",
  "user-staff.table.revenue-today": "今日收入",
  "user-staff.table.bills": "账单",
  "user-staff.table.status": "状态",
  "user-staff.table.action": "操作",
  "user-staff.action.call": "呼叫",
  "user-staff.action.message": "消息",
  "user-staff.action.edit": "编辑",
  "user-staff.action.more": "更多",
  "user-staff.action.delete": "删除",
  "user-staff.empty": "暂无员工数据",
  "user-staff.detail.empty": "选择员工查看详情",
  "user-staff.detail.tab.info": "信息",
  "user-staff.detail.tab.schedule": "排班",
  "user-staff.detail.tab.performance": "绩效",
  "user-staff.detail.tab.salary": "薪资",
  "user-staff.detail.tab.permission": "权限",
  "user-staff.detail.basic": "基本信息",
  "user-staff.detail.staff-code": "员工编号",
  "user-staff.detail.birthday": "生日",
  "user-staff.detail.schedule": "排班",
  "user-staff.detail.performance": "今日绩效",
  "user-staff.detail.salary": "薪资",
  "user-staff.detail.permission": "权限",
  "user-staff.detail.dynamic-fields": "自定义字段",
  "user-staff.today.revenue": "收入",
  "user-staff.today.bills": "账单数",
  "user-staff.today.products": "服务商品",
  "user-staff.today.revenue-per-hour": "收入/小时",
  "user-staff.total.revenue": "总收入",

  /** Role */
  "role.name": "权限名称",
  "role.title": "权限分散",
  "role.add-new-modal-title": "新增",
  "role.btn-add": "创建",

  /** User Role */
  "user-role.title": "编辑权限",
  "user-role.name": "员工姓名",
  "user-role.add-new-modal-title": "新增",
  "user-role.select-one": "选择权限",
  "user-role.place-holder-password": "如不更改请留空",
  "user-role.btn-add": "创建",

  /** Form Dynamic */
  "form-dynamic.title": "自定义表单",
  "form-dynamic.add-new-modal-title": "新增",
  "form-dynamic.label": "标题",
  "form-dynamic.alias": "表单类型",
  "form-dynamic.select-one-alias": "选择 1 个表单",
  "form-dynamic.type": "数据类型",
  "form-dynamic.select-one-type": "选择 1 种类型",
  "form-dynamic.btn-add": "创建",

  "url.placeholder": "http:// 或 https://",

  /** Compananies */
  "companies.find-company-uuid": "查找店铺代码",
  "companies.title": "关联店铺",
  "companies.add-new-modal-title": "新增",
  "companies.name": "名称",
  "companies.type": "类型",
  "companies.unset": "取消关联",
  "companies.btn-add": "创建",

  /** Promotion */
  "promotion.thumb-list": "促销",
  "promotion-add": "新增",
  "promotion-update": "更新",
  "promotion-name": "促销名称",
  "promotion-code": "代码",
  "promotion-quantity": "适用数量",
  "promotion-description": "描述",
  "promotion-max-per-customer": "每位客户最大使用量",
  "promotion-date_start": "开始时间",
  "promotion-date_end": "结束时间",
  "promotion-isAutoUse": "自动启用",

  /** Calendar */
  "calendar.add-event": "添加事件",

  /** Booking */
  "menu.booking": "预订",
  "booking.title": "预订管理",
  "booking.add-new": "添加预订",
  "booking.today": "今天",
  "booking.week": "本周",
  "booking.month": "本月",
  "booking.calendar": "日历",
  "booking.settings": "设置",
  "booking.customer-name": "客户姓名",
  "booking.customer-phone": "电话",
  "booking.customer-email": "电子邮件",
  "booking.date": "预订日期",
  "booking.time": "到达时间",
  "booking.party-size": "人数",
  "booking.table": "桌位",
  "booking.special-requests": "特殊要求",
  "booking.notes": "备注",
  "booking.status": "状态",
  "booking.status.pending": "待处理",
  "booking.status.confirmed": "已确认",
  "booking.status.cancelled": "已取消",
  "booking.status.completed": "已完成",
  "booking.status.no_show": "未到场",
  "booking.deposit": "押金",
  "booking.deposit-required": "需要押金",
  "booking.deposit-amount": "押金金额",
  "booking.confirm": "确认",
  "booking.cancel": "取消",
  "booking.complete": "完成",
  "booking.source": "来源",
  "booking.no-bookings": "暂无预订",

  /** Wizard */
  "wizard.title": "设置向导",
  "wizard.sub-title": "设置向导将指导您完成一些步骤，以便您的店铺快速运行。",
  "wizard.next": "下一步",
  "wizard.prev": "上一步",
  "wizard.finish": "完成",
  "wizard.skip": "跳过",
  "wizard.step-name-1": "第 1 步",
  "wizard.step-desc-1": "基本信息",
  "wizard.step-name-2": "第 2 步",
  "wizard.step-desc-2": "添加产品",
  "wizard.step-name-3": "第 3 步",
  "wizard.step-desc-3": "支付信息",
  "wizard.content-thanks": "谢谢！",
  "wizard.registered": "您的信息已被记录，祝您使用愉快！",

  /* Facebook Settings */
  "facebook.settings-title": "Facebook 粉丝页",
  "facebook.config-guide": "Webhook 配置（开发者）：",
  "facebook.callback-url": "回调 URL：",
  "facebook.verify-token": "验证令牌：",
  "facebook.fields": "字段：",
  "facebook.guide": "指南",
  "facebook.guide-step-1": "点击“连接新粉丝页”",
  "facebook.guide-step-2": "登录到 Facebook（如果需要）",
  "facebook.guide-step-3": "选择您要连接的粉丝页",
  "facebook.guide-step-4": "授予应用权限",
  "facebook.guide-step-5": "完成！",
  "facebook.connect-new": "连接新粉丝页",
  "facebook.description":
    "连接粉丝页以接收和回复来自 Facebook Messenger 的客户消息。",
  "facebook.how-to-connect": "如何连接粉丝页：",
  "facebook.upgrade-warning": "您需要升级到基础套餐才能连接粉丝页。",
  "facebook.upgrade-now": "立即升级",
  "facebook.connect-new-locked": "连接新粉丝页（需要基础套餐）",
  "facebook.loading": "加载中...",
  "facebook.no-pages": "尚未连接粉丝页。",
  "facebook.page-name": "页面名称",
  "facebook.page-id": "页面 ID",
  "facebook.connected-date": "连接日期",
  "facebook.action": "操作",
  "facebook.disconnect": "断开连接",
  "facebook.go-to-messenger": "前往聊天",
  "facebook.manual.btn": "手动令牌",
  "facebook.manual.title": "使用页面访问令牌连接",
  "facebook.manual.desc":
    "在下方粘贴您的页面访问令牌。您可以从 Facebook Developer Tools 或 Business Suite 获取。",
  "facebook.manual.guide": "如何获取令牌",
  "facebook.manual.guide-title": "如何获取页面访问令牌：",
  "facebook.manual.guide-step-1":
    "前往 Facebook Graph API Explorer (developers.facebook.com/tools/explorer)",
  "facebook.manual.guide-step-2": "选择您的应用和要连接的粉丝页",
  "facebook.manual.guide-step-3":
    "授予权限：pages_show_list, pages_messaging, pages_read_engagement",
  "facebook.manual.guide-step-4":
    "点击 'Generate Access Token' 并复制令牌",
  "facebook.manual.placeholder": "在此粘贴页面访问令牌...",
  "facebook.manual.connect-btn": "连接",
  "facebook.manual.connecting": "正在连接...",
  "facebook.manual.error-empty": "请输入页面访问令牌",
  "facebook.manual.error-failed": "连接失败。请检查您的令牌。",
  "facebook.manual.error-no-selection": "请至少选择1个粉丝页进行连接",
  "facebook.manual.check-btn": "检查",
  "facebook.manual.checking": "检查中...",
  "facebook.manual.select-pages": "选择要连接的粉丝页:",
  "facebook.manual.select-all": "全选",
  "facebook.manual.deselect-all": "取消全选",
  "facebook.manual.pages-selected": "页面已选择",

  /* Settings - General */
  "settings.general": "常规设置",
  "settings.general.ui-title": "界面外观",
  "settings.general.font-size-label": "字体大小",
  "settings.general.font-size-small": "小",
  "settings.general.font-size-large": "大",
  "settings.general.preview-text":
    "预览：这是一段字体大小为 {size}px 的示例文本",
  "settings.general.report-title": "报告配置",
  "settings.general.daily-report-time": "每日报告时间",
  "settings.general.select-time-placeholder": "选择时间...",
  "settings.general.report-note": "（系统将在选定时间发送收入报告电子邮件）",

  /* Settings - Invoice */
  "settings.invoice.title": "发票设置",
  "settings.invoice.section-1": "1. 客户发票设置",
  "settings.invoice.print-at-counter": "柜台点餐时打印发票",
  "settings.invoice.section-2": "2. 厨房小票设置",
  "settings.invoice.print-kitchen": "当收银员点击“送往厨房”时打印厨房小票",
  "settings.invoice.section-3": "3. 订单流程工作流",
  "settings.invoice.process-1": "下单并立即完成",
  "settings.invoice.process-2": "下单 > 厨房 > 完成",
  "settings.invoice.process-3": "下单 > 结账 > 完成",
  "settings.invoice.process-4": "下单 > 收银台 > 吧台/厨房 > 完成",
  "settings.invoice.process-4-title": "4. 二维码点餐流程",
  "settings.invoice.process-4-flow": "下单 > 送往厨房 > 待付款 > 已完成",

  /* Settings - Email */
  "settings.email.title": "电子邮件配置",
  "settings.email.guide-title": "如何创建 Gmail 应用密码：",
  "settings.email.guide-step-1": "转到 Google 帐户",
  "settings.email.guide-step-2": "安全性 → 开启两步验证",
  "settings.email.guide-step-3": "搜索“应用密码”或点击此处",
  "settings.email.guide-step-4": "选择应用：邮件，设备：其他，输入“VMASS”",
  "settings.email.guide-step-5": "复制 16 位密码",
  "settings.email.smtp-custom-title": "自定义 SMTP：",
  "settings.email.description":
    "配置自定义电子邮件，以便使用您店铺的电子邮件地址而不是 VMASS 默认地址向客户发送通知。",
  "settings.email.mode-default": "使用 VMASS 默认电子邮件",
  "settings.email.mode-custom": "使用自定义电子邮件",
  "settings.email.default-note":
    "系统将从 vmass.vn@gmail.com 发送电子邮件。禁用以配置自定义电子邮件。",
  "settings.email.type-label": "电子邮件类型",
  "settings.email.type-gmail": "Gmail（应用密码）",
  "settings.email.type-smtp": "自定义 SMTP（Zoho，Office 365...）",
  "settings.email.address-label": "电子邮件地址",
  "settings.email.password-label": "电子邮件密码",
  "settings.email.app-password-label": "应用密码",
  "settings.email.create-app-password": "在此创建应用密码",
  "settings.email.smtp-server-config": "SMTP 服务器配置",
  "settings.email.smtp-host": "SMTP 主机",
  "settings.email.smtp-port": "端口",
  "settings.email.smtp-secure": "安全性",
  "settings.email.quick-config": "快速配置：",
  "settings.email.test-button": "发送测试邮件",
  "settings.email.save-button": "保存配置",
  "settings.email.saving": "正在保存...",
  "settings.email.success": "电子邮件配置保存成功！",
  "settings.email.guide-button": "指南",

  /* Settings - Shipping */
  "settings.shipping.title": "运输设置",
  "settings.shipping.subtitle": "连接运输供应商以自动生成发货单",
  "settings.shipping.upgrade-warn":
    "您需要升级到基础套餐才能使用运输连接功能。",
  "settings.shipping.upgrade-btn": "立即升级",
  "settings.shipping.business-type-label": "您的业务类型：",
  "settings.business.cafe": "咖啡馆",
  "settings.business.restaurant": "餐厅",
  "settings.business.retail": "零售",
  "settings.business.other": "其他",
  "settings.shipping.business-fit": "以下运输供应商适合您的业务",
  "settings.shipping.connected-title": "已连接的供应商",
  "settings.shipping.edit-btn": "编辑",
  "settings.shipping.disconnect-btn": "断开连接",
  "settings.shipping.available-title": "可用供应商",
  "settings.shipping.status-connected": "已连接",
  "settings.shipping.connect-btn": "立即连接",
  "settings.shipping.guide-title": "说明",
  "settings.shipping.modal.connect-title": "连接 {name}",
  "settings.shipping.modal.token": "API 令牌",
  "settings.shipping.modal.shop-id": "店铺 ID",
  "settings.shipping.modal.client-id": "客户 ID",
  "settings.shipping.modal.secret-key": "密钥",
  "settings.shipping.modal.token-placeholder": "输入供应商提供的 API 令牌",
  "settings.shipping.modal.shop-id-placeholder": "输入店铺 ID（如果有）",
  "settings.shipping.modal.client-id-placeholder": "输入客户 ID",
  "settings.shipping.modal.secret-key-placeholder": "输入密钥",
  "settings.shipping.modal.current-token":
    "当前令牌：{token}（留空以保持不变）",
  "settings.shipping.modal.sandbox-label":
    "沙盒模式（测试） - 生产环境请取消勾选",
  "settings.shipping.modal.origin-title": "店铺发货地址",
  "settings.shipping.modal.origin-desc": "此信息用于计算准确的运费",
  "settings.shipping.modal.province": "省/市",
  "settings.shipping.modal.district": "区域",
  "settings.shipping.modal.ward": "街道/乡镇",
  "settings.shipping.modal.select-province": "选择省/市",
  "settings.shipping.modal.select-district": "选择区域",
  "settings.shipping.modal.select-ward": "选择街道/乡镇",
  "settings.shipping.modal.cancel": "取消",
  "settings.shipping.modal.connect": "连接",
  "settings.shipping.modal.connecting": "正在连接...",
  "settings.shipping.alert.missing-token": "请输入 API 令牌",
  "settings.shipping.alert.connect-success": "连接成功",
  "settings.shipping.alert.connect-error": "连接错误",
  "settings.shipping.alert.disconnect-confirm": "您确定要断开此运输供应商吗？",
  "settings.shipping.alert.disconnect-success": "断开连接成功",
  "settings.shipping.alert.disconnect-error": "断开连接错误",
  "settings.shipping.guide.ghn.step1": "转到 api.ghn.vn",
  "settings.shipping.guide.ghn.step2": "注册/登录帐户",
  "settings.shipping.guide.ghn.step3": "转到“文档”获取令牌",
  "settings.shipping.guide.ghn.step4": "在表单中输入令牌和店铺 ID",
  "settings.shipping.guide.ghtk.step1": "登录到 khachhang.giaohangtietkiem.vn",
  "settings.shipping.guide.ghtk.step2": "转到“店铺信息”或“API 管理”",
  "settings.shipping.guide.ghtk.step3": "复制 API 令牌",
  "settings.shipping.guide.viettel.step1": "登录到 partner.viettelpost.vn",
  "settings.shipping.guide.viettel.step2": "转到“帐户配置”",
  "settings.shipping.guide.viettel.step3": "复制 API 令牌",
  "settings.shipping.guide.jt.step1": "联系 J&T 注册成为合作伙伴",
  "settings.shipping.guide.jt.step2": "获取客户 ID 和密钥",
  "settings.shipping.modal.token-guide.ghn": "在 api.ghn.vn → 文档 中获取令牌",
  "settings.shipping.modal.token-guide.ghtk":
    "在 khachhang.giaohangtietkiem.vn → 店铺信息 中获取令牌",
  "settings.shipping.modal.token-guide.viettel":
    "在 partner.viettelpost.vn → 帐户配置 中获取令牌",
  "settings.shipping.modal.token-guide.jt": "联系 J&T 获取 API 帐户",

  /* Settings - Customer */
  "settings.customer.tier.bronze": "青铜",
  "settings.customer.tier.silver": "白银",
  "settings.customer.tier.gold": "黄金",
  "settings.customer.tier.diamond": "钻石",
  "settings.customer.alert.success": "设置保存成功！",
  "settings.customer.alert.error": "保存设置时出错",
  "settings.customer.alert.missing-info": "请填写所有信息",
  "settings.customer.alert.min-tiers": "必须至少有 1 个客户等级",
  "settings.customer.loading": "加载中...",
  "settings.customer.saving": "正在保存...",
  "settings.customer.point-rule": "积分积累规则",
  "settings.customer.point-value": "1 积分 =",
  "settings.customer.currency": "VND",
  "settings.customer.tier-title": "积分里程碑和客户等级",
  "settings.customer.add-tier": "添加等级",
  "settings.customer.new-tier": "新等级",
  "settings.customer.table.color": "颜色",
  "settings.customer.table.name": "等级名称",
  "settings.customer.table.points": "最低积分",
  "settings.customer.table.actions": "操作",
  "settings.customer.placeholder.name": "等级名称",
  "settings.customer.placeholder.points": "积分",
  "settings.customer.points-suffix": "积分",
  "settings.customer.note-title": "注意：",
  "settings.customer.note-content":
    "客户等级将根据累计总积分自动更新。等级按最低积分从低到高排序。",
  "settings.customer.save-btn": "保存更改",

  /* Settings - Staff */
  "settings.staff.alert.load-error": "无法加载设置",
  "settings.staff.alert.save-success": "设置保存成功！",
  "settings.staff.alert.save-error": "无法保存设置",
  "settings.staff.alert.position-exists": "此职位已存在",
  "settings.staff.shift-title": "轮班配置",
  "settings.staff.shift-desc": "设置默认轮班。点击“保存设置”以保存到系统。",
  "settings.staff.add-shift": "添加轮班",
  "settings.staff.from": "从",
  "settings.staff.to": "到",
  "settings.staff.delete": "删除",
  "settings.staff.position-title": "工作职位",
  "settings.staff.position-desc": "职位列表。点击 × 删除职位。",
  "settings.staff.add-position": "添加新职位",
  "settings.staff.position-placeholder": "输入职位名称...",
  "settings.staff.save-btn": "保存设置",
  "settings.staff.saving": "正在保存...",

  /* Settings - Partner & API */
  "settings.partner.title": "API 密钥",
  "settings.partner.doc-btn": "集成文档",
  "settings.partner.create-btn": "+ 创建 API 密钥",
  "settings.partner.alert.empty":
    "未找到 API 密钥。点击“+ 创建 API 密钥”以开始。",
  "settings.partner.alert.create-error": "请输入 API 密钥名称",
  "settings.partner.alert.create-success": "API 密钥创建成功！",
  "settings.partner.alert.create-fail": "API 密钥创建失败",
  "settings.partner.alert.revoke-title": "删除 API 密钥",
  "settings.partner.alert.revoke-confirm":
    "您确定要删除此 API 密钥吗？此操作无法撤消！",
  "settings.partner.alert.revoke-success": "API 密钥已撤销",
  "settings.partner.alert.revoke-fail": "撤销 API 密钥失败：",
  "settings.partner.alert.regenerate-title": "重新生成 API 密钥",
  "settings.partner.alert.regenerate-confirm":
    "您确定要重新生成此 API 密钥吗？旧密钥将立即失效！",
  "settings.partner.alert.regenerate-success": "API 密钥重新生成成功！",
  "settings.partner.alert.regenerate-fail": "API 密钥重新生成失败",
  "settings.partner.alert.update-fail": "API 密钥更新失败",
  "settings.partner.analytics.total": "总请求数",
  "settings.partner.analytics.today": "今天",
  "settings.partner.analytics.success-rate": "成功率",
  "settings.partner.analytics.avg-time": "平均时间",
  "settings.partner.table.name": "名称",
  "settings.partner.table.keys": "API 密钥",
  "settings.partner.table.permissions": "权限",
  "settings.partner.table.note": "备注",
  "settings.partner.table.action": "操作",
  "settings.partner.modal.create.title": "创建新 API 密钥",
  "settings.partner.modal.create.name": "API 密钥名称 *",
  "settings.partner.modal.create.name-placeholder":
    "例如：n8n 自动化，移动应用...",
  "settings.partner.modal.create.permissions": "权限",
  "settings.partner.modal.create.permissions-desc": "选择权限并点击 × 移除",
  "settings.partner.modal.create.permissions-placeholder": "选择权限...",
  "settings.partner.modal.create.env": "API 环境",
  "settings.partner.modal.create.env-test": "测试 (沙盒)",
  "settings.partner.modal.create.env-live": "实时 (生产)",
  "settings.partner.modal.create.desc": "描述",
  "settings.partner.modal.create.desc-placeholder": "描述此 API 密钥的用途...",
  "settings.partner.modal.create.cancel": "取消",
  "settings.partner.modal.create.submit": "创建 API 密钥",
  "settings.partner.modal.create.submitting": "正在创建...",
  "settings.partner.modal.result.title": "API 密钥已创建",
  "settings.partner.modal.result.important":
    "重要！立即保存此 API 密钥。它只会显示一次！",
  "settings.partner.modal.result.copy": "复制",
  "settings.partner.modal.result.copied": "✓ 已复制！",
  "settings.partner.modal.result.copy-alert": "API 密钥已复制到剪贴板！",
  "settings.partner.modal.result.expires": "过期时间：",
  "settings.partner.modal.result.close": "已保存",

  /* Partner Permissions */
  "settings.partner.perm.orders-read": "读取订单",
  "settings.partner.perm.orders-write": "写入订单",
  "settings.partner.perm.products-read": "读取产品",
  "settings.partner.perm.products-write": "写入产品",
  "settings.partner.perm.inventory-read": "读取库存",
  "settings.partner.perm.inventory-write": "写入库存",
  "settings.partner.perm.recipes-read": "读取配方",
  "settings.partner.perm.recipes-write": "写入配方",
  "settings.partner.perm.customers-read": "读取客户",
  "settings.partner.perm.customers-write": "写入客户",
  "settings.partner.perm.user-read": "读取用户信息",

  "settings.partner.env.test-desc":
    "用于 API 测试。创建的数据将标记为 is_test=true，不会影响收入报告。",
  "settings.partner.env.live-desc":
    "用于生产环境。所有数据都将记录在真实系统中并影响报告。",
  "settings.partner.env.live-label": "实时：",
  "settings.partner.create-btn-pro-auto": "+ 创建 API 密钥 (Pro Auto)",
  "settings.partner.list-title": "API 密钥列表",
  "settings.partner.pro-feature-tooltip":
    "此功能需要 Pro Auto 或更高版本的套餐",
  "settings.partner.upgrade-alert.text": "您需要升级到",
  "settings.partner.upgrade-alert.action": "套餐才能创建和管理 API 密钥。",
  "settings.partner.upgrade-alert.link": "立即升级",
  "settings.partner.modal.confirm.cancel": "取消",
  "settings.partner.modal.confirm.confirm": "确认",

  "settings.webhook.title": "Webhook 订阅",
  "settings.webhook.doc-btn": "API 文档",
  "settings.webhook.create-btn": "+ 创建 Webhook",
  "settings.webhook.create-btn-pro-auto": "+ 创建 Webhook (Pro Auto)",
  "settings.webhook.pro-feature-tooltip":
    "此功能需要 Pro Auto 或更高版本的套餐",
  "settings.webhook.upgrade-alert.text": "您需要升级到",
  "settings.webhook.upgrade-alert.action": "套餐才能使用 Webhook。",
  "settings.webhook.upgrade-alert.link": "立即升级",

  "settings.webhook.alert.empty":
    "未找到 Webhook。点击“+ 创建 Webhook”以开始接收自动通知。",
  "settings.webhook.alert.create-success": "Webhook 创建成功！",
  "settings.webhook.alert.create-error": "请检查您的信息。",
  "settings.webhook.alert.create-fail": "创建 Webhook 失败",
  "settings.webhook.alert.delete-success": "Webhook 已删除",
  "settings.webhook.alert.delete-fail": "删除 Webhook 失败",
  "settings.webhook.alert.update-fail": "更新 Webhook 失败",
  "settings.webhook.alert.rotate-confirm":
    "您确定要重新生成密钥吗？旧密钥将立即失效！",
  "settings.webhook.alert.rotate-success": "密钥重新生成成功！",
  "settings.webhook.alert.rotate-fail": "重新生成密钥失败",
  "settings.webhook.alert.delete-confirm":
    "您确定要删除此 Webhook 吗？此操作无法撤消！",

  "settings.webhook.table.url": "URL",
  "settings.webhook.table.events": "事件",
  "settings.webhook.table.status": "状态",
  "settings.webhook.table.last-triggered": "上次触发",
  "settings.webhook.table.action": "操作",
  "settings.webhook.status.active": "激活",
  "settings.webhook.status.inactive": "未激活",

  "settings.webhook.modal.create.title": "创建新 Webhook",
  "settings.webhook.modal.create.desc":
    "Webhook 允许 VMASS 在事件发生（新订单、付款等）时向您的 URL 发送自动通知。",
  "settings.webhook.modal.create.url-label": "Webhook URL *",
  "settings.webhook.modal.create.url-placeholder":
    "https://your-server.com/webhook",
  "settings.webhook.modal.create.url-help": "URL 必须是 HTTPS 并接受 POST 请求",
  "settings.webhook.modal.create.events-label": "选择事件 *",
  "settings.webhook.modal.create.events-placeholder": "选择事件...",
  "settings.webhook.modal.create.events-help": "点击 × 移除已选事件",
  "settings.webhook.modal.create.cancel": "取消",
  "settings.webhook.modal.create.submit": "创建 Webhook",
  "settings.webhook.modal.create.submitting": "正在创建...",

  "settings.webhook.modal.secret.title": "Webhook 密钥",
  "settings.webhook.modal.secret.important":
    "重要！立即保存此密钥。它只会显示一次！",
  "settings.webhook.modal.secret.label": "密钥（用于签名验证）",
  "settings.webhook.modal.secret.copy": "复制",
  "settings.webhook.modal.secret.copied": "✓ 已复制！",
  "settings.webhook.modal.secret.verify-guide": "如何验证签名：",
  "settings.webhook.modal.secret.close": "密钥已保存",

  "settings.webhook.modal.logs.title": "Webhook 投递历史",
  "settings.webhook.modal.logs.empty": "未找到日志",
  "settings.webhook.modal.logs.time": "时间",
  "settings.webhook.modal.logs.event": "事件",
  "settings.webhook.modal.logs.status": "状态",
  "settings.webhook.modal.logs.response-time": "响应时间",
  "settings.webhook.modal.logs.close": "关闭",

  "settings.webhook.modal.confirm.title": "确认",
  "settings.webhook.modal.confirm.cancel": "取消",
  "settings.webhook.modal.confirm.confirm": "确认",

  "settings.webhook.event.order.created": "新订单创建",
  "settings.webhook.event.order.paid": "订单已付款",
  "settings.webhook.event.order.shipped": "订单已发货",
  "settings.webhook.event.order.completed": "订单已完成",
  "settings.webhook.event.order.cancelled": "订单已取消",
  "settings.webhook.event.product.updated": "产品已更新",
  "settings.webhook.event.inventory.low_stock": "库存不足",
  "settings.webhook.event.inventory.expiring": "库存过期",
  "settings.webhook.event.customer.created": "新客户",
  "settings.webhook.event.payment.received": "收到付款",

  "settings.ai.title": "AI 助手集成（多智能体）",
  "settings.ai.switch.on": "已启用",
  "settings.ai.switch.off": "已禁用",
  "settings.ai.switch.desc":
    "启用后，AI 将自动回复消息，而不是标准的自动回复。",
  "settings.ai.provider.label": "主要提供商",
  "settings.ai.provider.gemini": "Google Gemini（推荐 - 免费/便宜）",
  "settings.ai.provider.openai": "OpenAI（GPT-4o - 更智能/付费）",
  "settings.ai.failover.label": "自动故障转移",
  "settings.ai.failover.desc":
    "如果主要提供商失败（配额超出，服务器错误），系统将自动切换到备用提供商。",
  "settings.ai.gemini.label": "Gemini API 密钥",
  "settings.ai.gemini.placeholder": "输入 Google Gemini API 密钥...",
  "settings.ai.gemini.help.text": "获取密钥于 ",
  "settings.ai.gemini.help.link": "Google AI Studio",
  "settings.ai.openai.label": "OpenAI API 密钥",
  "settings.ai.openai.placeholder": "输入 OpenAI API 密钥 (sk-...)...",
  "settings.ai.openai.help.text": "获取密钥于 ",
  "settings.ai.openai.help.link": "OpenAI Dashboard",
  "settings.ai.persona.label": "角色",
  "settings.ai.persona.desc":
    "定义 AI 的个性。例如：“你是一个乐于助人的支持代理，使用表情符号。”",
  "settings.ai.knowledge.label": "知识库",
  "settings.ai.knowledge.placeholder":
    "例如：\n- Wifi：CoffeeHouse / 密码：12345678\n- 营业时间：上午 7 点 - 晚上 10 点\n- 地址：123 Nguyen Van Linh...",
  "settings.ai.knowledge.desc": "AI 将使用此信息回答一般性客户问题。",
  "settings.ai.save": "保存配置",

  /* Shipping Providers */
  "settings.shipping.provider.ghn.name": "Giao Hang Nhanh (GHN)",
  "settings.shipping.provider.ghn.desc": "市区及全国快速配送",
  "settings.shipping.provider.ghtk.name": "Giao Hang Tiet Kiem (GHTK)",
  "settings.shipping.provider.ghtk.desc": "全国经济高效的配送",
  "settings.shipping.provider.viettelpost.name": "Viettel Post",
  "settings.shipping.provider.viettelpost.desc": "全国 Viettel 邮政服务",
  "settings.shipping.provider.jt.name": "J&T Express",
  "settings.shipping.provider.jt.desc": "J&T Express 配送",

  /* Quick Reply Settings */
  "settings.quickreply.title": "快速回复模板",
  "settings.quickreply.add": "添加模板",
  "settings.quickreply.empty.title": "未找到模板",
  "settings.quickreply.create-first": "创建第一个模板",
  "settings.quickreply.col.title": "标题",
  "settings.quickreply.col.content": "内容",
  "settings.quickreply.col.shortcut": "快捷方式",
  "settings.quickreply.col.category": "类别",
  "settings.quickreply.col.action": "操作",
  "settings.quickreply.modal.title-add": "添加快速回复",
  "settings.quickreply.modal.title-edit": "编辑快速回复",
  "settings.quickreply.modal.label.title": "标题 *",
  "settings.quickreply.modal.placeholder.title": "例如：谢谢",
  "settings.quickreply.modal.label.content": "内容 *",
  "settings.quickreply.modal.placeholder.content": "要发送的消息内容...",
  "settings.quickreply.modal.label.shortcut": "快捷键",
  "settings.quickreply.modal.placeholder.shortcut": "例如：/thanks",
  "settings.quickreply.modal.help.shortcut": "输入快捷键以快速查找",
  "settings.quickreply.modal.label.category": "分类",
  "settings.quickreply.cat.general": "常规",
  "settings.quickreply.cat.greeting": "问候",
  "settings.quickreply.cat.thanks": "感谢",
  "settings.quickreply.cat.faq": "常见问题",
  "settings.quickreply.cat.promotion": "促销",
  "settings.quickreply.modal.cancel": "取消",
  "settings.quickreply.modal.save": "创建",
  "settings.quickreply.modal.update": "更新",
  "settings.quickreply.notify.load-error": "无法加载模板",
  "settings.quickreply.notify.input-error": "请输入标题和内容",
  "settings.quickreply.notify.update-success": "模板已更新",
  "settings.quickreply.notify.create-success": "模板已创建",
  "settings.quickreply.notify.save-error": "无法保存模板",
  "settings.quickreply.notify.delete-confirm": "您确定要删除此模板吗？",
  "settings.quickreply.notify.delete-success": "模板已删除",
  "settings.quickreply.notify.delete-error": "无法删除模板",

  /* Auto Reply Settings */
  "settings.autoreply.title": "自动回复规则",
  "settings.autoreply.add": "添加规则",
  "settings.autoreply.empty.title": "未找到自动回复规则",
  "settings.autoreply.create-first": "创建第一个规则",
  "settings.autoreply.col.enable": "启用",
  "settings.autoreply.col.name": "规则名称",
  "settings.autoreply.col.keyword": "关键字",
  "settings.autoreply.col.response": "回复",
  "settings.autoreply.col.page": "粉丝页",
  "settings.autoreply.col.match": "匹配",
  "settings.autoreply.col.action": "操作",
  "settings.autoreply.modal.title-add": "添加自动回复规则",
  "settings.autoreply.modal.title-edit": "编辑自动回复规则",
  "settings.autoreply.modal.label.name": "规则名称 *",
  "settings.autoreply.modal.placeholder.name": "例如：欢迎新客户",
  "settings.autoreply.modal.label.page": "应用于粉丝页",
  "settings.autoreply.modal.option.all-pages": "所有粉丝页",
  "settings.autoreply.modal.label.trigger": "触发关键字",
  "settings.autoreply.modal.placeholder.trigger":
    "你好, 欢迎, 在吗 (用逗号分隔)",
  "settings.autoreply.modal.help.trigger":
    "当消息包含任何关键字时，机器人将回复",
  "settings.autoreply.modal.label.response": "回复内容 *",
  "settings.autoreply.modal.placeholder.response": "你好！感谢您联系我们...",
  "settings.autoreply.modal.label.priority": "优先级",
  "settings.autoreply.modal.help.priority":
    "数字越大 = 优先级越高（当多个规则匹配时）",
  "settings.autoreply.modal.cancel": "取消",
  "settings.autoreply.modal.save": "创建",
  "settings.autoreply.modal.update": "更新",
  "settings.autoreply.test.placeholder": "输入消息以测试自动回复...",
  "settings.autoreply.test.button": "测试",
  "settings.autoreply.test.matched": "匹配成功！",
  "settings.autoreply.test.no-match": "无匹配",
  "settings.autoreply.test.rule": "规则：",
  "settings.autoreply.test.response": "回复：",
  "settings.autoreply.notify.load-error": "无法加载规则",
  "settings.autoreply.notify.input-error": "请输入名称和回复内容",
  "settings.autoreply.notify.update-success": "规则已更新",
  "settings.autoreply.notify.create-success": "规则已创建",
  "settings.autoreply.notify.save-error": "无法保存规则",
  "settings.autoreply.notify.delete-confirm": "您确定要删除此规则吗？",
  "settings.autoreply.notify.delete-success": "规则已删除",
  "settings.autoreply.notify.delete-error": "无法删除规则",
  "settings.autoreply.notify.toggle-error": "无法切换规则状态",

  /* Upgrade Page */
  "upgrade.title": "升级账户",
  "upgrade.subtitle": "选择适合您业务需求的套餐",
  "upgrade.current-package": "当前套餐",
  "upgrade.expired": "过期",
  "upgrade.remaining-days": "剩余{days}天",
  "upgrade.lifetime": "终身",
  "upgrade.activated": "已激活",
  "upgrade.renew": "续费",
  "upgrade.downgrade": "降级",
  "upgrade.upgrade": "升级",
  "upgrade.contact": "联系",
  "upgrade.using": "正在使用",
  "upgrade.best-value": "超值",

  "upgrade.feature.billing": "收银与计费",
  "upgrade.feature.print_invoice": "发票打印",
  "upgrade.feature.accounts": "收银员、厨房和服务员账户",
  "upgrade.feature.sales": "完整的销售管理套件",
  "upgrade.feature.products": "产品管理",
  "upgrade.feature.materials": "物料管理",
  "upgrade.feature.staff": "员工管理和考勤",
  "upgrade.feature.chain": "多店管理",
  "upgrade.feature.reports": "收入和利润报告",
  "upgrade.feature.social": "社交媒体及即时通讯连接",
  "upgrade.feature.shipping": "运输连接",
  "upgrade.feature.ecommerce": "TikTok Shop / Shopee 连接",
  "upgrade.feature.einvoice": "电子发票",
  "upgrade.feature.api": "Webhook / API 集成",
  "upgrade.feature.api-limit": "API 请求限制",
  "upgrade.feature.automation": "自动化系统",
  "upgrade.feature.support": "技术支持和设置",

  "upgrade.value.products.free": "30 个产品",
  "upgrade.value.products.basic": "无限",
  "upgrade.value.materials.free": "30 种物料",
  "upgrade.value.materials.basic": "无限",
  "upgrade.value.staff.free": "2 名员工",
  "upgrade.value.unlimited": "无限",
  "upgrade.value.reports.basic": "今日报表",
  "upgrade.value.reports.detailed": "实时收入报表",
  "upgrade.value.reports.advanced": "深度利润分析报表",
  "upgrade.value.api.limit": "30,000 / 月",
  "upgrade.value.api.custom": "自定义",
  "upgrade.value.support.docs": "文档",
  "upgrade.value.support.online": "24/7 在线",
  "upgrade.value.support.priority": "优先级 1-1",

  "upgrade.package.free.title": "免费套餐",
  "upgrade.package.basic.title": "基础套餐",
  "upgrade.package.pro.title": "专业套餐",
  "upgrade.package.pro-auto.title": "专业 + 自动化",
  "upgrade.package.enterprise.title": "企业套餐",

  "upgrade.time.1m": "1 个月",
  "upgrade.time.6m": "6 个月",
  "upgrade.time.1y": "1 年",
  "upgrade.time.2y": "2 年",
  "upgrade.time.5y": "5 年",

  "upgrade.modal.payment.title": "支付信息",
  "upgrade.modal.payment.instant-title": "符合立即激活条件",
  "upgrade.modal.payment.deduct-intro":
    "总扣除值 ({amount} VND) 足以支付此套餐。",
  "upgrade.modal.payment.deduct-note": "您不需要额外支付。系统将立即激活。",
  "upgrade.modal.payment.instruction":
    "选择您要升级的时长，然后转账到下面的账户，并附上相应的金额和内容。转账后，软件将自动升级！",
  "upgrade.modal.payment.term": "时长：",
  "upgrade.modal.payment.scan-note": "扫码支付",
  "upgrade.modal.payment.owner": "账户持有人：",
  "upgrade.modal.payment.account": "账号：",
  "upgrade.modal.payment.bank": "银行：",
  "upgrade.modal.payment.amount": "金额：",
  "upgrade.modal.payment.content": "内容：",
  "upgrade.modal.payment.remaining": "(剩余余额)",
  "upgrade.modal.payment.wallet": "(钱包)",
  "upgrade.modal.payment.original-price": "原价：",
  "upgrade.modal.payment.total": "应付金额：",
  "upgrade.modal.payment.btn-instant": "确认并立即激活",
  "upgrade.modal.payment.btn-submit": "确认付款并请求升级",
  "upgrade.modal.payment.surplus-refund": "余额退还至钱包：",
  "upgrade.promo.title": "优惠码",
  "upgrade.promo.placeholder": "输入优惠码",
  "upgrade.promo.apply": "应用",
  "upgrade.promo.remove": "移除",
  "upgrade.promo.btn-create": "创建优惠码",
  "upgrade.promo.empty": "暂无优惠码",
  "upgrade.promo.modal-create": "创建优惠码",
  "upgrade.promo.modal-edit": "编辑优惠码",
  "upgrade.promo.col-code": "优惠码",
  "upgrade.promo.col-desc": "描述",
  "upgrade.promo.col-discount": "折扣",
  "upgrade.promo.col-packages": "适用套餐",
  "upgrade.promo.col-usage": "已用 / 上限",
  "upgrade.promo.col-date": "有效期",
  "upgrade.promo.col-status": "状态",
  "upgrade.promo.discount-type": "折扣类型",
  "upgrade.promo.discount-value": "值",
  "upgrade.promo.max-discount": "最大折扣额",
  "upgrade.promo.max-uses": "最大使用次数",
  "upgrade.promo.start-date": "开始日期",
  "upgrade.promo.end-date": "结束日期",
  "menu.upgrade-promo": "升级优惠码",
  "upgrade.modal.payment.manual-note":
    "扫描二维码支付。支付成功后，软件将自动升级！",

  "upgrade.modal.downgrade.title": "确认降级",
  "upgrade.modal.downgrade.intro": "系统将转换当前套餐的剩余价值：",
  "upgrade.modal.downgrade.remaining-value": "剩余价值：",
  "upgrade.modal.downgrade.equivalent": "(相当于 {days} 天)",
  "upgrade.modal.downgrade.exchange": "转换为新套餐：",
  "upgrade.modal.downgrade.refund": "退款到钱包：",
  "upgrade.modal.downgrade.warning": "注意：此操作无法撤消。新套餐将立即激活。",
  "upgrade.modal.downgrade.calculating": "计算中...",
  "upgrade.modal.downgrade.cancel": "取消",
  "upgrade.modal.downgrade.confirm": "确认降级",
  "upgrade.modal.downgrade.ineligible": "不符合条件（少于 1 个月）",

  "upgrade.modal.success.title": "升级成功！",
  "upgrade.modal.success.msg": "恭喜您升级成功！",
  "upgrade.modal.success.lifetime": "您的账户已终身升级",
  "upgrade.modal.success.new-expiry": "新过期日期：",
  "upgrade.modal.success.close": "关闭",

  "profile.fullname": "全名",
  "profile.description": "描述",
  "profile.address": "地址",
  "profile.phone": "电话",
  "profile.email": "电子邮件",
  "profile.company-name": "店铺名称",
  "profile.company-address": "店铺地址",
  "profile.company-website": "网站",
  "profile.company-start-time": "营业时间",
  "profile.company-end-time": "打烊时间",
  "profile.company-menu-hash": "在线菜单",
  "profile.bankPay": "银行",
  "profile.namePay": "账户持有人",
  "profile.numberPay": "账号",
  "profile.update-personal": "更新个人信息",
  "profile.update-company": "更新店铺信息",
  "profile.placeholder.fullname": "例如：张三",
  "profile.placeholder.description": "例如：热情的员工，热爱咖啡...",
  "profile.placeholder.address": "例如：上海市",
  "profile.placeholder.phone": "例如：13800138000",
  "profile.placeholder.email": "例如：zhangsan@gmail.com",
  "profile.placeholder.hotline": "例如：1900 1234",
  "profile.placeholder.website": "例如：vmass.vn",
  "profile.placeholder.bank": "选择银行",
  "profile.placeholder.account-name": "例如：ZHANG SAN",
  "profile.placeholder.account-number": "例如：0123456789",
  "profile.business-type.cafe": "咖啡，奶茶",
  "profile.business-type.restaurant": "餐厅，餐馆",
  "profile.business-type.retail": "杂货，零售",
  "profile.business-type.fashion": "时尚",
  "profile.business-type.cosmetics": "化妆品",
  "profile.business-type.unknown": "未知",
  "profile.business-type.label": "业务类型",
  "profile.payment-info.title": "支付信息",

  /* Affiliate List */
  "affiliate.col.name": "姓名",
  "affiliate.col.email": "电子邮件",
  "affiliate.col.phone": "电话",
  "affiliate.col.bank": "银行",
  "affiliate.col.status": "状态",
  "affiliate.col.date": "注册日期",
  "affiliate.col.action": "操作",
  "affiliate.empty": "无可用数据",
  "affiliate.status.approved": "已批准",
  "affiliate.status.pending": "待处理",
  "affiliate.status.deactivated": "已停用",

  /* Guest View & Orders */
  "guest.cart": "购物车",
  "guest.price": "单价",
  "guest.quantity": "数量",
  "guest.total": "总计",
  "guest.product": "产品",
  "guest.total-amount": "总金额",
  "guest.payment": "付款",
  "guest.call-service": "呼叫服务",
  "guest.call-service-cooldown": "{seconds}秒后再次呼叫",
  "guest.request-payment": "请求付款",
  "guest.invoice": "发票",

  /* Order Summary */
  "order.summary.discount": "折扣",
  "order.summary.tax": "税",
  "order.summary.fee": "其他费用",
  "order.summary.gift": "赠品",
  "order.summary.total-payment": "总付款",

  /* Product Management Tools */
  "product.tooltip.category":
    "此产品的父类别。例如，“咖啡”是“冰咖啡”的父类别。",
  "product.tooltip.price": "如果未选中“促销价格”，这就是销售价格。",
  "product.tooltip.topping": "添加额外项目或附加组件及其相应的额外费用。",
  "product.tooltip.ice": "勾选 5 个框以允许客户选择冰量。",
  "product.tooltip.sugar": "勾选 5 个框以允许客户选择甜度。",
  /* Recipe Builder */
  "recipe.unit.default": "个, 盒, 包...",
  "recipe.unit.cafe": "杯, 玻璃杯, 盘...",
  "recipe.unit.fashion": "件, 双, 套...",
  "recipe.unit.cosmetics": "瓶, 管, 罐...",
  "recipe.unit.retail": "个, 包, 盒, kg...",
  "recipe.unit.generic": "单位",
  "recipe.title": "配方 /以此料",
  "recipe.count-badge": "原材料",
  "recipe.empty-state": "暂无原材料。点击“添加原材料”开始。",
  "recipe.label.name": "原材料名称",
  "recipe.placeholder.select": "选择或新建...",
  "recipe.create-label": '新建 "{val}"',
  "recipe.label.usage": "使用量",
  "recipe.label.total": "小计",
  "recipe.btn.delete": "删除行",
  "recipe.btn.delete-tooltip": "删除原材料",
  "recipe.new-stock.title": "导入新库存:",
  "recipe.label.unit": "单位",
  "recipe.label.import-qty": "进货量",
  "recipe.label.cost-price": "成本价",
  "recipe.unit.per-unit": " / 单位",
  "recipe.label.paid": "已付",
  "recipe.label.provider": "供应商",
  "recipe.create-provider": '新建 "{val}"',
  "recipe.label.debt": "欠款",
  "recipe.btn.add": "添加原材料",
  "recipe.footer.total-cost": "总成本:",
  "recipe.footer.expected-profit": "预计利润:",

  "product.name": "产品名称",
  "product.price": "价格",
  "product.promotion-price": "促销价格",
  "product.price.cost": "成本价",
  "product.image": "图片",
  "label.enter-barcode": "输入条形码",
  "label.enter-product-name": "输入产品名称",
  "stock.unit": "单位",
  "label.select-or-create": "选择或创建...",
  "label.create-new": "创建新",
  "label.select-create-provider": "选择或创建供应商...",
  "unit.placeholder.default": "个, 盒, 包...",
  "unit.placeholder.cafe": "杯, 玻璃杯, 盘...",
  "unit.placeholder.fashion": "件, 双, 套...",
  "unit.placeholder.cosmetics": "瓶, 管, 罐...",
  "unit.placeholder.retail": "个, 包, 盒, kg...",
  "modal.stock.stt": "序号",
  "modal.product.unit": "配方",
  "modal.product.combo": "组合",
  "product.edit_cost": "编辑配方",
  "tooltip.enable-combo": "启用组合",
  "modal.product.variant": "变体",
  "tooltip.not-for-combo": "不适用于组合",
  "modal.stock.supplier": "供应商",
  "modal.product.paid": "已付",
  "modal.stock.remaining": "欠款",
  "modal.product.image": "图片",
  "tooltip.unit-hint": "产品单位",
  "warehouse.import-quantity": "进货量",

  "product.add-title": "添加产品",
  "product.import-excel": "从 Excel 导入",
  "product.import-image": "从图片导入",
  "product.notify.stock-success": "新库存创建成功",
  "product.sku": "SKU 代码",
  "product.barcode": "条形码",
  "product.stock-count": "库存",

  "breakeven.title": "盈亏平衡点",
  "breakeven.period.day": "天",
  "breakeven.period.month": "月",
  "breakeven.period.quarter": "季度",
  "breakeven.period.year": "年",
  "breakeven.fallback.active": "使用上一期间的估算数据或产品列表",
  "breakeven.fallback.inactive": "没有订单时启用使用估算数据",
  "breakeven.fallback.has-data": "期间内有实际数据，无需估算",
  "breakeven.fixed-costs.title": "固定成本 (VND)",
  "breakeven.fixed-costs.rent": "租金成本",
  "breakeven.fixed-costs.salary": "固定工资",
  "breakeven.fixed-costs.depreciation": "设备折旧",
  "breakeven.fixed-costs.management": "管理与营销",
  "breakeven.fixed-costs.other": "其他固定成本",
  "breakeven.product.title": "产品信息",
  "breakeven.product.price": "平均售价/单位",
  "breakeven.product.variable-cost": "平均成本价/单位",
  "breakeven.product.profit-margin": "利润率 %",
  "breakeven.product.price.tooltip.no-data": "期间内无订单，无法计算平均售价",
  "breakeven.product.variable-cost.tooltip.no-data": "此指标基于已售产品计算",
  "breakeven.product.profit-margin.tooltip.no-data":
    "需要销售价格和成本价格来计算利润率",
  "breakeven.product.profit-margin.tooltip.desc":
    "利润率 = (价格 - 成本) / 价格 × 100%",
  "breakeven.loading": "加载数据中...",
  "breakeven.empty.title": "无法计算盈亏平衡点",
  "breakeven.empty.desc": "期间内至少需要 1 个订单来确定实际利润率。",
  "breakeven.empty.sub": "将在第一个订单后出现。",
  "breakeven.result.fixed-cost": "总固定成本",
  "breakeven.result.revenue": "当前收入",
  "breakeven.result.gross-profit": "当前毛利润",
  "breakeven.result.sold-quantity": "已售数量",
  "breakeven.result.breakeven-units": "盈亏平衡销量",
  "breakeven.result.breakeven-revenue": "盈亏平衡收入",
  "breakeven.table.title": "利润分析明细表",
  "breakeven.table.volume": "销量",
  "breakeven.table.revenue": "收入",
  "breakeven.table.variable-cost": "可变成本",
  "breakeven.table.fixed-cost": "固定成本",
  "breakeven.table.total-cost": "总成本",
  "breakeven.table.profit": "利润",
  "breakeven.error.price-invalid": "平均售价必须大于 0。",
  "breakeven.error.cost-invalid": "可变成本不能为负数。",
  "breakeven.error.margin-invalid": "售价必须大于单位可变成本。",
  "breakeven.error.fetch-fail": "无法获取数据",
  "breakeven.error.connect-fail": "连接错误：",
  "breakeven.chart.title": "盈亏平衡分析图表",
  "breakeven.chart.revenue": "收入 (TR)",
  "breakeven.chart.total-cost": "总成本 (TC)",
  "breakeven.chart.fixed-cost": "固定成本 (FC)",
  "breakeven.chart.x-axis": "单位 (Q)",
  "breakeven.chart.y-axis": "价值 (VND)",
  "profile.validate.required": "请填写所有标有 * 的信息以获得最佳功能！",
  "profile.success": "成功",
  "profile.error": "发生错误，请重试。",
  "company-uuid": "UUID",

  "upgrade.notify.payment-received": "收到来自 {gateway} 的 {amount} VND 付款",
  "upgrade.notify.success": "账户升级成功！请检查过期日期。",

  /* Navigation Tabs */
  "settings.nav.general": "常规设置",
  "settings.nav.invoice": "发票设置",
  "settings.nav.social": "社交连接",
  "settings.nav.shipping": "运输连接",
  "settings.nav.staff": "员工设置",
  "settings.nav.customer": "客户设置",
  "settings.nav.ecommerce": "电子商务连接",
  "settings.nav.einvoice": "电子发票",
  "settings.nav.apikeys": "API 密钥",
  "settings.nav.webhooks": "Webhooks",
  "settings.nav.email": "电子邮件配置",
  "settings.nav.ai": "AI 助手",

  /* Notifications & Confirms */
  "settings.notification.no-data": "无可用数据",
  "settings.notification.saved": "配置已保存！",
  "settings.notification.error": "发生错误",
  "settings.social.fb.disconnect-success": "页面已断开连接！",
  "settings.social.fb.disconnect-error": "断开页面错误",
  "settings.social.fb.confirm-disconnect": "您确定要断开此页面的连接吗？",
  "settings.social.zalo.disconnect-success": "Zalo OA 已断开连接！",
  "settings.social.zalo.disconnect-error": "断开 Zalo OA 错误",
  "settings.social.zalo.confirm-disconnect":
    "您确定要断开此 Zalo OA 的连接吗？",
  "settings.ecommerce.shopee.connect-error": "连接 Shopee 错误",
  "settings.ecommerce.shop.disconnect-success": "店铺已断开连接！",
  "settings.ecommerce.shop.disconnect-error": "断开店铺错误",
  "settings.ecommerce.shop.confirm-disconnect": "您确定要断开此店铺的连接吗？",
  "settings.ecommerce.tiktok.connect-error": "连接 TikTok Shop 错误",
  "settings.ecommerce.tiktok.disconnect-success": "TikTok Shop 已断开连接！",
  "settings.ecommerce.tiktok.disconnect-error": "断开 TikTok Shop 错误",
  "settings.ecommerce.product-import-success": "产品已导入！",
  "settings.ecommerce.product-import-error": "导入产品错误",
  "settings.ecommerce.order-sync-success": "订单已同步！",
  "settings.ecommerce.order-sync-error": "同步订单错误",
  "settings.einvoice.save-success": "电子发票配置已保存！",
  "settings.einvoice.save-error": "保存电子发票配置错误",
  "settings.email.save-success": "电子邮件配置已保存！",
  "settings.email.save-error": "保存电子邮件配置错误",
  "settings.email.test-success": "测试邮件已发送！",
  "settings.email.test-error": "发送测试邮件错误",

  /* Social Settings (Zalo) */
  "settings.zalo.title": "Zalo Official Account",
  "settings.zalo.guide": "指南",
  "settings.zalo.guide.title": "如何连接 Zalo OA：",
  "settings.zalo.guide.step1": "点击“连接新 Zalo OA”",
  "settings.zalo.guide.step2": "登录 Zalo（如果需要）",
  "settings.zalo.guide.step3": "选择要连接的 OA",
  "settings.zalo.guide.step4": "授予权限",
  "settings.zalo.guide.step5": "完成！",
  "settings.zalo.desc": "连接 Zalo OA 以接收和回复来自 Zalo 的客户消息。",
  "settings.zalo.upgrade-warning": "您需要升级到基础套餐才能连接 Zalo OA。",
  "settings.zalo.upgrade-btn": "立即升级",
  "settings.zalo.connect-locked": "连接新 Zalo OA（需要基础套餐）",
  "settings.zalo.connect-btn": "连接新 Zalo OA",
  "settings.zalo.loading": "加载中...",
  "settings.zalo.no-oa": "未连接 Zalo OA。",
  "settings.zalo.table.name": "Zalo OA 名称",
  "settings.zalo.table.id": "OA ID",
  "settings.zalo.table.date": "连接日期",
  "settings.zalo.table.action": "操作",
  "settings.zalo.disconnect-btn": "断开连接",

  /* Ecommerce Settings (Shopee/TikTok) */
  "settings.ecommerce.shopee.guide": "指南",
  "settings.ecommerce.shopee.guide.title": "如何连接 Shopee：",
  "settings.ecommerce.shopee.guide.step1": "点击“连接新店铺”",
  "settings.ecommerce.shopee.guide.step2": "登录 Shopee（如果需要）",
  "settings.ecommerce.shopee.guide.step3": "选择要连接的店铺",
  "settings.ecommerce.shopee.guide.step4": "授予权限",
  "settings.ecommerce.shopee.guide.step5": "完成！",
  "settings.ecommerce.shopee.desc": "连接 Shopee 以同步订单、产品和库存。",
  "settings.ecommerce.upgrade-warning": "您需要升级到基础套餐才能连接。",
  "settings.ecommerce.connect-locked": "连接新店铺（需要基础套餐）",
  "settings.ecommerce.connect-btn": "连接新店铺",
  "settings.ecommerce.loading": "加载中...",
  "settings.ecommerce.no-shop": "未连接店铺。",
  "settings.ecommerce.table.name": "店铺名称",
  "settings.ecommerce.table.id": "店铺 ID",
  "settings.ecommerce.table.region": "地区",
  "settings.ecommerce.table.date": "连接日期",
  "settings.ecommerce.table.action": "操作",
  "settings.ecommerce.action.syncing": "正在同步...",
  "settings.ecommerce.action.import-product": "导入产品",
  "settings.ecommerce.action.sync-order": "同步订单",
  "settings.ecommerce.action.disconnect": "断开连接",
  "settings.ecommerce.tiktok.guide": "指南",
  "settings.ecommerce.tiktok.guide.title": "如何连接 TikTok Shop：",
  "settings.ecommerce.tiktok.desc": "连接 TikTok Shop 以同步订单、产品和库存。",

  /* E-Invoice Settings */
  "settings.einvoice.title": "电子发票配置",
  "settings.einvoice.upgrade-warning": "您需要升级到专业套餐才能使用电子发票。",
  "settings.einvoice.provider": "电子发票提供商",
  "settings.einvoice.vat-rate": "默认增值税率 (%)",
  "settings.einvoice.api-info": "API 凭证",
  "settings.einvoice.username": "用户名",
  "settings.einvoice.password": "密码",
  "settings.einvoice.company-info": "公司信息",
  "settings.einvoice.tax-id": "税号",
  "settings.einvoice.company-name": "公司名称",
  "settings.einvoice.address": "地址",
  "settings.einvoice.phone": "电话",
  "settings.einvoice.email": "电子邮件",
  "settings.einvoice.series": "发票系列",
  "settings.einvoice.bank-info": "银行信息（可选）",
  "settings.einvoice.bank-account": "银行账号",
  "settings.einvoice.bank-name": "银行名称",
  "settings.einvoice.save-btn": "保存配置",
  "settings.einvoice.saving": "正在保存...",
  "settings.einvoice.api-url": "API URL",
  "settings.einvoice.api-url-help": "测试环境用于测试，生产环境用于正式操作",
  "settings.einvoice.signing-method": "发票签名方式",
  "settings.einvoice.sign-type": "签名类型",
  "settings.einvoice.sign-type-help":
    "USB令牌（手动）、HSM（服务器自动）、eSign（远程CA）",
  "settings.einvoice.esign-config": "eSign高级配置",
  "settings.einvoice.esign-provider": "CA 提供商",
  "settings.einvoice.esign-username": "eSign 用户名",
  "settings.einvoice.esign-password": "eSign 密码",
  "settings.einvoice.esign-serial": "证书序列号",
  "settings.einvoice.test-connection": "测试连接",
  "settings.einvoice.testing": "测试中...",
  "settings.einvoice.test-success": "连接成功！",
  "settings.einvoice.test-fail": "无法连接到服务器",
  "settings.ai.saving-btn": "正在保存...",
  "settings.ai.notification.success": "AI 代理配置保存成功！",
  "settings.ai.notification.error": "保存配置错误",
  "settings.ai.notification.success-title": "成功",
  "settings.ai.notification.error-title": "错误",

  "facebook.go-to-messenger": "前往聊天",

  "settings.shipping.alert.connect-success": "连接成功",
  "settings.shipping.alert.connect-error": "连接错误",
  "settings.shipping.alert.disconnect-confirm": "您确定要断开此运输供应商吗？",
  "settings.shipping.alert.disconnect-success": "断开连接成功",
  "settings.shipping.alert.disconnect-error": "断开错误",

  "warehouse.transfer-search": "搜索调拨单名称",
  "warehouse.transfer": "调拨单",
  "warehouse.transfer-stock": "调拨项目",
  "warehouse.transfer-title": "更新调拨单",
  "warehouse.transfer-name": "调拨人姓名",
  "warehouse.transfer-quantity": "数量",
  "warehouse.transfer-price": "调拨价格",

  /* Inventory Audit */
  "audit.title": "库存检查和库存调整",
  "audit.button.create": "创建盘点",
  "audit.modal.detail.title": "盘点详情",
  "audit.date": "日期",
  "audit.status": "状态",
  "audit.note": "备注",
  "audit.table.stock": "物料",
  "audit.table.system": "系统",
  "audit.table.actual": "实际",
  "audit.table.discrepancy": "差异",
  "audit.table.reason": "原因",
  "audit.total-discrepancy": "总差异价值",
  "audit.button.continue": "继续盘点",
  "audit.status.completed": "已完成",
  "audit.status.pending": "进行中",

  /* Stock Return */
  "return.title": "退货给供应商",
  "return.button.create": "创建退货",
  "return.modal.detail.title": "退货详情",
  "return.date": "日期",
  "return.status": "状态",
  "return.reason": "原因",
  "return.table.stock": "物料",
  "return.table.quantity": "数量",
  "return.table.price": "价格",
  "return.table.provider": "供应商",
  "return.table.total": "总计",
  "return.total-value": "总价值",
  "return.status.completed": "已完成",
  "return.status.pending": "处理中",

  /* Stock Disposal */
  "disposal.title": "处理过期或损坏的物料",
  "disposal.button.create": "创建报废",
  "disposal.modal.detail.title": "报废详情",
  "disposal.date": "日期",
  "disposal.type": "类型",
  "disposal.status": "状态",
  "disposal.type.expired": "过期",
  "disposal.type.damaged": "损坏",
  "disposal.type.other": "其他",
  "disposal.status.completed": "已完成",
  "disposal.status.pending": "待处理",
  "disposal.status.rejected": "已拒绝",
  "disposal.table.stock": "物料",
  "disposal.table.quantity": "数量",
  "disposal.table.unit": "单位",
  "disposal.table.provider": "供应商",
  "disposal.table.refundable": "可退款",
  "disposal.table.price": "价格",
  "disposal.table.total": "总计",
  "disposal.table.reason": "原因",
  "disposal.total": "总计",
  "disposal.button.close": "关闭",
  "disposal.refundable.yes": "是",
  "disposal.refundable.no": "否",

  /* Invoice (Order) */
  "invoice.title": "发票",
  "invoice.tab.info": "常规信息",
  "invoice.tab.deleted": "已删除发票",
  "invoice.empty": "无可用数据...",
  "invoice.menu.restore": "恢复发票",
  "invoice.menu.destroy": "永久删除",
  "invoice.badge.id": "发票 ID",
  "invoice.badge.no-print": "未打印",
  "invoice.discount": "折扣",
  "invoice.tax": "税",
  "invoice.fee": "费用",
  "invoice.no-permission": "您没有权限使用此功能！",
  "invoice.confirm.destroy": "您确定要永久删除此发票吗？",
  "invoice.success.restore": "发票恢复成功",
  "invoice.error.unknown": "发生未知错误。",

  /* Home Page (Dashboard) */
  "home.wizard.title": "初始设置",
  "home.warning.add-product": "请添加您的第一个产品",
  "home.warning.update-info": "请更新店铺信息",
  "home.warning.update-payment": "请更新支付信息",
  "home.warning.dismiss-template": "您正在查看示例数据。在正式使用前请隐藏或移除示例数据",
  "home.warning.dismiss-btn": "隐藏示例数据",
  "home.warning.dismiss-confirm": "您确定要隐藏所有示例数据吗？",
  "home.warning.dismiss-success": "已成功隐藏示例数据！",
  "home.warning.here": "点击这里",
  "home.status-order": "订单状态",
  "home.btn.order-preview": "订单预览",
  "home.table.title-orders": "订购项目",
  "home.table.title-adjust": "调整订单",
  "home.btn.save-provisional": "临时保存",
  "home.btn.provisional-invoice": "草稿发票",
  "home.btn.return-order": "退货订单",

  "home.header.product": "产品名称",
  "home.header.quantity": "数量",
  "home.header.price": "价格",
  "home.header.total": "总计",
  "home.header.delete": "删除",
  "home.empty": "暂无订购项目！",
  "home.summary.total": "小计",
  "home.summary.discount": "折扣",
  "home.summary.tax": "税/费",
  "home.summary.fee-other": "其他费用",
  "home.summary.shipping": "运费",
  "home.summary.payment-total": "应付总额",
  "home.shipping.ghn": "Giao Hang Nhanh (GHN)",
  "home.shipping.ghtk": "Giao Hang Tiet Kiem (GHTK)",
  "home.shipping.viettelpost": "Viettel Post",
  "home.shipping.vnpost": "VN Post",
  "home.shipping.ahamove": "Ahamove",
  "home.shipping.lalamove": "Lalamove",
  "home.shipping.grabexpress": "GrabExpress",
  "home.shipping.shopeexpress": "Shopee Xpress",
  "home.shipping.jtexpress": "J&T Express",
  "home.shipping.ninjavan": "Ninja Van",
  "home.shipping.bestexpress": "BEST Express",
  "home.shipping.kerryexpress": "Kerry Express",
  "home.summary.customer-pay": "客户已付",
  "home.summary.refund": "找零",
  "home.summary.missing": "欠缺",
  "home.order.ice": "冰",
  "home.order.sugar": "糖",

  "home.placeholder.customer-name": "客户姓名",
  "home.placeholder.phone": "电话号码",
  "home.btn.complete-adjust": "完成调整",
  "home.tooltip.missing-amount":
    "欠缺金额将记录在“客户债务”中。请在下方输入客户姓名和电话号码。",

  "home.tooltip.done-pay": "点击“完成”即表示您确认客户已全额付款。",
  "home.tooltip.discount": "此金额将从总金额中扣除。",
  "home.tooltip.tax-fee": "此金额将添加到总金额中。",
  "home.tooltip.fee-other": "此金额将添加到总金额中。",
  "home.notify.no-products": "未订购产品。请至少添加 1 个产品。",
  "general.loading": "加载中...",
  "general.done": "完成",
  "general.not-yet": "尚未",
  "general.error.title": "错误！",
  "home.btn.close": "关闭",
  "home.btn.order": "下单 (F9)",
  "home.btn.payment": "完成付款 (F9)",
  "home.btn.print-provisional": "打印草稿 (F8)",
  "home.btn.calculating": "计算中...",

  "home.alert.call-payment": "客人呼叫付款！",
  "home.alert.call-service": "客人呼叫服务！",
  "home.alert.stock-warning": "库存不足警告",
  "home.notify.no-order-discount": "无订单可应用折扣",
  "home.notify.open-menu-print": "请打开“其他”菜单打印临时发票",
  "home.notify.no-order-print": "没有订单可打印",
  "home.notify.no-payment-btn": "未找到付款按钮",
  "home.notify.no-order-pay": "没有订单可支付",
  "home.notify.save-not-supported": "暂不支持临时保存功能",
  "home.notify.no-order-save": "没有订单可临时保存",
  "home.notify.scan-success": "扫描成功",
  "home.notify.updated": "已更新",
  "home.notify.success": "成功",
  "home.notify.update-failed": "更新失败",
  "home.notify.error": "错误",
  "home.notify.no-permission": "您没有权限使用此功能！",
  "general.setting": "设置",
  "general.error.invalid-data": "无效数据",
  "home.summary.no-info": "无信息",
  "home.summary.no-setup": "未设置",
  "home.summary.no-data": "无可用数据...",
  "home.btn.save-all": "保存所有更改",
  "home.notify.transfer-success": "换桌成功",
  "home.notify.transfer-failed": "换桌失败",
  "home.notify.save-error": "保存折扣/税/费用详情时出错",
  "home.notify.status-error": "更新订单状态时出错。",

  /* Shortcuts */
  "home.shortcut.f1": "打开指南",
  "home.shortcut.f2": "搜索产品",
  "home.shortcut.f3": "产品管理",
  "home.shortcut.f4": "折扣 / 税 / 费",
  "home.shortcut.f8": "打印草稿发票",
  "home.shortcut.f9": "下单 / 付款",
  "home.shortcut.f10": "保存草稿发票",
  "home.shortcut.title": "键盘快捷键",
  "home.shortcut.close": "按 ESC 关闭",

  /* Provisional Invoice (Drafts) */
  "home.provisional.title": "草稿发票",
  "home.provisional.empty": "暂无保存的草稿发票！",
  "home.provisional.btn-reorder": "重新下单",
  "home.provisional.btn-cancel": "取消",
  "home.provisional.counter": "柜台",

  /* Order History & Return */
  "home.history.title": "订单历史查询",
  "home.history.search": "搜索",
  "home.history.empty": "未找到所选期间的订单。",
  "home.history.loading": "加载数据中...",
  "home.history.error": "加载数据出错。请重试。",
  "home.history.invoice": "发票",
  "home.history.sku": "SKU",
  "home.history.btn-return": "退货",
  "home.history.confirm-return": "您确定要退回此商品吗？",
  "home.history.return-success": "退货及库存恢复成功。",

  /* Common Labels & Options */
  "home.label.product-name": "产品名称",
  "home.label.quantity": "数量",
  "home.label.price": "价格",
  "home.label.total": "总计",
  "home.label.delete": "删除",
  "home.label.customer-name": "客户姓名",
  "home.label.phone": "电话号码",
  "home.btn.order-now": "立即订购！",
  "home.msg.preview-detail": "预览详情",

  "home.option.payment.cash": "现金",
  "home.option.payment.transfer": "银行转账",
  "home.option.payment.card": "信用卡",
  "home.option.payment.credit": "债务",
  "home.option.shipping.select": "选择承运商",
  "home.placeholder.staff": "销售人员",
  "home.placeholder.shipping": "运输承运商",
  "home.placeholder.payment": "支付方式",

  /* Analytics */
  "analytics.tabs.overview": "概览",
  "analytics.tabs.products": "产品",
  "analytics.tabs.materials": "物料",
  "analytics.tabs.customers": "客户",
  "analytics.tabs.staff": "员工",
  "analytics.tabs.debt": "供应商",
  "analytics.tabs.payment": "付款",
  "analytics.tabs.other": "其他",

  "analytics.summary.total_products": "产品总数",
  "analytics.summary.products_with_variants": "变体产品",
  "analytics.summary.products_on_sale": "促销中",
  "analytics.summary.products_without_recipe": "无配方",
  "analytics.summary.unsold_products_count": "未售出产品",
  "analytics.summary.avg_profit_margin": "平均利润率",
  "analytics.summary.total_materials": "物料总数",
  "analytics.summary.low_stock": "低库存 (<20% | <10%)",
  "analytics.summary.unassigned_materials": "未分配物料",
  "analytics.summary.total_inventory_value": "总库存价值",
  "analytics.summary.import_value": "入库价值",
  "analytics.summary.import_count": "入库次数",
  "analytics.summary.total_new_customers": "新客户",
  "analytics.summary.total_returning_customers": "回头客",
  "analytics.summary.total_spent": "总消费",
  "analytics.summary.avg_spent_per_customer": "平均消费/客户",
  "analytics.summary.customer_debt": "客户欠款",
  "analytics.summary.return_rate": "退货率",
  "analytics.summary.total_sales": "总销售额",
  "analytics.summary.total_bills": "总账单数",
  "analytics.summary.total_items": "总项目数",
  "analytics.summary.avg_revenue_per_hour": "平均收入/小时",
  "analytics.summary.active_staff": "活跃员工",

  "analytics.table.top_selling": "热销产品",
  "analytics.table.top_slow": "滞销产品",
  "analytics.table.payment_method": "支付方式",

  "analytics.error.agency": "获取代理数据出错",
  "analytics.error.activity": "获取活动数据出错",
  "analytics.error.outcome": "获取支出数据出错",
  "analytics.error.income": "获取收入数据出错",
  "analytics.error.sold_products": "获取已售产品数据出错",
  "analytics.error.material_import": "获取入库物料数据出错",
  "analytics.error.debt": "获取债务数据出错",
  "analytics.error.material_usage": "获取物料使用数据出错",
  "analytics.error.table": "获取桌位数据出错",
  "analytics.error.payment_method": "获取支付方式数据出错",
  "analytics.error.top_products": "获取热门产品数据出错",
  "analytics.error.best_selling": "获取畅销产品数据出错",
  "analytics.error.customer": "获取客户数据出错",
  "analytics.error.staff": "获取员工数据出错",
  "analytics.error.booking": "获取预订数据出错",
  "analytics.error.materials": "获取物料数据出错",
  "analytics.dashboards.outcome": "支出",
  "analytics.dashboards.income": "收入",
  "analytics.dashboards.stock-log": "库存日志",
  "analytics.dashboards.make-product": "制作产品",
  "analytics.dashboards.order-table": "桌位统计",
  "analytics.dashboards.debt": "债务",
  "analytics.chart.income": "收入",
  "analytics.chart.outcome": "支出",
  "analytics.filter.my_store": "我的店铺",
  "analytics.filter.all": "全部",
  "analytics.filter.today": "今天",
  "analytics.upgrade.notification":
    "您当前的套餐仅允许查看今天的报告。请升级以查看历史记录！",
  "analytics.upgrade.title": "套餐限制",
  "analytics.profit": "利润",
  "analytics.imported-stock-quantity": "入库数量",
  "analytics.total-stock-value": "总库存价值",
  "analytics.pnl.title": "详细损益表",
  "analytics.pnl.revenue-header": "💰 收入",
  "analytics.pnl.sales-revenue": "销售收入",
  "analytics.pnl.gross-revenue": "总收入",
  "analytics.pnl.discount": "(-) 折扣",
  "analytics.pnl.tax": "(+) 税",
  "analytics.pnl.other-fees": "(+) 其他费用",
  "analytics.pnl.other-income": "其他收入",
  "analytics.pnl.total-revenue": "总收入",
  "analytics.pnl.cost-header": "📉 支出",
  "analytics.pnl.cogs": "销售成本 (COGS)",
  "analytics.pnl.material-cost": "物料成本",
  "analytics.pnl.gross-profit": "毛利润",
  "analytics.pnl.operating-expenses": "运营费用",
  "analytics.pnl.fixed-costs": "固定成本 (水电，人工...)",
  "analytics.pnl.gift-cost": "🎁 促销赠品成本",
  "analytics.pnl.total-expenses": "总支出",
  "analytics.pnl.net-profit": "💰 净利润",
  "analytics.pnl.net-loss": "📉 净亏损",

  "analytics.table.stt": "序号",
  "analytics.table.name": "名称",
  "analytics.table.quantity": "数量",
  "analytics.table.total": "总计",
  "analytics.table.price": "价格",
  "analytics.table.product": "产品",
  "analytics.table.sold_quantity": "已售数量",
  "analytics.table.revenue": "收入",
  "analytics.table.cogs": "成本",
  "analytics.table.profit": "利润",
  "analytics.table.ratio": "比率",
  "analytics.table.material": "物料",
  "analytics.table.stock": "库存",
  "analytics.table.total_import": "总入库",
  "analytics.table.value": "价值",
  "analytics.table.remaining": "剩余",
  "analytics.table.gift": "赠品",
  "analytics.table.discount": "折扣",
  "analytics.table.method": "方式",
  "analytics.table.order_count": "订单数",
  "analytics.table.product_count": "产品数",
  "analytics.table.total_amount": "总金额",
  "analytics.table.stock_status.critical": "严重",
  "analytics.table.stock_status.warning": "警告",
  "analytics.table.stock_status.normal": "正常",
  "analytics.table.unit_price": "单价",

  "analytics.staff.rank": "排名",
  "analytics.staff.name": "员工",
  "analytics.staff.position": "职位",
  "analytics.staff.sales": "销售额",
  "analytics.staff.bill_count": "订单数",
  "analytics.staff.product_count": "产品数",
  "analytics.staff.revenue_per_hour": "时薪",
  "analytics.staff.commission": "佣金",
  "analytics.staff.bonus": "奖金",
  "analytics.staff.overtime": "加班 (小时)",
  "analytics.staff.advance": "预支",
  "analytics.staff.fined": "罚款",
  "analytics.staff.no_data": "无员工数据",
  "analytics.staff.top": "🏆 榜首",

  "analytics.booking.title": "预订统计",
  "analytics.booking.summary.total": "总预订",
  "analytics.booking.summary.pending": "待处理",
  "analytics.booking.summary.confirmed": "已确认",
  "analytics.booking.summary.completed": "已完成",
  "analytics.booking.summary.cancelled": "已取消",
  "analytics.booking.summary.guests": "总客人数",
  "analytics.booking.source.phone": "电话",
  "analytics.booking.source.walk_in": "直接到店",
  "analytics.booking.source.website": "网站",
  "analytics.booking.source.app": "App",
  "analytics.booking.source.facebook": "Facebook",
  "analytics.booking.source.zalo": "Zalo",
  "analytics.booking.table.stt": "#",
  "analytics.booking.table.date": "日期",
  "analytics.booking.table.time": "时间",
  "analytics.booking.table.customer": "客户",
  "analytics.booking.table.phone": "电话",
  "analytics.booking.table.party_size": "人数",
  "analytics.booking.table.status": "状态",
  "analytics.booking.table.source": "来源",
  "analytics.booking.table.no_data": "无预订数据",

  "analytics.customer.name": "客户",
  "analytics.customer.phone": "电话",
  "analytics.customer.order_count": "订单数",
  "analytics.customer.products_purchased": "已购产品",
  "analytics.customer.total_spent": "总消费",
  "analytics.customer.point": "积分",
  "analytics.customer.debt": "债务",
  "analytics.customer.created_at": "创建时间",
  "analytics.customer.no_data": "无数据",

  "chat.permission_denied": "您没有权限使用此功能！",
  "chat.internal_msg": "常规消息",
  "chat.search_placeholder": "搜索",
  "chat.max_files_error": "最多允许 3 个文件",
  "chat.no_file_guest_error": "不支持向访客发送文件",
  "chat.file_size_error": "文件最大 100 MB",

  "chat.facebook.messenger": "Messenger",
  "chat.facebook.syncing": "正在从 Facebook 同步消息...",
  "chat.facebook.synced_success": "已同步 {count} 个对话",
  "chat.facebook.sync_failed": "同步失败",
  "chat.facebook.sync_error": "同步消息出错",
  "chat.facebook.all_pages": "所有页面",
  "chat.facebook.customer": "客户",
  "chat.facebook.no_messages": "暂无消息",
  "chat.facebook.outside_24h": "超出24小时 - 选择消息标签发送：",
  "chat.facebook.select_tag": "-- 选择标签 --",
  "chat.facebook.tag.human_agent": "客户支持 (7天)",
  "chat.facebook.tag.post_purchase": "订单更新",
  "chat.facebook.tag.account_update": "账户更新",
  "chat.facebook.tag.event_update": "活动更新",
  "chat.facebook.send_file_error": "无法发送消息",
  "chat.facebook.sync_btn": "同步",
  "chat.facebook.processing": "处理中...",
  "chat.facebook.search_customer": "搜索客户...",
  "chat.facebook.send_error": "无法发送文件",
  "chat.facebook.token_expired_title": "⚠️ Facebook令牌已过期！无法发送/接收消息。",
  "chat.facebook.token_reconnect_btn": "重新连接Facebook",
  "fb.comment.no-posts": "未找到帖子",
  "fb.comment.no-posts-hint": "点击“同步”从粉丝专页加载",
  "fb.comment.loading-comments": "正在加载评论...",
  "fb.comment.no-comments": "未找到评论",
  "fb.comment.select-post": "选择帖子以查看评论",
  "fb.comment.post-detail": "帖子详情",
  "fb.comment.view-on-fb": "在 Facebook 上查看",
  "fb.comment.like": "点赞",
  "fb.comment.reply": "回复",
  "fb.comment.hide": "隐藏",
  "fb.comment.unhide": "取消隐藏",
  "fb.comment.hidden": "已隐藏",
  "fb.comment.reply-placeholder": "输入回复...",
  "fb.comment.edit": "编辑",
  "fb.comment.delete": "删除",
  "fb.comment.filter-all": "全部",
  "fb.comment.filter-unread": "未读",
  "fb.comment.filter-unreplied": "未回复",
  "fb.comment.status-replied": "已回复",
  "fb.comment.loading-posts": "正在加载帖子...",
  "fb.comment.no-pages-desc": "尚未连接粉丝专页。请使用访问令牌开始管理评论。",

  "topnav.search.placeholder.default": "搜索...",
  "topnav.search.placeholder.dashboard": "搜索产品...",
  "topnav.search.placeholder.product": "搜索产品...",
  "topnav.search.placeholder.stock": "搜索物料...",
  "topnav.search.placeholder.customer": "搜索客户...",
  "topnav.search.placeholder.order": "搜索订单...",
  "topnav.search.placeholder.staff": "搜索员工...",
  "topnav.search.placeholder.promotion": "搜索促销...",
  "topnav.search.placeholder.provider": "搜索供应商...",
  "topnav.search.placeholder.income": "搜索收入...",
  "topnav.search.placeholder.outcome": "搜索支出...",
  "topnav.search.placeholder.cash-flow": "搜索收入和支出...",
  "topnav.search.placeholder.treasury": "搜索资产...",
  "topnav.search.placeholder.warehouse_export": "搜索出库单...",
  "topnav.search.placeholder.warehouse_import": "搜索入库单...",
  "topnav.search.placeholder.warehouse_transfer": "搜索调拨单...",
  "topnav.search.placeholder.todo": "搜索任务...",

  "topnav.menu.account": "账户",
  "topnav.menu.cashier": "收银员",
  "topnav.menu.waiter": "服务员",
  "topnav.menu.kitchen": "厨房 / 吧台",
  "topnav.menu.settings": "设置",
  "topnav.menu.logout": "登出",

  "topnav.noti.todo.message": "立即查看'待办事项'",
  "topnav.noti.todo.title": "提醒",
  "topnav.noti.order.message": "新产品订单。立即查看！",
  "topnav.noti.stock_down.message": "物料库存不足！",
  "topnav.noti.stock_down.title": "建议采购",

  "page.heading.excel": "Excel",
  "page.heading.add_from_image": "从图片添加产品",
  "page.heading.create_quantitative": "创建定量",
  "page.heading.add_bulk": "批量添加产品",
  "page.heading.add_quantitative_one": "创建定量",
  "page.heading.best_seller": "推荐",
  "page.heading.un_best_seller": "不推荐",
  "page.heading.mark_best_seller": "标记为推荐",
  "page.heading.soft_hide_mixed": "隐藏/显示产品",
  "page.heading.soft_hide_show": "显示产品",
  "page.heading.soft_hide_hide": "隐藏产品",
  "page.heading.print_sticker": "打印标签",
  "page.heading.import_excel_title": "从 Excel 文件导入数据",
  "page.heading.import_result": "导入结果",
  "page.heading.import_btn": "导入",
  "page.heading.error.limit": "您当前的套餐已达到产品限制。请升级以添加更多！",
  "page.heading.error.limit_title": "套餐限制",

  "product.confirm.delete": "您确定要删除这些产品吗？",
  "product.error.invalid-data": "无效数据",
  "product.error.variant-required": "变体需要价格和数量",

  "product.multi.name": "产品名称",
  "product.multi.barcode": "条形码",
  "product.multi.sku": "SKU",
  "product.multi.unit": "单位",
  "product.multi.category": "类别",
  "product.multi.hot": "热门",
  "product.multi.price": "价格",
  "product.multi.price_sale": "促销价",
  "product.multi.active_sale": "促销开启",
  "product.multi.recipe": "配方",
  "product.multi.variant": "规格",
  "product.multi.image": "图片",
  "product.multi.soft_hide": "隐藏",

  "product.variant.default": "默认属性",
  "product.variant.coming_soon": "即将推出 {date}",
  "product.variant.starts_from": "起价 {date}",
  "product.variant.name": "变体名称",
  "product.variant.sku": "SKU",
  "product.variant.price": "价格",
  "product.variant.stock": "库存",
  "product.variant.promo_time": "促销时间",
  "product.variants": "变体",

  "customer.export.stt": "序号",
  "customer.export.name": "客户姓名",
  "customer.export.phone": "电话",
  "customer.export.email": "电子邮件",
  "customer.export.address": "地址",
  "customer.export.used": "使用次数",
  "customer.export.point": "积分",
  "customer.export.armorial": "徽章",
  "customer.export.tags": "标签",
  "customer.export.debt": "债务",
  "customer.export.total_spent": "总消费",
  "customer.export.created_at": "首次使用",
  "customer.export.updated_at": "更新时间",
  "customer.export.filename": "客户列表",

  "stock.export.stt": "序号",
  "stock.export.id": "ID",
  "stock.export.name": "物料名称",
  "stock.export.sku": "SKU",
  "stock.export.unit": "单位",
  "stock.export.price_new": "入库价格",
  "stock.export.inventory": "库存",
  "stock.export.total": "总金额",
  "stock.export.created_at": "创建时间",
  "stock.export.updated_at": "更新时间",
  "stock.export.filename": "物料列表",

  "income.export.stt": "序号",
  "income.export.name": "收入名称",
  "income.export.value": "金额",
  "income.export.address": "地址",
  "income.export.note": "备注",
  "income.export.created_at": "创建时间",
  "income.export.statistic": "统计",
  "income.statistic.exclude": "排除",
  "income.statistic.include": "包含",
  "income.export.creator": "创建者",
  "income.export.filename": "收入列表",

  "outcome.export.stt": "序号",
  "outcome.export.name": "支出名称",
  "outcome.export.value": "金额",
  "outcome.export.address": "地址",
  "outcome.export.note": "备注",
  "outcome.export.created_at": "创建时间",
  "outcome.export.statistic": "统计",
  "outcome.statistic.exclude": "排除",
  "outcome.statistic.include": "包含",
  "outcome.export.creator": "创建者",
  "outcome.export.filename": "支出列表",

  "todo.export.filename": "待办事项列表",
  "page.heading.excel.tooltip": "下载数据到 Excel 文件",
  "analytics.export.name": "名称",
  "analytics.export.quantity": "数量",
  "analytics.export.total_price": "总金额",
  "analytics.export.product": "产品",
  "analytics.export.revenue": "收入",
  "analytics.export.method": "方式",
  "analytics.export.order_count": "订单数",
  "analytics.export.supplier": "供应商",
  "analytics.export.customer": "客户",
  "analytics.export.phone": "电话",
  "analytics.export.spent": "花费",
  "analytics.export.created_at": "创建时间",
  "analytics.export.material": "物料",
  "analytics.export.unit": "单位",
  "analytics.export.table": "桌号",
  "analytics.export.discount": "折扣",
  "analytics.export.stock": "库存",
  "analytics.export.min_stock": "最低库存",
  "analytics.export.date": "日期",
  "analytics.export.time": "时间",
  "analytics.export.party_size": "人数",
  "analytics.export.status": "状态",
  "analytics.export.source": "来源",
  "analytics.export.sheet.sold_products": "已售产品",
  "analytics.export.sheet.top_spenders": "高消费客户",
  "analytics.export.sheet.imported_materials": "入库物料",
  "analytics.export.sheet.used_materials": "已用物料",
  "analytics.export.sheet.booking": "预订",
  "analytics.export.success": "Excel 导出成功！",

  /* AI Configuration */
  "settings.ai.default_persona": "您是一个友好的客户支持代理。",

  /* Upgrade */
  "upgrade.price.currency": "{price} VND",
  "upgrade.feature.billing": "收银与计费",
  "upgrade.feature.print_invoice": "发票打印",
  "upgrade.feature.accounts": "员工账户",
  "upgrade.feature.sales": "销售管理",
  "upgrade.feature.products": "产品 & 库存",
  "upgrade.value.products.free": "30 个产品",
  "upgrade.value.products.basic": "无限",
  "upgrade.value.unlimited": "无限",
  "upgrade.time.1m": "1 个月",
  "upgrade.features": "功能",
  "make-product.select-or-create": "选择或创建新",
  "make-product.unit": "单位",
  "make-product.no-recipe": "此产品暂无配方！",
  "make-product.cost-price": "成本价",
  "make-product.cost-ratio": "成本 / 价格 比率",
  "general.add": "添加",

  "stock.header.material_name": "物料名称",
  "stock.header.unit": "单位",
  "stock.header.total_import": "总入库",
  "stock.header.new_quantity": "新数量",
  "stock.header.inventory": "库存",
  "stock.header.below_20": "低于 20%",
  "stock.header.below_10": "低于 10%",
  "stock.header.true": "是",
  "stock.header.false": "否",

  "income.header.name": "收入名称",
  "income.header.payer": "付款人",
  "income.header.address": "地址",
  "income.header.amount": "金额",
  "income.header.description": "描述",
  "income.header.status": "状态",
  "income.header.statistic": "统计",
  "income.header.creator": "创建者",
  "income.header.created_at": "创建时间",

  "outcome.header.name": "支出名称",
  "outcome.header.receiver": "收款人",
  "outcome.header.amount": "金额",
  "outcome.header.description": "描述",
  "outcome.header.address": "地址",
  "outcome.header.status": "状态",
  "outcome.header.statistic": "统计",
  "outcome.header.creator": "创建者",
  "outcome.header.created_at": "创建时间",

  "customer.header.name": "客户姓名",
  "customer.header.phone": "电话",
  "customer.header.email": "电子邮件",
  "customer.header.address": "地址",
  "customer.header.points": "积分",
  "customer.header.used_count": "使用次数",
  "customer.header.total_spent": "总消费",
  "customer.header.rank": "等级",
  "customer.header.debt": "债务",
  "customer.header.created_at": "首次使用",
  "customer.header.updated_at": "更新时间",

  "provider.header.name": "供应商名称",
  "provider.header.phone": "电话",
  "provider.header.email": "电子邮件",
  "provider.header.address": "地址",
  "provider.header.total_import": "总入库",
  "provider.header.paid": "已付",
  "provider.header.remaining": "剩余",

  "warehouse.transfer.header.item": "调拨项目",
  "warehouse.transfer.header.quantity": "调拨数量",
  "warehouse.transfer.header.price": "调拨价格",
  "warehouse.transfer.header.description": "描述",
  "warehouse.transfer.header.status": "状态",
  "warehouse.transfer.header.sender": "发货人",
  "warehouse.transfer.header.phone": "电话",
  "warehouse.transfer.header.carrier": "承运商",
  "warehouse.transfer.header.carrier_phone": "承运商电话",
  "warehouse.transfer.header.destination": "目标仓库",
  "warehouse.transfer.header.transport": "运输方式",
  "warehouse.transfer.header.shipping_cost": "运费",
  "warehouse.transfer.header.creator": "创建者",
  "warehouse.transfer.header.created_at": "创建时间",

  "warehouse.import.header.item": "入库项目",
  "warehouse.import.header.unit": "单位",
  "warehouse.import.header.quantity": "入库数量",
  "warehouse.import.header.price": "入库价格",
  "warehouse.import.header.status": "状态",
  "warehouse.import.header.importer": "入库人",
  "warehouse.import.header.phone": "电话",
  "warehouse.import.header.address": "地址",
  "warehouse.import.header.created_at": "创建时间",

  "warehouse.export.header.item": "出库项目",
  "warehouse.export.header.quantity": "出库数量",
  "warehouse.export.header.price": "出库价格",
  "warehouse.export.header.status": "状态",
  "warehouse.export.header.description": "描述",
  "warehouse.export.header.creator": "创建者",
  "warehouse.export.header.created_at": "创建时间",

  "treasury.header.name": "资产名称",
  "treasury.header.value": "价值",
  "treasury.header.note": "备注",
  "treasury.header.statistic": "统计",
  "treasury.header.creator": "创建者",
  "treasury.header.created_at": "创建时间",

  "modal.stock.stt": "序号",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "条形码",
  "modal.stock.supplier": "供应商",
  "modal.stock.remaining": "剩余",
  "modal.stock.expired": "过期日期",

  "table.import.sku": "SKU",
  "table.import.barcode": "条形码",
  "table.import.price_sale": "销售价格",
  "table.import.price_promotion": "促销价格",
  "table.import.apply_promotion": "应用促销",
  "table.import.image": "图片",
  "table.import.image_sub": "子图片",
  "table.import.recommend": "推荐",
  "table.import.hidden": "隐藏",
  "table.import.description": "描述",
  "table.import.size": "尺寸",
  "table.import.topping": "配料",
  "table.import.ice": "冰量",
  "table.import.sugar": "甜度",
  "table.import.color": "颜色",
  "table.import.material": "物料",
  "table.import.result": "导入结果",
  "table.import.reason": "错误原因",

  "modal.product.stt": "#",
  "modal.product.barcode_enter": "条形码 (输入)",
  "modal.product.unit": "定量",
  "modal.product.combo": "组合/制造",
  "modal.product.variant": "变体",
  "modal.product.supplier": "供应商",
  "modal.product.paid": "已付",
  "modal.product.remaining": "剩余",
  "modal.product.image": "图片",
  "modal.product.hot": "热门",
  "modal.product.delete": "删除",
  "modal.auto-generate": "自动生成",
  "modal.stock.confirm-import": "确认入库",
  "modal.add-row": "添加行",
  "tooltip.not-for-combo": "不适用于组合商品",
  "tooltip.unit-hint": "输入此产品的最小单位，例如：使用“包”而不是“箱”",
  "tooltip.enable-combo":
    "启用定量模式：允许选择多个成分（组合/制造）。成本价和入库数量将根据配方计算，而不是直接输入。",
  "label.create-new": "创建新",
  "label.select-or-create": "选择或创建...",
  "label.enter-product-name": "输入产品名称...",
  "label.enter-barcode": "输入条形码...",
  "label.select-create-provider": "选择/创建供应商...",
  "menu.product.recommended": "推荐产品",
  "menu.product.discount": "折扣",
  "menu.product.recipe": "配方",
  "menu.stock.inventory": "库存",
  "menu.stock.less-than-50": "低于 50%",
  "menu.stock.less-than-20": "低于 20%",
  "menu.stock.less-than-10": "低于 10%",
  "menu.stock.cost-price": "成本价",
  "menu.stock.cost-price-done": "已输入成本价",
  "menu.stock.cost-price-not-yet": "缺少成本价",
  "menu.stock.import-time": "入库时间",
  "menu.stock.recent-5-days": "最近 5 天",
  "menu.stock.recent-10-days": "最近 10 天",
  "todo.tasks": "任务",
  "todo.today": "今天",
  "todo.this-week": "本周",
  "todo.this-month": "本月",
  "todo.upcoming": "即将到来",
  "todo.next-1-hour": "未来 1 小时",
  "todo.next-3-hours": "未来 3 小时",
  "todo.next-6-hours": "未来 6 小时",
  "todo.past": "过去",
  "todo.past-7-days": "过去 7 天",
  "todo.past-30-days": "过去 30 天",
  "todo.past-6-months": "过去 6 个月",
  "chat.broadcast-all-stores": "发送给所有店铺",
  "menu.customer.debt": "债务",
  "menu.customer.no-debt": "无债务",
  "menu.customer.have-debt": "有债务",
  "menu.customer.badge": "徽章",
  "menu.customer.no-badge": "无徽章",
  "menu.customer.bronze": "铜牌",
  "menu.customer.gold": "金牌",
  "menu.customer.platinum": "白金",
  "menu.customer.tags": "标签",
  "menu.provider.transaction": "交易",
  "menu.provider.paid-all": "已全付",
  "menu.provider.debt": "债务",
  "menu.provider.no-transaction": "无交易",
  "menu.provider.products": "产品",
  "menu.staff.work-status": "工作状态",
  "menu.staff.working": "工作中",
  "menu.staff.quit": "离职",
  "menu.staff.position": "职位",
  "price.under-1m": "100 万以下",
  "price.1m-to-10m": "100 万 - 1000 万",
  "price.over-10m": "1000 万以上",
  "menu.finance.include-statistics": "包含在统计中",
  "menu.finance.price-range": "价格范围",
  "menu.finance.creator": "创建者",
  "menu.stock.status": "状态",
  "status.draft": "草稿",
  "status.in-progress": "进行中",
  "status.completed": "已完成",
  "menu.stock.time": "时间",
  "general.this-month": "本月",
  "general.last-month": "上月",
  "menu.audit.result": "结果",
  "menu.audit.has-discrepancy": "有差异",
  "status.pending": "待处理",
  "status.approved": "已批准",
  "status.rejected": "已拒绝",
  "menu.disposal.type": "处理类型",
  "disposal.expired": "过期",
  "disposal.damaged": "损坏",
  "menu.stock.statistics": "统计",
  "menu.stock.total-tickets": "总单据",
  "menu.stock.total-value": "总价值",
  "status.processing": "处理中",
  "menu.warehouse.status": "状态",
  "menu.warehouse.quantity-range": "数量",
  "menu.warehouse.unit": "单位",
  "quantity.under-10": "10 以下",
  "quantity.10-to-50": "10 - 50",
  "quantity.over-50": "50 以上",

  "table.import.success": "导入成功",
  "table.import.failed": "失败",
  "table.import.error_reason": "错误原因",

  "modal.alert.min-one-material": "请至少输入一种物料。",
  "modal.alert.check-required": "请检查必填项：\n\n",
  "modal.alert.missing-unit": '第 {index} 行 - "{name}": 缺少单位',
  "modal.alert.price-must-positive": '第 {index} 行 - "{name}": 价格必须 > 0',
  "modal.alert.quantity-must-positive":
    '第 {index} 行 - "{name}": 数量必须 > 0',
  "modal.alert.barcode-duplicate-list": "列表中有重复的条形码。请再次检查。",
  "modal.alert.barcode-duplicate-db":
    '条形码 "{barcode}" 已存在于物料 "{name}" 中。请使用其他代码。',

  "unit.placeholder.cafe": "杯, 玻璃杯, 盘...",
  "unit.placeholder.fashion": "件, 双, 套...",
  "unit.placeholder.cosmetics": "瓶, 管, 罐...",
  "unit.placeholder.retail": "件, 包, 箱, kg...",
  "unit.placeholder.default": "件, 箱, 包...",

  "product.price.cost": "成本价",
  "product.promotion-price": "促销价",

  "general.all": "全部",
  "general.yes": "是",
  "general.no": "否",

  "modal.stock.stt": "序号",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "条形码",
  "modal.stock.supplier": "供应商",
  "modal.stock.remaining": "剩余",
  "modal.stock.expired": "过期日期",
  "modal.stock.confirm-import": "确认入库",
  "modal.add-row": "添加行",
  "modal.auto-generate": "自动生成",

  "tooltip.unit-hint": "输入单位 (例如：kg, 箱...)",
  "tooltip.not-for-combo": "不适用于组合商品",
  "tooltip.enable-combo": "启用组合 (定量)",

  "label.select-or-create": "选择或创建...",
  "label.create-new": "创建新",
  "label.select-create-provider": "选择或创建供应商...",
  "label.enter-barcode": "输入条形码",
  "label.enter-product-name": "输入产品名称",

  "modal.product.combo": "组合",
  "modal.product.paid": "已付",
  "page.heading.export-filename": "产品列表",
  "product.alert.create-variant-missing-unit": "创建变体前请输入单位。",
  "product.alert.sync-stock-confirm":
    "主表单中的入库数量 ({mainFormQuantity}) 与变体总数量 ({totalVariantQuantity}) 不同。\n\n您想将主表单数量更新为 {totalVariantQuantity} 吗？",
  "product.validation.missing-name": "产品名称",
  "product.validation.missing-category": "类别",
  "product.validation.missing-price": "价格",
  "product.validation.missing-unit": "单位",
  "product.validation.missing-import-quantity": "入库数量",
  "product.validation.missing-cost-price": "成本价",
  "product.validation.barcode-duplicate-list":
    '条形码 "{barcode}" 在此列表中重复',
  "product.validation.barcode-duplicate-system":
    '条形码 "{barcode}" 已存在于系统中',
  "product.alert.validation-check-info": "请再次检查信息：\n",
  "label.create-new-value": '创建 "{value}"',
  "product.template.default": "Product_Import_Template.xlsx",
  "product.template.cafe": "Cafe_Product_Template.xlsx",
  "product.template.restaurant": "Restaurant_Product_Template.xlsx",
  "product.template.fashion": "Fashion_Product_Template.xlsx",
  "product.template.retail": "Retail_Product_Template.xlsx",
  "product.template.cosmetics": "Cosmetics_Product_Template.xlsx",

  VD: "例如",
  "analytics.export.stt": "序号",
  "analytics.export.total": "总计",
  "analytics.update": "更新分析",
  "product.btn-add": "添加产品",
  "product.tab.add-multiple": "批量添加",
  "product.tab.add-one": "添加单个",
  "settings.invoice.process-3-old": "流程 3 (旧)",
  "settings.invoice.process-4-old": "流程 4 (旧)",

  /* Missing Keys Added (Translated) */
  "todo.detail": "详情",
  "todo.cancel": "取消",
  "todo.submit": "提交",
  "todo.status": "状态",
  "todo.all-tasks": "所有任务",
  "todo.pending-tasks": "待办任务",
  "todo.completed-tasks": "已完成任务",
  "todo.categories": "分类",
  "todo.labels": "标签",
  "menu.charts": "图表",
  "chat.all_messages": "所有消息",
  "menu.chat": "聊天",
  "menu.survey": "调查",
  "input.to": "至",
  "input.email": "输入邮箱",
  "product.name": "产品名称",
  "modal.alert.warning": "警告",
  "general.done": "完成",
  "general.not-yet": "未完成",
  "product.add.quantity": "添加数量",
  "user-staff.date_start": "开始日期",
  "user-staff.date_end": "结束日期",
  "general.other": "其他",
  "stock.inventory": "库存",
  "stock.total-import": "总入库",

  "settings.email.placeholder.gmail-email": "输入 Gmail",
  "settings.email.placeholder.smtp-email": "输入 SMTP 邮箱",
  "profile.edit": "编辑个人资料",
  "menu.blank-page": "空白页",
  "action.success": "成功",
  "promotion-discount-add": "添加优惠码",
  "settings.ai.save-btn": "保存 AI 配置",
  "settings.partner.env.test-label": "测试环境",
  "invoice.tab.einvoice": "电子发票",
  "einvoice.list.title": "电子发票列表",
  "einvoice.status.draft": "草稿",
  "einvoice.status.issued": "已开具",
  "einvoice.status.signed": "已签名",
  "einvoice.status.sent": "已发送",
  "einvoice.status.cancelled": "已取消",
  "einvoice.action.view-pdf": "查看PDF",
  "einvoice.action.download-pdf": "下载PDF",
  "einvoice.action.send-email": "发送邮件",
  "einvoice.action.cancel": "取消发票",
  "einvoice.action.check-status": "检查状态",
  "einvoice.correction.adjust": "调整",
  "einvoice.correction.replace": "替换",
  "einvoice.correction.edit-draft": "编辑 SePay 草稿",
  "einvoice.correction.modal-adjust-title": "SePay 调整发票",
  "einvoice.correction.modal-replace-title": "SePay 替换发票",
  "einvoice.correction.submit": "发送至 SePay",
  "einvoice.mapping.preview": "VMASS 同步预览",
  "einvoice.mapping.applied": "已应用",
  "einvoice.mapping.pending": "等待应用",
  "einvoice.mapping.conflict": "冲突；请新建单据",
  "einvoice.mapping.failed": "技术错误；将重试",
  "einvoice.mapping.inventory": "发票库存",
  "einvoice.mapping.inventory-applied": "原料：恢复 {restored} 次，扣减 {deducted} 次；变体：恢复 {variantsRestored}，扣减 {variantsDeducted}",
  "einvoice.correction.save-draft": "保存 SePay 草稿",
  "einvoice.correction.issue-now": "立即开具",
  "einvoice.action.issue-official": "正式发行",
  "einvoice.action.reissue": "重新发行",
  "einvoice.cancel.reason": "取消原因",
  "einvoice.email.placeholder": "输入收件人邮箱",
  "einvoice.alert.cancel-confirm": "确定要取消此发票吗？",
  "einvoice.alert.email-success": "邮件发送成功！",
  "einvoice.action.edit": "编辑发票",
  "einvoice.edit.title": "编辑发票详情",
  "einvoice.edit.customer-name": "单位名称/购买方",
  "einvoice.edit.email": "发票接收邮箱",
  "einvoice.edit.payment-method": "付款方式",
  "einvoice.edit.note": "备注",
  "einvoice.edit.placeholder.customer-name": "公司名称或客户姓名",
  "einvoice.edit.placeholder.tax-id": "企业纳税人识别号",
  "einvoice.edit.placeholder.address": "企业注册地址",
  "einvoice.edit.placeholder.email": "email@company.com",
  "einvoice.edit.placeholder.phone": "发票接收手机号",
  "einvoice.edit.placeholder.note": "发票备注",
  "button.save-changes": "保存修改",
  "einvoice.notification.status-updated": "发票状态已更新",
  "einvoice.notification.email-required": "请输入邮箱地址",
  "einvoice.notification.cancel-reason-required": "请输入作废原因",
  "einvoice.notification.cancel-success": "发票已作废",
  "einvoice.notification.issue-official-success": "已成功发行正规发票",
  "einvoice.notification.customer-name-required": "请输入单位名称/购买方",
  "einvoice.notification.update-success": "发票信息已更新",
  "einvoice.notification.missing-contact-info": "发票缺少邮箱和电话。请选择“编辑发票”进行补充，然后再重新发行。",

  /* Table Headers - E-Invoice */
  "table.invoice-no": "发票号",
  "table.customer": "客户",
  "table.date": "日期",
  "table.total": "总计",
  "table.status": "状态",
  "table.action": "操作",
  "table.no-data": "暂无数据",
  "button.refresh": "刷新",
  "button.cancel": "取消",
  "einvoice.checkbox.issue": "开具电子发票",
  "einvoice.success.issued": "电子发票开具成功",
  "einvoice.error.issue-failed": "电子发票开具失败",
  "table.phone": "电话",
  "table.address": "地址",
  "table.email": "电子邮件",
  "table.discount": "折扣",
  "table.payment_method": "支付方式",
  "table.note": "备注",
  "table.tax": "税号",
  "settings.einvoice.sepay-client-id": "客户端 ID",
  "settings.einvoice.sepay-client-secret": "客户端密钥",
  "settings.einvoice.sepay-template-code": "发票模板代码",
  "settings.einvoice.automation": "自动化配置",
  "settings.einvoice.auto-issue": "始终勾选“开具发票”复选框（默认：关闭）",
  "settings.einvoice.auto-draft": "未选中时始终开具草稿发票（默认：开启）",
  "settings.email.placeholder.gmail-email": "输入 Gmail",
  "settings.email.placeholder.smtp-email": "输入 SMTP 邮箱",
  "settings.einvoice.title": "电子发票",
  "settings.einvoice.save-success": "配置保存成功",
  "settings.einvoice.save-error": "保存配置时出错",
  "settings.einvoice.test-success": "连接成功",
  "settings.einvoice.test-fail": "连接失败",
  "settings.email.save-success": "邮箱配置保存成功",
  "settings.email.save-error": "保存邮箱配置时出错",
  "settings.email.test-success": "测试邮件发送成功",
  "settings.email.test-error": "测试邮件发送出错",
  /* Shopee */
  "menu.ecommerce": "电子商务",
  "menu.shopee": "Shopee",
  "menu.tiktok-shop": "TikTok Shop",
  "menu.lazada": "Lazada",
  "menu.tiki": "Tiki",
  "ecommerce.coming-soon": "即将推出",
  "ecommerce.coming-soon-desc": "此功能正在开发中。我们将很快支持此平台！",
  "shopee.tab.connection": "连接",
  "shopee.tab.orders": "订单",
  "shopee.tab.products": "商品",
  "shopee.tab.inventory": "库存",
  "shopee.connection.title": "Shopee店铺连接",
  "shopee.connection.desc": "连接Shopee店铺以同步订单、商品和库存。",
  "shopee.connect.btn": "连接新店铺",
  "shopee.connect.error": "连接Shopee出错",
  "shopee.disconnect.btn": "断开",
  "shopee.disconnect.confirm": "确定要断开此店铺吗？",
  "shopee.disconnect.success": "店铺已断开",
  "shopee.disconnect.error": "断开出错",
  "shopee.oauth.success": "Shopee店铺连接成功。",
  "shopee.oauth.error.missing-params": "Shopee未返回完整的授权信息。",
  "shopee.oauth.error.invalid-state": "Shopee连接会话无效或已过期，请重试。",
  "shopee.oauth.error.not-configured": "尚未配置Shopee Partner凭据。",
  "shopee.oauth.error.shop-already-connected": "此Shopee店铺已连接到另一个VMASS账户。",
  "shopee.oauth.error.callback-failed": "无法完成Shopee连接，请重试。",
  "shopee.oauth.error.upgrade-required": "请升级套餐以使用Shopee集成。",
  "shopee.oauth.error.generic": "Shopee拒绝了连接请求，请重试。",
  "shopee.no-shop": "暂无连接的Shopee店铺。",
  "shopee.select-shop": "选择店铺",
  "shopee.table.name": "店铺名",
  "shopee.table.id": "店铺ID",
  "shopee.table.region": "地区",
  "shopee.table.token-expires": "令牌状态",
  "shopee.table.connected": "连接日期",
  "shopee.token.expired": "已过期",
  "shopee.token.active": "有效",
  "shopee.orders.filter.all": "全部状态",
  "shopee.orders.sync-btn": "从Shopee同步",
  "shopee.orders.bulk-sync": "全部同步到VMASS",
  "shopee.orders.sync.error": "同步订单出错",
  "shopee.orders.sync-to-bill": "同步到VMASS",
  "shopee.orders.sync-bill.error": "同步订单出错",
  "shopee.orders.load.error": "加载订单出错",
  "shopee.orders.empty": "暂无订单。",
  "shopee.orders.col.sn": "订单号",
  "shopee.orders.col.status": "状态",
  "shopee.orders.col.buyer": "买家",
  "shopee.orders.col.amount": "金额",
  "shopee.orders.col.date": "日期",
  "shopee.orders.col.synced": "已同步",
  "shopee.synced": "已同步",
  "shopee.not-synced": "未同步",
  "shopee.products.mapped": "商品映射",
  "shopee.products.view-shopee": "查看Shopee商品",
  "shopee.products.import-btn": "从Shopee导入",
  "shopee.products.load.error": "加载商品出错",
  "shopee.products.import.error": "导入出错",
  "shopee.products.empty": "暂无商品映射。",
  "shopee.products.col.name": "商品名",
  "shopee.products.col.sku": "SKU",
  "shopee.products.col.price": "价格",
  "shopee.products.col.stock": "库存",
  "shopee.products.col.vmass": "VMASS关联",
  "shopee.products.linked": "已关联",
  "shopee.products.not-linked": "未关联",
  "shopee.products.map-btn": "关联",
  "shopee.products.map.success": "商品关联成功",
  "shopee.products.map.error": "关联出错",
  "shopee.products.map-modal.title": "关联Shopee商品到VMASS",
  "shopee.products.map-modal.select": "选择VMASS商品",
  "shopee.products.map-modal.placeholder": "选择商品",
  "shopee.products.map-modal.save": "保存",
  "shopee.cancel": "取消",
  "shopee.inventory.title": "库存同步",
  "shopee.inventory.desc": "将VMASS库存推送到Shopee。",
  "shopee.inventory.sync-btn": "同步库存到Shopee",
  "shopee.inventory.sync.error": "库存同步出错",
  "shopee.inventory.no-linked": "暂无关联商品。",
  "shopee.inventory.col.shopee-stock": "Shopee库存",
  "shopee.inventory.col.vmass-product": "VMASS商品",
  "shopee.inventory.col.sync-enabled": "同步",
  "shopee.inventory.col.last-sync": "最后同步",
  "shopee.logistics.ship-btn": "发货",
  "shopee.logistics.track-btn": "追踪",
  "shopee.logistics.ship.error": "安排发货出错",
  "shopee.logistics.track.error": "加载物流信息出错",
  "shopee.logistics.modal.title": "物流",
  "shopee.logistics.phone": "电话",
  "shopee.logistics.address": "地址",
  "shopee.logistics.carrier": "承运商",
  "shopee.logistics.tracking-no": "运单号",
  "shopee.logistics.arrange": "安排发货",
  "shopee.logistics.pickup-address": "取件地址",
  "shopee.logistics.confirm-ship": "确认发货",
  "shopee.logistics.timeline": "物流时间线",
  "shopee.logistics.no-tracking": "暂无物流信息。",
  "shopee.tab.returns": "退货",
  "shopee.tab.analytics": "数据分析",
  "shopee.tab.settings": "设置",
  "shopee.tab.monitor": "监控",
  "shopee.returns.title": "退货退款",
  "shopee.returns.refresh": "刷新",
  "shopee.returns.empty": "暂无退货/退款请求。",
  "shopee.returns.col.sn": "退货编号",
  "shopee.returns.col.order": "订单编号",
  "shopee.returns.col.reason": "原因",
  "shopee.returns.col.status": "状态",
  "shopee.returns.col.amount": "退款金额",
  "shopee.returns.col.date": "日期",
  "shopee.returns.col.buyer": "买家",
  "shopee.returns.accept": "接受",
  "shopee.returns.dispute": "申诉",
  "shopee.returns.load.error": "加载退货列表出错",
  "shopee.returns.detail.error": "加载退货详情出错",
  "shopee.returns.detail.title": "退货详情",
  "shopee.returns.confirm.prompt": "确定接受此退货请求吗？",
  "shopee.returns.confirm.error": "确认退货出错",
  "shopee.returns.dispute.title": "退货申诉",
  "shopee.returns.dispute.email": "联系邮箱",
  "shopee.returns.dispute.reason": "申诉原因",
  "shopee.returns.dispute.submit": "提交申诉",
  "shopee.returns.dispute.success": "申诉提交成功",
  "shopee.returns.dispute.error": "提交申诉出错",
  "shopee.returns.buyer-note": "买家备注",
  "shopee.analytics.title": "Shopee数据分析",
  "shopee.analytics.no-data": "暂无分析数据。",
  "shopee.analytics.total-orders": "总订单数",
  "shopee.analytics.revenue": "营收",
  "shopee.analytics.synced": "已同步到VMASS",
  "shopee.analytics.products-linked": "已关联商品",
  "shopee.analytics.by-status": "按状态分类",
  "shopee.analytics.last-7-days": "最近7天",
  "shopee.analytics.col.date": "日期",
  "shopee.analytics.col.orders": "订单数",
  "shopee.analytics.col.revenue": "营收",
  "shopee.analytics.date-range": "日期范围",
  "shopee.analytics.date-hint": "Shopee数据搜索范围不超过90天（3个月）。请选择日期范围进行筛选。",
  "shopee.analytics.max-range": "日期范围不能超过90天（3个月）",
  "shopee.analytics.invalid-range": "开始日期必须早于结束日期",
  "shopee.settings.title": "Shopee设置",
  "shopee.settings.auto-sync-orders": "自动同步订单",
  "shopee.settings.auto-sync-orders.desc": "自动从Shopee获取新订单",
  "shopee.settings.sync-interval": "同步间隔",
  "shopee.settings.sync-interval.desc": "检查新订单的频率",
  "shopee.settings.auto-bill": "自动创建账单",
  "shopee.settings.auto-bill.desc": "从Shopee订单自动创建VMASS账单",
  "shopee.settings.auto-inventory": "自动同步库存",
  "shopee.settings.auto-inventory.desc": "自动将VMASS库存推送到Shopee",
  "shopee.settings.notifications": "通知",
  "shopee.settings.notify-new-order": "新订单通知",
  "shopee.settings.notify-status": "订单状态变更",
  "shopee.settings.notify-return": "退货/退款请求",
  "shopee.settings.save": "保存设置",
  "shopee.settings.save.success": "设置保存成功",
  "shopee.settings.save.error": "保存设置出错",
  "shopee.monitor.health": "连接状态",
  "shopee.monitor.no-shops": "暂无连接的店铺。",
  "shopee.monitor.last-sync": "最后同步",
  "shopee.monitor.expiring-soon": "即将过期",
  "shopee.monitor.activity": "活动日志",
  "shopee.monitor.filter.all": "全部活动",
  "shopee.monitor.no-activity": "暂无近期活动。",
  "shopee.push.modal.title": "发布商品到Shopee",
  "shopee.push.step": "步骤",
  "shopee.push.step.select": "选择VMASS商品",
  "shopee.push.step.category": "选择Shopee分类",
  "shopee.push.step.details": "商品详情",
  "shopee.push.step.confirm": "确认并发布",
  "shopee.push.form.name": "商品名称（5-120字）",
  "shopee.push.form.description": "描述（至少25字）",
  "shopee.push.form.price": "价格",
  "shopee.push.form.weight": "重量（kg）",
  "shopee.push.form.condition": "商品状态",
  "shopee.push.form.condition.new": "全新",
  "shopee.push.form.condition.used": "二手",
  "shopee.push.form.status": "上架状态",
  "shopee.push.form.status.normal": "上架（NORMAL）",
  "shopee.push.form.status.unlist": "下架（UNLIST）",
  "shopee.push.form.logistics": "物流渠道",
  "shopee.push.form.attributes": "分类属性",
  "shopee.push.form.category": "Shopee分类",
  "shopee.push.form.dimension": "包装尺寸",
  "shopee.push.btn.next": "下一步",
  "shopee.push.btn.back": "返回",
  "shopee.push.btn.push": "发布到Shopee",
  "shopee.push.btn.push-short": "发布到Shopee",
  "shopee.push.btn.select": "选择",
  "shopee.push.btn.cancel": "取消",
  "shopee.push.validate.name": "商品名称必须在5-120字之间",
  "shopee.push.validate.description": "描述至少需要25个字符",
  "shopee.push.validate.price": "价格必须大于0",
  "shopee.push.validate.weight": "重量必须在0.01到50公斤之间",
  "shopee.push.validate.category": "请选择分类",
  "shopee.push.validate.logistics": "请至少选择一个物流渠道",

  "suggestion.title": "推荐",
  "suggestion.frequently-bought": "经常一起购买",
  "suggestion.bestseller": "畅销",
  "analytics.product_customers.title": "购买过的客户",
  "analytics.product_customers.identified": "已识别客户",
  "analytics.product_customers.anonymous": "散客订单",
  "analytics.product_customers.quantity": "数量",
  "analytics.product_customers.revenue": "收入",
  "analytics.product_customers.search": "搜索",
  "analytics.product_customers.customer": "客户",
  "analytics.product_customers.orders": "订单数",
  "analytics.product_customers.spent": "消费金额",
  "analytics.product_customers.last_purchase": "最近购买",
  "analytics.product_customers.empty": "没有匹配的客户",
  "analytics.product_customers.customers": "位客户",
  "analytics.summary.total_products_sold_period": "期间已售商品数",
  "analytics.summary.total_quantity_sold_period": "期间销售数量",
  "analytics.summary.product_revenue_period": "商品收入",
  "analytics.summary.product_cost_period": "商品成本",
  "analytics.summary.product_gross_profit_period": "毛利润",
  "analytics.summary.product_margin_period": "利润率",
  "shopee.workspace.title": "Shopee 运营中心",
  "shopee.workspace.subtitle": "按店铺管理订单、商品、库存、履约和结算",
  "shopee.workspace.overview": "总览",
  "shopee.workspace.catalog": "商品目录",
  "shopee.workspace.inventory": "库存",
  "shopee.workspace.fulfillment": "履约",
  "shopee.workspace.returns": "退货",
  "shopee.workspace.finance": "财务",
  "shopee.workspace.automation": "自动化",
  "shopee.workspace.logs": "日志",
  "shopee.workspace.refresh": "刷新",
  "shopee.workspace.search": "搜索",
  "shopee.workspace.from-date": "开始日期",
  "shopee.workspace.to-date": "结束日期",
  "shopee.workspace.loading": "正在加载 Shopee 数据…",
  "shopee.workspace.no-data": "暂无数据",
  "shopee.workspace.actions": "操作",
  "shopee.workspace.gmv": "GMV",
  "shopee.workspace.refunds": "退款",
  "shopee.workspace.fees": "Shopee 费用",
  "shopee.workspace.net-revenue": "净收入",
  "shopee.workspace.payout": "实际到账",
  "shopee.workspace.issues": "问题",
  "shopee.workspace.issue-center": "问题中心",
  "shopee.workspace.order-issues": "订单问题",
  "shopee.workspace.mapping-issues": "映射问题",
  "shopee.workspace.job-issues": "失败任务",
  "shopee.workspace.retry-selected-orders": "重试所选订单",
  "shopee.workspace.auto-map-selected": "自动映射完全匹配的 SKU",
  "shopee.workspace.create-selected-drafts": "创建所选草稿",
  "shopee.workspace.issue-reason": "问题",
  "shopee.workspace.item-model": "商品 / 型号",
  "shopee.workspace.job": "任务",
  "shopee.workspace.replay": "重试",
  "shopee.workspace.no-issues": "未发现问题",
  "shopee.workspace.confirm-remediation": "确认修复",
  "shopee.workspace.confirm-remediation-detail": "此操作仅处理所选记录，并具有幂等性。",
  "shopee.workspace.sync": "同步",
  "shopee.workspace.mapping": "映射",
  "shopee.workspace.sync-state": "同步状态",
  "shopee.workspace.amount": "金额",
  "shopee.workspace.create-bill": "创建账单",
  "shopee.workspace.import-catalog": "导入目录",
  "shopee.workspace.map-product": "映射商品",
  "shopee.workspace.mapping-wizard": "将 Shopee 变体映射到 VMASS",
  "shopee.workspace.search-product": "搜索 VMASS 商品",
  "shopee.workspace.choose-product": "选择 VMASS 商品",
  "shopee.workspace.choose-variant": "选择 VMASS 变体",
  "shopee.workspace.create-draft": "创建 VMASS 草稿",
  "shopee.workspace.update-listing": "更新商品",
  "shopee.workspace.list-listing": "上架",
  "shopee.workspace.unlist-listing": "下架",
  "shopee.workspace.variant-prices": "变体价格",
  "shopee.workspace.image-urls": "图片 URL",
  "shopee.workspace.image-help": "每行一个允许的 VMASS 资源 URL；仅在编辑此字段后发送图片。",
  "shopee.workspace.length": "长 (cm)",
  "shopee.workspace.width": "宽 (cm)",
  "shopee.workspace.height": "高 (cm)",
  "shopee.workspace.vmass-product-id": "VMASS 商品 ID",
  "shopee.workspace.vmass-variant-id": "VMASS 变体 ID（单品请留空）",
  "shopee.workspace.mapping-help": "保存前系统会验证租户归属以及变体是否属于该商品。",
  "shopee.workspace.sync-stock": "同步库存",
  "shopee.workspace.shopee-stock": "Shopee 库存",
  "shopee.workspace.state": "状态",
  "shopee.workspace.reservation": "库存预留",
  "shopee.workspace.tracking": "运单号",
  "shopee.workspace.ship": "发货",
  "shopee.workspace.ship-confirm": "确认发货",
  "shopee.workspace.shipping-params-error": "无法加载配送参数",
  "shopee.workspace.shipping-method": "交接方式",
  "shopee.workspace.pickup-address": "取件地址",
  "shopee.workspace.pickup-time": "取件时间",
  "shopee.workspace.confirm": "确认",
  "shopee.workspace.accept": "接受",
  "shopee.workspace.dispute": "申诉",
  "shopee.workspace.return-reason": "退货处理原因",
  "shopee.workspace.return-evidence": "凭证（图片 ID，以逗号分隔）",
  "shopee.workspace.sync-finance": "同步结算",
  "shopee.workspace.create-income": "创建收款单",
  "shopee.workspace.save": "保存",
  "shopee.workspace.sync-interval": "同步间隔（分钟）",
  "shopee.workspace.resource": "资源",
  "shopee.workspace.attempts": "尝试次数",
  "shopee.workspace.created-at": "创建时间",
  "shopee.workspace.retry": "重试",
  "shopee.workspace.setting.auto_sync_orders": "自动同步订单",
  "shopee.workspace.setting.auto_create_bill": "待发货时自动创建账单",
  "shopee.workspace.setting.auto_sync_inventory": "自动同步库存",
  "shopee.workspace.setting.auto_sync_catalog": "自动同步商品目录",
  "shopee.workspace.catalog-sync-interval": "目录同步间隔（分钟）",
  "shopee.workspace.catalog-sync-hint": "60 至 10080 分钟；默认 1440 分钟（每天）。",
  "shopee.workspace.catalog-last-sync": "上次成功同步目录的时间",
  "shopee.workspace.catalog-next-sync": "下次目录同步",
  "shopee.workspace.select-shop-for-automation": "请选择具体店铺以配置自动化。",
  "shopee.workspace.select-shop-for-listing": "添加或编辑商品前，请选择具体店铺。",
  "shopee.workspace.listing-load-incomplete": "部分 Shopee 商品数据无法加载。您可以查看已加载的数据并重试。",
  "shopee.workspace.listing-no-candidates": "没有可发布到 Shopee 的 VMASS 商品。",
  "shopee.workspace.setting.notify_new_order": "新 Shopee 订单通知",
  "shopee.workspace.setting.notify_status_change": "订单状态变更通知",
  "shopee.workspace.setting.notify_return": "退货通知",
  "shopee.workspace.inventory-safety-buffer": "不发布到 Shopee 的安全库存",
  "shopee.workspace.scope-not-granted": "店铺尚未授予所需的 Shopee 权限：",
  "shopee.workspace.group.overview": "总览",
  "shopee.workspace.group.catalog": "库存与商品",
  "shopee.workspace.group.logistics": "物流与财务",
  "shopee.workspace.group.system": "系统",
  "shopee.workspace.tab.overview": "总览",
  "shopee.workspace.tab.orders": "订单",
  "shopee.workspace.tab.products": "多渠道商品",
  "shopee.workspace.tab.mappings": "商品匹配",
  "shopee.workspace.tab.inventory": "渠道库存",
  "shopee.workspace.tab.pricing": "渠道价格",
  "shopee.workspace.tab.shipping": "发货与打包",
  "shopee.workspace.tab.returns": "退货与退款",
  "shopee.workspace.tab.reconciliation": "对账与结算",
  "shopee.workspace.tab.issues": "问题中心",
  "shopee.workspace.tab.connections": "渠道与连接",
  "shopee.workspace.tab.connections-short": "销售渠道",
  "shopee.workspace.tab.automation": "自动化",
  "shopee.workspace.tab.logs": "任务日志",
  "shopee.workspace.connect-required.title": "需要连接 Shopee 账户",
  "shopee.workspace.connect-required.desc": "您的账户尚未连接任何 Shopee 店铺。请连接 Shopee 店铺以查看报表、管理订单和商品并同步库存。",
  "shopee.workspace.connect-required.feature.orders": "自动同步订单",
  "shopee.workspace.connect-required.feature.mapping": "SKU 匹配与库存管理",
  "shopee.workspace.connect-required.feature.shipping": "物流状态更新",
  "shopee.workspace.connect-required.feature.finance": "营收对账与结算",
  "shopee.workspace.connect-required.connecting": "正在连接...",
  "shopee.workspace.connect-required.cta": "🚀 立即连接 Shopee 店铺",
  "shopee.workspace.sidebar.shops-header": "店铺",
  "shopee.workspace.sidebar.add-shop-title": "连接新的 Shopee 店铺",
  "shopee.workspace.sidebar.refresh-title": "刷新数据",
  "shopee.workspace.sidebar.all-shops": "📊 所有店铺（{count}）",
  "shopee.workspace.sidebar.shop-fallback": "店铺 {shopId}",
  "shopee.workspace.sidebar.connected-count": "{count} 个已连接渠道",
  "shopee.workspace.sidebar.not-connected": "未连接",
  "shopee.workspace.common.sending-request": "请求发送中...",
  "shopee.workspace.common.sync": "同步",
  "shopee.workspace.common.edit": "编辑",
  "shopee.workspace.common.per-page": "{size} / 页",
  "shopee.workspace.common.product-name": "商品名称",
  "shopee.workspace.common.customer": "客户",
  "shopee.workspace.common.previous": "上一页",
  "shopee.workspace.common.next": "下一页",
  "shopee.workspace.common.loading": "加载中...",
  "shopee.workspace.common.page": "页",
  "shopee.workspace.common.of": "/",
  "shopee.workspace.common.rows": "条",
  "shopee.workspace.common.all-statuses": "全部状态",
  "shopee.workspace.common.all-channels": "全部渠道",
  "shopee.workspace.common.filter": "筛选",
  "shopee.workspace.common.tab-all-count": "全部（{count}）",
  "shopee.workspace.common.view-all": "查看全部",
  "shopee.workspace.common.total": "合计",
  "shopee.workspace.common.note": "备注",
  "shopee.workspace.common.optional": "选填",
  "shopee.workspace.common.note-placeholder": "输入备注...",
  "shopee.workspace.common.last-7-days": "最近 7 天",
  "shopee.workspace.common.last-30-days": "最近 30 天",
  "shopee.workspace.catalog.channel-all": "全部",
  "shopee.workspace.catalog.not-synced-yet": "尚未同步",
  "shopee.workspace.catalog.minutes-ago": "{count} 分钟前",
  "shopee.workspace.catalog.hours-ago": "{count} 小时前",
  "shopee.workspace.catalog.channel-unlisted": "未上架",
  "shopee.workspace.catalog.publish-now": "立即上架",
  "shopee.workspace.catalog.sync-error-short": "同步错误",
  "shopee.workspace.catalog.out-of-stock": "缺货",
  "shopee.workspace.catalog.listed": "已上架",
  "shopee.workspace.catalog.view-error": "查看错误",
  "shopee.workspace.catalog.mapping-saved": "商品匹配已更新",
  "shopee.workspace.catalog.mapping-cleared": "已从 VMASS 移除该 Shopee 商品的匹配",
  "shopee.workspace.catalog.inventory-sync-queued": "库存同步已排期",
  "shopee.workspace.catalog.import-queued": "目录导入已排期",
  "shopee.workspace.catalog.kpi-total-listings": "刊登总数",
  "shopee.workspace.catalog.kpi-total-listings-note": "{count} 行匹配记录",
  "shopee.workspace.catalog.kpi-mapped": "已匹配",
  "shopee.workspace.catalog.kpi-page-percent": "本页 {percent}%",
  "shopee.workspace.catalog.kpi-unmapped": "未匹配",
  "shopee.workspace.catalog.note-needs-action": "需要处理",
  "shopee.workspace.catalog.kpi-sync-errors": "同步错误",
  "shopee.workspace.catalog.note-priority": "优先处理",
  "shopee.workspace.catalog.kpi-out-of-stock": "缺货",
  "shopee.workspace.catalog.note-at-shopee": "Shopee 渠道侧",
  "shopee.workspace.catalog.kpi-price-pending": "待更新价格",
  "shopee.workspace.catalog.note-sync-price": "需要同步价格",
  "shopee.workspace.catalog.filter-aria": "商品筛选",
  "shopee.workspace.catalog.search-placeholder": "搜索商品、SKU、条码...",
  "shopee.workspace.catalog.channel-aria": "销售渠道",
  "shopee.workspace.catalog.mapping-state-aria": "匹配状态",
  "shopee.workspace.catalog.sync-state-aria": "同步状态",
  "shopee.workspace.catalog.mapping-all": "全部匹配",
  "shopee.workspace.catalog.mapping-mapped": "已匹配",
  "shopee.workspace.catalog.mapping-unmapped": "未匹配",
  "shopee.workspace.catalog.sync-state-all": "同步状况",
  "shopee.workspace.catalog.sync-state-error": "有错误",
  "shopee.workspace.catalog.add-product": "添加商品",
  "shopee.workspace.catalog.select-all-aria": "选择全部商品",
  "shopee.workspace.catalog.col-product": "商品",
  "shopee.workspace.catalog.col-sku-vmass": "VMASS SKU",
  "shopee.workspace.catalog.col-price": "售价",
  "shopee.workspace.catalog.col-stock": "库存",
  "shopee.workspace.catalog.col-sync-state": "同步状态",
  "shopee.workspace.catalog.col-last-update": "最后更新",
  "shopee.workspace.catalog.select-row-aria": "选择 {name}",
  "shopee.workspace.catalog.no-vmass-mapping": "尚未匹配 VMASS",
  "shopee.workspace.catalog.no-vmass-sku": "暂无 VMASS SKU",
  "shopee.workspace.catalog.open-detail-aria": "打开详情",
  "shopee.workspace.catalog.pagination-summary": "显示 {from} - {to}，共 {total} 行匹配记录",
  "shopee.workspace.catalog.detail-sku-label": "VMASS SKU：",
  "shopee.workspace.catalog.detail-item-label": "Shopee 商品：",
  "shopee.workspace.catalog.close-detail-aria": "关闭详情",
  "shopee.workspace.catalog.nav-stock": "库存",
  "shopee.workspace.catalog.nav-history": "历史",
  "shopee.workspace.catalog.unmapped-badge": "未匹配",
  "shopee.workspace.catalog.sku-shopee": "Shopee SKU",
  "shopee.workspace.catalog.update-mapping": "更新匹配",
  "shopee.workspace.catalog.map-product-btn": "匹配商品",
  "shopee.workspace.catalog.no-channel-info": "暂无商品信息",
  "shopee.workspace.catalog.publish-to": "上架到 {channel}",
  "shopee.workspace.catalog.sync-shopee-catalog": "同步 Shopee 目录",
  "shopee.workspace.catalog.unmap": "取消匹配",
  "shopee.workspace.catalog.sku-name-placeholder": "SKU / 商品名称",
  "shopee.workspace.catalog.draft-created": "已创建库存为 0 的 VMASS 商品草稿",
  "shopee.workspace.catalog.listing-show-queued": "上架展示请求已加入队列",
  "shopee.workspace.catalog.listing-hide-queued": "下架隐藏请求已加入队列",
  "shopee.workspace.fulfillment.ship-queued": "发货请求已加入队列",
  "shopee.workspace.returns.status.requested": "新请求",
  "shopee.workspace.returns.status.in-inspection": "验货中",
  "shopee.workspace.returns.status.waiting-refund": "待退款",
  "shopee.workspace.returns.status.processing": "处理中",
  "shopee.workspace.returns.status.completed": "已完成",
  "shopee.workspace.returns.status.rejected": "已拒绝",
  "shopee.workspace.returns.status.restocked": "已入库",
  "shopee.workspace.returns.status.waiting-confirm": "待确认",
  "shopee.workspace.returns.inspection-confirmed": "退货验货已确认，库存已更新",
  "shopee.workspace.returns.dispute-queued": "争议请求已加入队列",
  "shopee.workspace.returns.customer-fallback": "客户",
  "shopee.workspace.returns.reason-other": "其他",
  "shopee.workspace.returns.reason-detail-fallback": "退货请求",
  "shopee.workspace.returns.item-fallback": "商品",
  "shopee.workspace.returns.subtitle": "统一管理全部退货、退款与换货请求",
  "shopee.workspace.returns.export-excel": "导出 Excel",
  "shopee.workspace.returns.report": "报表",
  "shopee.workspace.returns.create-request": "创建退货请求",
  "shopee.workspace.returns.kpi-requested-note": "新增及待确认",
  "shopee.workspace.returns.kpi-processing-note": "验货与处理中",
  "shopee.workspace.returns.kpi-waiting-refund-note": "等待退款中",
  "shopee.workspace.returns.kpi-completed-note": "已全部处理",
  "shopee.workspace.returns.kpi-rejected-note": "被拒绝的请求",
  "shopee.workspace.returns.total-refund-today": "今日退款总额",
  "shopee.workspace.returns.return-value-today": "今日退货金额",
  "shopee.workspace.returns.pipeline.customer-request": "客户发起请求",
  "shopee.workspace.returns.pipeline.inspect": "验货",
  "shopee.workspace.returns.pipeline.approve": "审批退货",
  "shopee.workspace.returns.pipeline.restock-dispose": "入库 / 报废",
  "shopee.workspace.returns.pipeline.refund": "退款",
  "shopee.workspace.returns.search-placeholder": "搜索退货单号、订单号、姓名、电话...",
  "shopee.workspace.returns.all-reasons": "全部原因",
  "shopee.workspace.returns.all-warehouses": "全部仓库",
  "shopee.workspace.returns.no-data": "暂无退货请求",
  "shopee.workspace.returns.detail-title": "退货详情",
  "shopee.workspace.returns.original-order": "原始订单",
  "shopee.workspace.returns.customer-media": "客户的照片/视频",
  "shopee.workspace.returns.no-media": "客户尚未上传照片",
  "shopee.workspace.returns.returned-products": "退货商品",
  "shopee.workspace.returns.qty-label": "数量",
  "shopee.workspace.returns.inspection-title": "退货商品验收",
  "shopee.workspace.returns.check.intact": "商品完好",
  "shopee.workspace.returns.check.packaging": "包装与标签",
  "shopee.workspace.returns.check.accessories": "配件齐全",
  "shopee.workspace.returns.check.correct-product": "商品无误",
  "shopee.workspace.returns.check.defect": "瑕疵 / 损坏",
  "shopee.workspace.returns.processing-title": "处理退货",
  "shopee.workspace.returns.action.restock": "入库",
  "shopee.workspace.returns.action.exchange": "换货",
  "shopee.workspace.returns.action.discard": "报废",
  "shopee.workspace.returns.restock-warehouse": "入库仓库",
  "shopee.workspace.returns.confirm-continue": "确认并继续",
  "shopee.workspace.returns.popular-reasons": "常见退货原因",
  "shopee.workspace.returns.no-reason-data": "暂无原因数据",
  "shopee.workspace.returns.top-returned": "退货最多的商品",
  "shopee.workspace.returns.times-suffix": "次",
  "shopee.workspace.returns.no-returned-products": "暂无退回商品",
  "shopee.workspace.returns.refund-trend": "退款金额趋势",
  "shopee.workspace.returns.performance": "处理效率",
  "shopee.workspace.returns.avg-processing-time": "平均处理时长",
  "shopee.workspace.returns.on-time-rate": "按时完成率",
  "shopee.workspace.returns.sample-processing-time": "1.8 天",
  "shopee.workspace.returns.sample-processing-delta": "-0.3 天",
  "shopee.workspace.returns.dispute-modal-title": "发起 Shopee 争议",
  "shopee.workspace.returns.inspection-modal-title": "退货验收单",
  "shopee.workspace.returns.condition-placeholder": "请输入实际收货情况...",
  "shopee.workspace.returns.stock-decision": "入库决定",
  "shopee.workspace.returns.stock.resellable": "1. 完好 -> 重新入销售库",
  "shopee.workspace.returns.stock.defective": "2. 损坏 / 脏污 -> 入不良品库",
  "shopee.workspace.returns.stock.discard": "3. 严重损坏 / 报废 -> 不入库",
  "shopee.workspace.returns.stock.shortage": "4. 缺件 / 掉包 -> 建立短缺报告",
  "shopee.workspace.returns.evidence-placeholder": "验货凭证图片/视频链接（URL 1、URL 2）...",
  "shopee.workspace.returns.col.sn": "退货单号",
  "shopee.workspace.returns.col.order": "原始订单",
  "shopee.workspace.returns.col.channel": "渠道",
  "shopee.workspace.returns.col.reason": "退货原因",
  "shopee.workspace.returns.col.refund-value": "退款金额",
  "shopee.workspace.returns.col.warehouse": "仓库",
  "shopee.workspace.returns.col.status": "状态",
  "shopee.workspace.returns.col.created-at": "创建时间",
  "shopee.workspace.returns.action.inspect": "验货并入库",
  "shopee.workspace.returns.action.dispute": "发起 Shopee 争议",
  "shopee.workspace.returns.view-detail-title": "查看详情",
  "shopee.workspace.automation.settings-saved": "自动化配置已保存",
  "shopee.workspace.logs.replayed": "任务已重放",
  "shopee.workspace.common.detail": "详情",
  "shopee.workspace.common.page-count": "/ {total} 页",
  "shopee.workspace.common.no-data": "暂无数据",
  "shopee.workspace.common.close": "关闭",
  "shopee.workspace.orders.status.all": "全部",
  "shopee.workspace.orders.status.unpaid": "未付款",
  "shopee.workspace.orders.status.ready-to-ship": "待处理",
  "shopee.workspace.orders.status.processed": "已处理",
  "shopee.workspace.orders.status.shipped": "配送中",
  "shopee.workspace.orders.status.to-confirm-receive": "待确认收货",
  "shopee.workspace.orders.status.completed": "已送达",
  "shopee.workspace.orders.status.in-cancel": "取消中",
  "shopee.workspace.orders.status.cancelled": "已取消",
  "shopee.workspace.orders.status-unknown": "未知",
  "shopee.workspace.orders.metric.total": "订单总数",
  "shopee.workspace.orders.metric.total-indicator": "本页 {count} 单",
  "shopee.workspace.orders.metric.pending": "待处理",
  "shopee.workspace.orders.metric.pending-indicator": "本页 {percent}%",
  "shopee.workspace.orders.metric.deadline": "发货期限关注",
  "shopee.workspace.orders.metric.deadline-overdue": "{count} 单已逾期",
  "shopee.workspace.orders.metric.deadline-window": "{risk}/{total} 单有期限",
  "shopee.workspace.orders.metric.deadline-none": "没有等待发货的订单",
  "shopee.workspace.orders.metric.gmv": "订单 GMV",
  "shopee.workspace.orders.metric.gmv-indicator": "{paid}/{eligible} 单有金额",
  "shopee.workspace.orders.metric.delivered": "已送达",
  "shopee.workspace.orders.tabs-region-aria": "订单状态栏，横向滚动查看更多",
  "shopee.workspace.orders.count-tooltip": "当前页的订单数量",
  "shopee.workspace.orders.select-all-aria": "选择全部订单",
  "shopee.workspace.orders.select-row-aria": "选择订单 {sn}",
  "shopee.workspace.orders.col.sn": "订单编号",
  "shopee.workspace.orders.col.channel": "渠道",
  "shopee.workspace.orders.col.items": "商品",
  "shopee.workspace.orders.col.amount": "总金额",
  "shopee.workspace.orders.col.tracking": "运单号",
  "shopee.workspace.orders.col.time": "时间",
  "shopee.workspace.orders.phone-hidden": "信息已隐藏",
  "shopee.workspace.orders.items-count": "{count} 件",
  "shopee.workspace.orders.items-total-x": "合计 x{count}",
  "shopee.workspace.orders.paid-time": "付款时间 {time}",
  "shopee.workspace.orders.paid-time-missing": "Shopee 尚未返回付款时间",
  "shopee.workspace.orders.sync-queued": "订单同步已排期",
  "shopee.workspace.orders.sync-button": "同步订单",
  "shopee.workspace.orders.selection-banner": "已选择 {count} 个订单。",
  "shopee.workspace.orders.export-selected": "导出所选订单",
  "shopee.workspace.orders.clear-selection": "取消选择",
  "shopee.workspace.orders.empty": "没有符合条件的订单。",
  "shopee.workspace.orders.showing-summary": "显示 {shown} / {total} 个订单",
  "shopee.workspace.orders.filter-title": "搜索筛选",
  "shopee.workspace.orders.clear-filters": "清除筛选",
  "shopee.workspace.orders.filter-status-label": "订单状态",
  "shopee.workspace.orders.filter-search-label": "搜索关键词",
  "shopee.workspace.orders.search-placeholder": "订单号或运单号...",
  "shopee.workspace.orders.apply-filters": "应用筛选",
  "shopee.workspace.orders.chart-title": "页面内状态分布",
  "shopee.workspace.orders.detail-title": "Shopee 订单详情 #{orderSn}",
  "shopee.workspace.orders.detail-loading": "正在加载订单详情...",
  "shopee.workspace.orders.detail-load-error": "无法加载更多订单详情。",
  "shopee.workspace.orders.phone-label": "电话号码:",
  "shopee.workspace.orders.tracking-label": "运单号:",
  "shopee.workspace.orders.total-shopee": "Shopee 总金额",
  "shopee.workspace.orders.created-at": "下单时间",
  "shopee.workspace.orders.ship-deadline": "Shopee 发货期限",
  "shopee.workspace.orders.items-title": "商品列表（{count}）",
  "shopee.workspace.orders.price-per-item": "{price} / 件",
  "shopee.workspace.orders.create-bill": "创建 VMASS 账单",
  "shopee.workspace.orders.bill-created": "已从 Shopee 订单创建账单",
  "shopee.workspace.orders.csv.order-code": "订单编号",
  "shopee.workspace.orders.csv.phone": "电话",
  "shopee.workspace.orders.csv.products": "商品",
  "shopee.workspace.orders.csv.amount": "总金额",
  "shopee.workspace.overview.webhook.configured": "已配置",
  "shopee.workspace.overview.webhook.processing": "处理中",
  "shopee.workspace.overview.webhook.degraded": "需要检查",
  "shopee.workspace.overview.webhook.not-configured": "未配置",
  "shopee.workspace.overview.webhook.unknown": "未知",
  "shopee.workspace.overview.kpi.new-orders": "新订单",
  "shopee.workspace.overview.kpi.new-trend": "新增",
  "shopee.workspace.overview.kpi.new-comparison": "今日新增订单",
  "shopee.workspace.overview.kpi.pending": "待处理 / 打包",
  "shopee.workspace.overview.kpi.pending-trend": "需要处理",
  "shopee.workspace.overview.kpi.pending-comparison": "可移交发货",
  "shopee.workspace.overview.kpi.expiring": "即将超过发货期限",
  "shopee.workspace.overview.kpi.expiring-priority": "优先",
  "shopee.workspace.overview.kpi.expiring-safe": "安全",
  "shopee.workspace.overview.kpi.expiring-comparison": "需尽快处理",
  "shopee.workspace.overview.kpi.gmv": "今日营收（GMV）",
  "shopee.workspace.overview.kpi.gmv-trend": "GMV 总计",
  "shopee.workspace.overview.kpi.gmv-comparison": "总营收",
  "shopee.workspace.overview.kpi.ontime": "按时发货率",
  "shopee.workspace.overview.kpi.ontime-trend": "达标",
  "shopee.workspace.overview.kpi.ontime-comparison": "绩效指标",
  "shopee.workspace.overview.issue.orders": "待处理订单",
  "shopee.workspace.overview.issue.orders-desc": "为保障发货时效需要处理的订单。",
  "shopee.workspace.overview.issue.mappings": "待处理匹配",
  "shopee.workspace.overview.issue.mappings-desc": "尚未匹配或匹配不准确的 SKU。",
  "shopee.workspace.overview.issue.jobs": "失败任务",
  "shopee.workspace.overview.issue.jobs-desc": "同步失败的任务，需要检查。",
  "shopee.workspace.overview.issue.products": "信息不全的商品",
  "shopee.workspace.overview.issue.products-desc": "在部分渠道缺少信息的商品。",
  "shopee.workspace.overview.issue.reconciliation": "对账差异",
  "shopee.workspace.overview.issue.reconciliation-desc": "存在差异、需要对账的订单。",
  "shopee.workspace.overview.shop-fallback": "Shopee - 店铺 {shopId}",
  "shopee.workspace.overview.shop-label": "店铺 {shopId}",
  "shopee.workspace.overview.activity.sync-default": "同步",
  "shopee.workspace.overview.activity.just-now": "刚刚",
  "shopee.workspace.overview.activity.success": "成功",
  "shopee.workspace.overview.activity.attempts": "已运行 {count} 次",
  "shopee.workspace.overview.banner-title": "Shopee 渠道健康状况与绩效总览",
  "shopee.workspace.overview.banner-healthy": "系统正常",
  "shopee.workspace.overview.banner-attention": "需要关注",
  "shopee.workspace.overview.banner-shops-updated": "已连接 {count} 家店铺 | 更新时间：{time}",
  "shopee.workspace.overview.period.today": "今天",
  "shopee.workspace.overview.period.week": "7 天",
  "shopee.workspace.overview.period.month": "30 天",
  "shopee.workspace.overview.reload": "重新加载数据",
  "shopee.workspace.overview.mapping-title": "SKU 匹配进度",
  "shopee.workspace.overview.mapping-tooltip": "Shopee 与 VMASS 之间的实际库存同步",
  "shopee.workspace.overview.mapping-percent": "{percent}% 已匹配",
  "shopee.workspace.overview.mapping-progress": "已匹配 {mapped} / {total} 个商品 SKU",
  "shopee.workspace.overview.mapping-note": "有新订单时自动同步实际库存并防止超卖。",
  "shopee.workspace.overview.mapping-action": "立即匹配 SKU",
  "shopee.workspace.overview.health-title": "同步健康度与 Shopee 连接状态",
  "shopee.workspace.overview.last-sync": "上次同步：",
  "shopee.workspace.overview.sparkline-label": "实时连接状态",
  "shopee.workspace.overview.oauth-label": "OAuth 令牌：",
  "shopee.workspace.overview.oauth-valid": "有效",
  "shopee.workspace.overview.oauth-invalid": "已过期",
  "shopee.workspace.overview.api-label": "API 健康度：",
  "shopee.workspace.overview.api-good": "良好（正常）",
  "shopee.workspace.overview.api-bad": "需要检查",
  "shopee.workspace.overview.issues-title": "问题中心",
  "shopee.workspace.overview.manage-connections": "管理连接",
  "shopee.workspace.overview.channels-title": "销售渠道",
  "shopee.workspace.overview.channel-active": "运行中",
  "shopee.workspace.overview.channel-error": "连接错误",
  "shopee.workspace.overview.new-orders-colon": "新订单：",
  "shopee.workspace.overview.no-shops": "尚无已连接的店铺",
  "shopee.workspace.overview.connect-more": "连接更多销售渠道",
  "shopee.workspace.overview.view-logs": "查看日志",
  "shopee.workspace.overview.activity-title": "近期同步活动",
  "shopee.workspace.overview.no-activity": "暂无近期活动日志",
  "shopee.workspace.overview.top-products": "热销商品榜",
  "shopee.workspace.overview.top-products-note": "按订单数量",
  "shopee.workspace.overview.top-period": "近 7 天统计",
  "shopee.workspace.overview.product-unknown": "未识别商品",
  "shopee.workspace.overview.sold-count": "{count} 单",
  "shopee.workspace.overview.no-products": "暂无商品数据",
  "shopee.workspace.overview.revenue-title": "各渠道营收分布",
  "shopee.workspace.overview.revenue-period": "近 7 天营收",
  "shopee.workspace.overview.revenue-total-aria": "总营收 {amount}",
  "shopee.workspace.overview.total-revenue": "总营收",
  "shopee.workspace.error.no-response": "Shopee 请求无响应。请检查 Redis 和 Shopee worker 后重试。",
  "shopee.workspace.error.load-failed": "无法加载 Shopee 数据",
  "shopee.workspace.notice.job-completed": "Shopee 任务已完成",
  "shopee.workspace.notice.job-ended-status": "Shopee 任务以状态 {status} 结束",
  "shopee.workspace.notice.job-status-updated": "任务 {status}",
  "shopee.workspace.notice.job-status-default": "已更新",
  "shopee.workspace.notice.new-order": "已收到来自 Shopee 的新订单",
  "shopee.workspace.notice.action-queued": "任务已加入队列",
  "shopee.workspace.notice.action-success": "更新成功",
  "shopee.workspace.common.back": "返回",
  "shopee.workspace.common.next-step": "下一步",
  "shopee.workspace.connections.title": "销售渠道与已连接店铺",
  "shopee.workspace.connections.subtitle": "管理 OAuth 授权、同步策略和 Shopee 店铺连接",
  "shopee.workspace.connections.add-shop-wizard": "添加新的 Shopee 店铺（6 步向导）",
  "shopee.workspace.connections.status-active": "运行中",
  "shopee.workspace.connections.region-id": "区域：{region} | 店铺 ID：{shopId}",
  "shopee.workspace.connections.scopes-label": "已授权权限：",
  "shopee.workspace.connections.scope.orders": "订单",
  "shopee.workspace.connections.scope.catalog": "目录",
  "shopee.workspace.connections.scope.stock": "库存",
  "shopee.workspace.connections.scope.finance": "财务",
  "shopee.workspace.connections.scope.return": "退货",
  "shopee.workspace.connections.last-sync-colon": "上次同步：",
  "shopee.workspace.connections.reauth-title": "重新授权",
  "shopee.workspace.connections.reauth": "重新执行 OAuth",
  "shopee.workspace.connections.disconnect-title": "断开连接",
  "shopee.workspace.connections.disconnected-notice": "已断开店铺 {shop} 的连接",
  "shopee.workspace.connections.disconnect-btn": "移除",
  "shopee.workspace.connections.empty": "尚未连接任何 Shopee 店铺。",
  "shopee.workspace.connections.connect-new": "+ 连接新的 Shopee 店铺",
  "shopee.workspace.connections.wizard.title": "Shopee 店铺连接与激活向导（第 {step}/6 步）",
  "shopee.workspace.connections.wizard.step1-title": "第 1 步：连接并授权 Shopee OAuth",
  "shopee.workspace.connections.wizard.step1-desc": "您将被重定向到 Shopee Partner Platform 官方授权页面登录店铺。",
  "shopee.workspace.connections.wizard.step1-permissions": "访问权限包括：",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "订单读写、目录同步、库存数量更新以及结算历史查看。",
  "shopee.workspace.connections.wizard.open-oauth": "前往 Shopee 登录与授权页面",
  "shopee.workspace.connections.wizard.step2-title": "第 2 步：选择初始数据导入",
  "shopee.workspace.connections.wizard.step2-desc": "选择要从 Shopee 导入到 VMASS 的数据类型：",
  "shopee.workspace.connections.wizard.step2-products": "来自 Shopee 的全部商品与规格",
  "shopee.workspace.connections.wizard.step2-orders": "最近 30 天内的订单",
  "shopee.workspace.connections.wizard.step2-logistics": "取货地址与物流合作方信息",
  "shopee.workspace.connections.wizard.step3-title": "第 3 步：确定数据源（Source of Truth）",
  "shopee.workspace.connections.wizard.step3-desc": "数据源决定由哪个系统管理主库存数量：",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "以 VMASS 为数据源（推荐）：",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "订单处理完成后，VMASS 库存将自动推送到 Shopee。",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "以 Shopee 为初始来源：",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "首次同步时以 Shopee 当前库存数量为基准。",
  "shopee.workspace.connections.wizard.step4-title": "第 4 步：检查 SKU 匹配",
  "shopee.workspace.connections.wizard.step4-info": "系统检测到 85% 的 Shopee SKU 与 VMASS 仓库 SKU 完全一致，这些 SKU 将被自动匹配。",
  "shopee.workspace.connections.wizard.step4-note": "未匹配的 SKU 可在激活后于“商品匹配”标签页中管理。",
  "shopee.workspace.connections.wizard.step5-title": "第 5 步：配置库存与价格策略",
  "shopee.workspace.connections.wizard.allocation-label": "库存分配模式",
  "shopee.workspace.connections.wizard.option-shared": "SHARED（共享 100% 可售库存）",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED（预留固定额度）",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE（按比例分配）",
  "shopee.workspace.connections.wizard.safety-buffer-label": "安全库存（Safety Buffer）",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "多渠道销售时防止超卖。",
  "shopee.workspace.connections.wizard.step6-title": "第 6 步：确认并激活店铺",
  "shopee.workspace.connections.wizard.step6-ready-strong": "可以激活！",
  "shopee.workspace.connections.wizard.step6-ready-detail": "所有配置有效，没有严重冲突。",
  "shopee.workspace.connections.wizard.check-oauth": "✔ 已授权 Shopee Partner API v2",
  "shopee.workspace.connections.wizard.check-sot": "✔ 数据源：{value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ 库存模式：{mode}（安全库存：{buffer}）",
  "shopee.workspace.connections.wizard.opening-shopee": "正在打开 Shopee 门户...",
  "shopee.workspace.connections.wizard.connect-now": "立即连接 Shopee OAuth",
  "shopee.workspace.connections.wizard.activate-done": "新 Shopee 店铺激活成功",
  "shopee.workspace.connections.wizard.activate-now": "立即激活店铺",
  "shopee.workspace.inventory.status.unknown": "数据不足",
  "shopee.workspace.inventory.status.unmapped": "未匹配 VMASS",
  "shopee.workspace.inventory.status.error": "同步错误",
  "shopee.workspace.inventory.status.out-of-stock": "Shopee 缺货",
  "shopee.workspace.inventory.status.variance": "差异",
  "shopee.workspace.inventory.status.synced": "已同步",
  "shopee.workspace.inventory.no-name": "Shopee 未提供商品名称",
  "shopee.workspace.inventory.sub.on-page": "当前页内",
  "shopee.workspace.inventory.sub.by-filter": "按当前筛选条件",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "基于已加载的匹配数据",
  "shopee.workspace.inventory.kpi.total": "Shopee 匹配总数",
  "shopee.workspace.inventory.kpi.synced-sub": "已加载 {count} 行中",
  "shopee.workspace.inventory.kpi.variance": "库存差异",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} 个同步错误",
  "shopee.workspace.inventory.kpi.last-sync": "最近更新",
  "shopee.workspace.inventory.col.vmass-stock": "VMASS 库存",
  "shopee.workspace.inventory.col.total": "总计",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "状态",
  "shopee.workspace.inventory.col.updated": "更新",
  "shopee.workspace.inventory.col.last": "最后",
  "shopee.workspace.inventory.img-placeholder-aria": "暂无商品图片",
  "shopee.workspace.inventory.title": "Shopee 库存",
  "shopee.workspace.inventory.subtitle": "将 VMASS 可售库存与已同步的 Shopee 目录进行核对。",
  "shopee.workspace.inventory.manage-mapping": "管理商品匹配",
  "shopee.workspace.inventory.search-placeholder": "搜索商品或 Shopee SKU...",
  "shopee.workspace.inventory.filter.all": "全部状况",
  "shopee.workspace.inventory.shop-colon": "店铺：",
  "shopee.workspace.inventory.no-shop-selected": "尚未选择店铺",
  "shopee.workspace.inventory.loading": "正在加载 Shopee 数据...",
  "shopee.workspace.inventory.empty": "没有符合筛选条件的 Shopee 匹配记录。",
  "shopee.workspace.inventory.pagination-summary": "显示 {from} - {to}，共 {total} 条 Shopee 匹配记录",
  "shopee.workspace.inventory.side.overview-title": "库存概览",
  "shopee.workspace.inventory.legend.filtered": "筛选后的匹配数",
  "shopee.workspace.inventory.legend.synced-page": "本页已同步",
  "shopee.workspace.inventory.legend.variance-page": "本页有差异",
  "shopee.workspace.inventory.side.top-variance": "库存差异排行",
  "shopee.workspace.inventory.side.no-variance": "已加载数据中没有库存差异。",
  "shopee.workspace.inventory.side.alerts-title": "库存预警",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} 个商品在 Shopee 缺货",
  "shopee.workspace.inventory.alert.variance": "{count} 个商品存在库存差异",
  "shopee.workspace.inventory.alert.variance-desc": "Shopee 与 VMASS 不一致",
  "shopee.workspace.inventory.alert.unmapped": "{count} 个商品未匹配 VMASS",
  "shopee.workspace.inventory.alert.unmapped-desc": "请先匹配商品再进行核对",
  "shopee.workspace.pricing.kpi.total": "SKU 总数",
  "shopee.workspace.pricing.kpi.synced": "价格已同步",
  "shopee.workspace.pricing.kpi.variance": "价格差异",
  "shopee.workspace.pricing.kpi.pending": "未更新",
  "shopee.workspace.pricing.kpi.pending-sub": "缺少 Shopee 或 VMASS 价格",
  "shopee.workspace.pricing.kpi.errors": "价格错误",
  "shopee.workspace.pricing.subtitle": "管理并同步 VMASS 与各销售渠道之间的商品售价",
  "shopee.workspace.pricing.search-placeholder": "搜索商品名称、SKU、条码...",
  "shopee.workspace.pricing.category.all": "全部分类",
  "shopee.workspace.pricing.category.fashion": "时尚服饰",
  "shopee.workspace.pricing.category.electronics": "电子产品",
  "shopee.workspace.pricing.category.food": "食品",
  "shopee.workspace.pricing.warehouse.main": "主仓",
  "shopee.workspace.pricing.warehouse.hanoi": "河内仓",
  "shopee.workspace.pricing.warehouse.hcm": "胡志明仓",
  "shopee.workspace.pricing.pagination-summary": "显示 {from} - {to}，共 {total} 个 Shopee 商品",
  "shopee.workspace.pricing.col.vmass-price": "VMASS 售价",
  "shopee.workspace.pricing.col.price-small": "售价",
  "shopee.workspace.pricing.col.diff-range": "最高 - 最低",
  "shopee.workspace.pricing.action.adjust-price": "调整价格",
  "shopee.workspace.pricing.action.sync-price-list": "同步价目表",
  "shopee.workspace.pricing.action.cancel-rule": "取消价格规则",
  "shopee.workspace.pricing.action.sync-price": "同步价格",
  "shopee.workspace.pricing.action.batch-update": "批量更新",
  "shopee.workspace.pricing.action.price-rules": "价格规则",
  "shopee.workspace.pricing.alert.higher": "{count} 个商品价格偏高",
  "shopee.workspace.pricing.alert.lower": "{count} 个商品价格偏低",
  "shopee.workspace.pricing.alert.unavailable": "{count} 个商品缺少价格数据",
  "shopee.workspace.pricing.alert.threshold-desc": "与 VMASS 相差 > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "本页",
  "shopee.workspace.pricing.side.variance-title": "价格差异概览",
  "shopee.workspace.pricing.side.top-variance": "价格差异排行",
  "shopee.workspace.pricing.side.no-variance": "已加载的 Shopee 数据中没有价格差异。",
  "shopee.workspace.pricing.side.alerts-title": "价格预警",
  "shopee.workspace.pricing.rule.title": "渠道售价规则设置（Price Policy Builder）",
  "shopee.workspace.pricing.rule.policy-mode": "定价策略模式",
  "shopee.workspace.pricing.rule.option-direct": "直接使用 VMASS 价格",
  "shopee.workspace.pricing.rule.option-percent": "按百分比加价",
  "shopee.workspace.pricing.rule.option-fixed": "固定金额加价",
  "shopee.workspace.pricing.rule.option-cost-plus": "成本 + 费用 + 利润",
  "shopee.workspace.pricing.rule.markup-percent-label": "加价比例 (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "固定加价金额 (越南盾)",
  "shopee.workspace.pricing.rule.fee-label": "预计平台费率 (%)",
  "shopee.workspace.pricing.rule.packaging-label": "包装费用 (越南盾)",
  "shopee.workspace.pricing.rule.rounding-label": "取整规则",
  "shopee.workspace.pricing.rule.rounding-none": "不取整",
  "shopee.workspace.pricing.rule.rounding-thousand": "整千 (.000)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "尾数 9.000 (.9.000)",
  "shopee.workspace.pricing.rule.formula-strong": "应用公式：",
  "shopee.workspace.pricing.rule.formula-text": "渠道价 = [VMASS 价 + 固定费用] / (1 - 平台费率%) -> 取整。",
  "shopee.workspace.pricing.rule.preview-no-base": "已加载的 Shopee 数据中没有可用于预览的 VMASS 价格。",
  "shopee.workspace.pricing.rule.preview-from": "从 VMASS 价格 {base} 预览：{result}",
  "shopee.workspace.pricing.rule.save-preview": "保存规则并预览",
  "shopee.workspace.pricing.approve.title": "确认审批并向 Shopee 批量推送价目表",
  "shopee.workspace.pricing.approve.warning-strong": "安全警告：",
  "shopee.workspace.pricing.approve.warning-detail": "此操作将应用新的价格规则，并将商品价目表同步到 Shopee。",
  "shopee.workspace.pricing.approve.items-total": "商品总数",
  "shopee.workspace.pricing.approve.rule-applied": "应用规则",
  "shopee.workspace.pricing.approve.fee-deducted": "平台扣点",
  "shopee.workspace.pricing.approve.queued": "已启动向 Shopee 批量更新价目表的任务",
  "shopee.workspace.pricing.approve.confirm": "同意审批并更新价格",
  "shopee.workspace.mapping.model-simple": "单规格商品",
  "shopee.workspace.mapping.draft-created-from-listing": "已从 Shopee 刊登创建 VMASS 商品",
  "shopee.workspace.mapping.no-provider-data": "Shopee 未提供数据",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · 价格 {price} · 库存 {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "价格 {price} · 库存 {stock}",
  "shopee.workspace.mapping.stock-colon": "库存:",
  "shopee.workspace.mapping.price-label": "价格",
  "shopee.workspace.mapping.col.vmass-product": "VMASS 商品",
  "shopee.workspace.mapping.col.mapping": "匹配",
  "shopee.workspace.mapping.pick-product-aria": "选择要匹配的 VMASS 商品",
  "shopee.workspace.mapping.no-mapping-permission": "您没有商品匹配权限",
  "shopee.workspace.common.pick-product": "选择商品",
  "shopee.workspace.common.retry": "重试",
  "shopee.workspace.common.yes": "是",
  "shopee.workspace.common.no": "否",
  "shopee.workspace.mapping.state-conflict": "冲突",
  "shopee.workspace.mapping.auto-map-launched": "已启动 {count} 条 Shopee 匹配的自动匹配任务",
  "shopee.workspace.mapping.inventory-sync-queued": "Shopee 商品库存同步已排期",
  "shopee.workspace.mapping.no-shop-selected": "尚未选择 Shopee 店铺。请连接或选择店铺以加载真实匹配数据。",
  "shopee.workspace.mapping.kpi.total-sub": "来自 API 的 {count} 行匹配记录",
  "shopee.workspace.mapping.kpi.rate-page": "当前页 {percent}%",
  "shopee.workspace.mapping.kpi.rate": "匹配率",
  "shopee.workspace.mapping.search-placeholder": "搜索 SKU、条码、商品名称...",
  "shopee.workspace.mapping.title": "Shopee 匹配",
  "shopee.workspace.mapping.data-scope-banner": "来自店铺 {shop} 的数据；状态指标按当前页计算。",
  "shopee.workspace.mapping.shop-unselected": "未选择",
  "shopee.workspace.mapping.loading": "正在从 Shopee 加载匹配数据...",
  "shopee.workspace.mapping.empty": "Shopee 未返回符合店铺和当前筛选条件的匹配记录。",
  "shopee.workspace.mapping.detail-title": "匹配详情",
  "shopee.workspace.mapping.tab-info": "信息",
  "shopee.workspace.mapping.tab-history": "历史",
  "shopee.workspace.mapping.status.disabled": "同步已停用",
  "shopee.workspace.mapping.status.error": "同步错误",
  "shopee.workspace.mapping.status.healthy": "正常",
  "shopee.workspace.mapping.status.mapping-required": "未匹配",
  "shopee.workspace.mapping.status.out-of-stock": "缺货",
  "shopee.workspace.mapping.section-vmass": "VMASS 信息",
  "shopee.workspace.mapping.section-shopee": "Shopee 数据",
  "shopee.workspace.mapping.available-stock": "可用库存",
  "shopee.workspace.mapping.shopee-name-colon": "Shopee 名称：",
  "shopee.workspace.mapping.not-linked": "尚未关联 Shopee 渠道",
  "shopee.workspace.mapping.sync-enabled-colon": "允许同步：",
  "shopee.workspace.mapping.auto-map-this": "自动匹配此 SKU",
  "shopee.workspace.mapping.change": "更改匹配",
  "shopee.workspace.mapping.remove": "移除匹配",
  "shopee.workspace.mapping.history-created": "创建匹配：",
  "shopee.workspace.mapping.history-updated": "更新匹配：",
  "shopee.workspace.mapping.history-last-sync": "上次 Shopee 同步：",
  "shopee.workspace.mapping.sync-stock-to-shopee": "同步库存到 Shopee",
  "shopee.workspace.mapping.modal-title": "选择要匹配的 VMASS 商品",
  "shopee.workspace.mapping.candidate-search-placeholder": "按 VMASS 名称、SKU 或条码搜索",
  "shopee.workspace.mapping.candidates-loading": "正在加载 VMASS 商品...",
  "shopee.workspace.mapping.choose-product": "选择 VMASS 商品",
  "shopee.workspace.mapping.nameless-product": "未命名商品",
  "shopee.workspace.mapping.choose-variant": "选择 VMASS 规格",
  "shopee.workspace.mapping.no-variants-note": "该 VMASS 商品没有规格；匹配将使用基础商品库存。",
  "shopee.workspace.mapping.no-candidates": "没有符合搜索条件的 VMASS 商品。",
  "shopee.workspace.mapping.create-product": "新建商品",
  "shopee.workspace.mapping.save": "保存匹配",
  "shopee.workspace.mapping.auto-map-selected": "自动匹配所选（{count}）",
  "einvoice.filter.issuance-status": "开具状态",
  "einvoice.filter.invoice-status": "发票状态",
  "einvoice.filter.all": "全部",
  "einvoice.issuance-status.pending": "处理中",
  "einvoice.issuance-status.success": "成功",
  "einvoice.issuance-status.failed": "失败",
  "einvoice.invoice-status.draft": "草稿",
  "einvoice.invoice-status.issued": "已开具",
  "template.badge": "示例数据",
  "template.convert": "转换为真实数据",
  "product.btn-update": "更新商品",
  "template.profile.title": "引导示例数据",
  "template.profile.description": "示例商品和原料可帮助您熟悉系统。您可以根据需要隐藏或重新显示它们。",
  "template.profile.dismiss": "隐藏示例数据",
  "template.profile.show": "重新显示示例数据",
  "template.profile.confirm": "示例数据及由其创建的订单将被隐藏，已使用的示例库存会被恢复。是否继续？",
  "template.profile.show-confirm": "您确定要重新显示示例数据吗？",
  "template.profile.success": "示例数据已隐藏",
  "template.profile.show-success": "已成功重新显示示例数据！",
  "shopee.workspace.shipping.customer-fallback": "客户 {number}",
  "shopee.workspace.shipping.product-fallback": "Shopee 商品",
  "shopee.workspace.shipping.service-standard": "标准配送",
  "shopee.workspace.shipping.status.ready-pickup": "等待揽收",
  "shopee.workspace.shipping.status.processing": "处理中",
  "shopee.workspace.shipping.checklist.inspect": "检查商品",
  "shopee.workspace.shipping.checklist.protect": "防震包装",
  "shopee.workspace.shipping.col.order-sub": "订单号 | 渠道",
  "shopee.workspace.shipping.col.phone-sub": "电话",
  "shopee.workspace.shipping.col.amount": "货款金额",
  "shopee.workspace.shipping.col.progress-sub": "进度",
  "shopee.workspace.shipping.print-slip-title": "打印面单",
  "shopee.workspace.shipping.alert.print-slip": "打印订单 {sn} 的送货单",
  "shopee.workspace.shipping.alert.update-status": "更新订单 {sn} 的状态",
  "shopee.workspace.shipping.action.update-status": "更新状态",
  "shopee.workspace.shipping.alert.cancel-order": "取消订单 {sn}",
  "shopee.workspace.shipping.action.cancel-order": "取消订单",
  "shopee.workspace.shipping.subtitle": "管理所有渠道订单的处理、打包和发货流程。",
  "shopee.workspace.shipping.create-shipping-order": "创建发货单",
  "shopee.workspace.shipping.alert.print-labels-bulk": "批量打印面单",
  "shopee.workspace.shipping.action.print-bulk": "批量打印",
  "shopee.workspace.shipping.alert.export-excel": "导出 Excel 列表",
  "shopee.workspace.shipping.alert.syncing-orders": "正在从各渠道同步新订单...",
  "shopee.workspace.shipping.kpi.overdue": "{count} 单已逾期",
  "shopee.workspace.shipping.kpi.packing": "打包中",
  "shopee.workspace.shipping.kpi.packing-sub": "1 个进行中",
  "shopee.workspace.shipping.kpi.pickup-today": "今日揽收",
  "shopee.workspace.shipping.kpi.handover": "已交接",
  "shopee.workspace.shipping.kpi.shipping": "配送中",
  "shopee.workspace.shipping.kpi.shipping-sub": "运输途中",
  "shopee.workspace.shipping.step.delivered": "已完成",
  "shopee.workspace.shipping.step.picking": "拣货",
  "shopee.workspace.shipping.action.print-label": "打印运单",
  "shopee.workspace.shipping.search-placeholder": "搜索订单号、客户姓名、电话...",
  "shopee.workspace.shipping.filter.all-carriers": "全部承运商",
  "shopee.workspace.common.yesterday": "昨天",
  "shopee.workspace.common.this-month": "本月",
  "shopee.workspace.shipping.pagination-summary": "显示 1 - {count}，共 {total} 个订单",
  "shopee.workspace.shipping.perf.performance-today": "今日绩效",
  "shopee.workspace.shipping.perf.updated-at": "10:30 更新",
  "shopee.workspace.shipping.perf.processed": "已处理",
  "shopee.workspace.shipping.perf.orders-value": "{count} 单",
  "shopee.workspace.shipping.perf.on-time": "准时",
  "shopee.workspace.shipping.perf.overdue": "逾期",
  "shopee.workspace.shipping.perf.success-rate": "妥投率",
  "shopee.workspace.shipping.perf.returns": "退货单",
  "shopee.workspace.shipping.perf.top-carriers": "承运商排行",
  "shopee.workspace.shipping.alert.close-detail": "关闭详情面板",
  "shopee.workspace.shipping.section-customer": "客户信息",
  "shopee.workspace.shipping.title.call": "拨打电话",
  "shopee.workspace.shipping.alert.call": "呼叫 {phone}",
  "shopee.workspace.shipping.title.address": "查看地址",
  "shopee.workspace.shipping.section-products": "商品（{count}）",
  "shopee.workspace.shipping.section-shipping-info": "物流信息",
  "shopee.workspace.shipping.col.carrier": "承运商",
  "shopee.workspace.shipping.title.copy-code": "复制单号",
  "shopee.workspace.shipping.alert.copied": "已复制：{code}",
  "shopee.workspace.shipping.col.service": "服务",
  "shopee.workspace.shipping.col.shipping-fee": "运费",
  "shopee.workspace.shipping.col.cod": "货到付款 (COD)",
  "shopee.workspace.shipping.col.total-collect": "总收款",
  "shopee.workspace.shipping.checklist-title": "打包清单",
  "shopee.workspace.shipping.alert.print-label": "打印 {sn} 的运单",
  "shopee.workspace.shipping.action.print-slip": "打印出货单",
  "shopee.workspace.shipping.alert.print-slip-order": "打印 {sn} 的出货单",
  "shopee.workspace.shipping.action.packed-done": "打包完成",
  "shopee.workspace.shipping.notice.packed-handover": "打包完成，已转为“待交接”状态",
  "shopee.workspace.shipping.alert.packed-done": "订单 {sn} 打包完成",
  "shopee.workspace.shipping.action.complete-handover": "完成并转待交接",
  "shopee.workspace.shipping.action.report-shortage": "报告缺货",
  "shopee.workspace.shipping.action.delay-packing": "暂缓打包",
  "shopee.workspace.shipping.scan.title": "打包站 - 扫描订单码",
  "shopee.workspace.shipping.scan.desc": "扫描条码或输入运单号 / Shopee 订单号以即时核对并打印面单：",
  "shopee.workspace.shipping.scan.label": "订单号 / 运单号",
  "shopee.workspace.shipping.scan.placeholder": "例如：SP24072201 或 GHN1234567890...",
  "shopee.workspace.shipping.alert.not-found": "未找到该编码的订单：{code}",
  "shopee.workspace.shipping.scan.now": "立即扫描",
  "shopee.workspace.finance.channel-pos": "POS - 门店",
  "shopee.workspace.finance.status.paid": "已付款",
  "shopee.workspace.finance.status.pending-payment": "待付款",
  "shopee.workspace.finance.status.discrepancy": "差异",
  "shopee.workspace.finance.status.dispute": "争议中",
  "shopee.workspace.finance.bank-encrypted": "已加密账户",
  "shopee.workspace.finance.payout.transferred": "已转账",
  "shopee.workspace.finance.payout.processing": "处理中",
  "shopee.workspace.finance.sync-queued": "对账同步已排期",
  "shopee.workspace.finance.subtitle": "跟踪、核对并管理所有销售渠道的付款",
  "shopee.workspace.finance.forecast": "回款预测",
  "shopee.workspace.finance.export-report": "导出报表",
  "shopee.workspace.finance.action.sync": "同步对账",
  "shopee.workspace.finance.kpi.revenue": "营收",
  "shopee.workspace.finance.kpi.vs-prev-period": "较上期",
  "shopee.workspace.finance.kpi.pending-reconciliation": "待对账",
  "shopee.workspace.finance.kpi.holding": "冻结中",
  "shopee.workspace.finance.kpi.refund": "退款",
  "shopee.workspace.finance.kpi.fees": "费用与扣款",
  "shopee.workspace.finance.cashflow-title": "现金流",
  "shopee.workspace.finance.net-received": "实收金额",
  "shopee.workspace.finance.forecast.tomorrow": "明天",
  "shopee.workspace.finance.forecast.next-3-days": "未来 3 天",
  "shopee.workspace.finance.forecast.next-week": "下周",
  "shopee.workspace.finance.forecast.view-detail": "查看预测详情 →",
  "shopee.workspace.finance.filter.all-banks": "全部银行账户",
  "shopee.workspace.finance.col.sn": "结算单号",
  "shopee.workspace.finance.col.period": "结算周期",
  "shopee.workspace.finance.col.order-count": "订单数",
  "shopee.workspace.finance.col.payout-date": "付款日期",
  "shopee.workspace.finance.action.export-excel-file": "导出 Excel 文件",
  "shopee.workspace.finance.detail-title": "对账详情",
  "shopee.workspace.finance.meta.period": "结算周期：",
  "shopee.workspace.finance.meta.payout-date": "付款日期：",
  "shopee.workspace.finance.meta.bank-account": "收款账户：",
  "shopee.workspace.finance.meta.transaction-code": "交易编号：",
  "shopee.workspace.finance.meta.status": "状态：",
  "shopee.workspace.finance.tab-orders": "订单明细（{count}）",
  "shopee.workspace.finance.bd.gross-revenue": "总营收",
  "shopee.workspace.finance.bd.platform-deduction": "平台扣款 ^",
  "shopee.workspace.finance.bd.voucher": "平台优惠券",
  "shopee.workspace.finance.bd.shipping-buyer": "运费（买家承担）",
  "shopee.workspace.finance.bd.seller-discount": "平台优惠折扣",
  "shopee.workspace.finance.bd.payment-fee": "支付手续费",
  "shopee.workspace.finance.bd.service-fee": "服务费",
  "shopee.workspace.finance.bd.tax": "税费",
  "shopee.workspace.finance.bd.refunds": "退款 / 退货 ^",
  "shopee.workspace.finance.bd.refund-fee": "退款手续费",
  "shopee.workspace.finance.bd.other-deductions": "其他扣款",
  "shopee.workspace.finance.action.view-documents": "查看看对账凭证",
  "shopee.workspace.finance.action.download-statement": "下载对账单",
  "shopee.workspace.finance.discrepancy.alert": "有差异需要核查：",
  "shopee.workspace.finance.discrepancy.desc": "有 {count} 个订单在 VMASS 与渠道之间存在差异。",
  "shopee.workspace.finance.widget.success-rate": "对账成功率",
  "shopee.workspace.finance.legend.success": "成功：",
  "shopee.workspace.finance.legend.failed": "失败：",
  "shopee.workspace.finance.widget.top-revenue-channels": "营收最高渠道",
  "shopee.workspace.finance.channel-others": "其他",
  "shopee.workspace.finance.widget.popular-refund-reasons": "常见退款原因",
  "shopee.workspace.finance.reason.wrong-color": "颜色/色号不符：",
  "shopee.workspace.finance.reason.wrong-size": "尺码不合适：",
  "shopee.workspace.finance.reason.defect": "商品瑕疵：",
  "shopee.workspace.finance.reason.not-liked": "不喜欢：",
  "shopee.workspace.finance.insight.unpaid-orders": "您有 {count} 个 Shopee 订单已送达超过 10 天仍未收到款项。",
  "shopee.workspace.finance.insight.transfer-tomorrow": "Shopee 将于明天（{date}）转入约 4200 万。",
  "shopee.workspace.finance.insight.fee-increase": "TikTok Shop 运费较上月上涨了 {percent}。",
  "shopee.workspace.finance.insight.view-more": "查看更多洞察 →",
  "shopee.workspace.issues.channel-other": "其他渠道",
  "shopee.workspace.common.order-hash": "订单",
  "shopee.workspace.common.product-hash": "商品",
  "shopee.workspace.tab.shipping-short": "物流",
  "shopee.workspace.issues.subtitle": "跟踪、处理并修复连接、同步和系统问题",
  "shopee.workspace.issues.severity.critical": "严重",
  "shopee.workspace.issues.severity.high": "高",
  "shopee.workspace.issues.severity.medium": "中",
  "shopee.workspace.issues.severity.low": "低",
  "shopee.workspace.issues.status.unresolved": "未处理",
  "shopee.workspace.issues.status.in-progress": "处理中",
  "shopee.workspace.issues.status.waiting": "等待处理",
  "shopee.workspace.issues.status.resolved": "已解决",
  "shopee.workspace.issues.status.ignored": "已忽略",
  "shopee.workspace.issues.type.order-sync": "订单同步",
  "shopee.workspace.issues.type.product-sync": "商品同步",
  "shopee.workspace.issues.type.system-task": "系统任务",
  "shopee.workspace.issues.type.system": "系统",
  "shopee.workspace.issues.type.stock-sync": "库存同步",
  "shopee.workspace.issues.type.api-connection": "API 连接",
  "shopee.workspace.issues.type.payment": "支付",
  "shopee.workspace.issues.filter.all-types": "全部类型",
  "shopee.workspace.issues.filter.all-severities": "全部级别",
  "shopee.workspace.issues.error.order-sync": "订单同步错误",
  "shopee.workspace.issues.error.check-order-status": "请检查订单状态",
  "shopee.workspace.issues.error.sku-mapping": "SKU 匹配错误",
  "shopee.workspace.issues.error.sku-unmapped": "SKU 未匹配 VMASS 或库存同步错误",
  "shopee.workspace.issues.error.job-ended-status": "任务以状态 {status} 结束",
  "shopee.workspace.issues.error.retried-times": "已重试 {count} 次",
  "shopee.workspace.issues.action.process-label": "处理问题 {id}",
  "shopee.workspace.issues.action.process-now": "立即处理",
  "shopee.workspace.issues.action.ignore-label": "忽略问题 {id}",
  "shopee.workspace.issues.action.ignore": "忽略",
  "shopee.workspace.issues.action.mark-resolved": "标记为已解决",
  "shopee.workspace.issues.empty": "未找到符合条件的问题数据",
  "shopee.workspace.issues.pagination-of": "共 {total} 个问题",
  "shopee.workspace.issues.total-errors": "问题总数",
  "shopee.workspace.issues.chart.by-channel": "按渠道统计问题",
  "shopee.workspace.issues.chart.by-type": "按类型统计问题",
  "shopee.workspace.issues.chart.by-severity": "按级别统计问题",
  "shopee.workspace.issues.chart.timeline": "问题趋势图",
  "shopee.workspace.issues.chart.top-errors": "最常见问题",
  "shopee.workspace.issues.times-count": "{count} 次",
  "shopee.workspace.issues.top.order-list": "无法获取订单列表",
  "shopee.workspace.issues.top.invalid-data": "数据无效",
  "shopee.workspace.issues.top.negative-stock": "负库存",
  "shopee.workspace.issues.top.payment-not-found": "未找到付款交易",
  "shopee.workspace.issues.activity.processed": "已处理 TikTok Shop - 商品同步问题",
  "shopee.workspace.issues.activity.resolved": "已解决问题",
  "shopee.workspace.issues.drawer.title": "问题详情",
  "shopee.workspace.issues.drawer.info-title": "问题信息",
  "shopee.workspace.issues.drawer.error-code": "错误代码",
  "shopee.workspace.issues.drawer.request": "请求",
  "shopee.workspace.issues.drawer.request-detail": "请求详情",
  "shopee.workspace.issues.drawer.response-detail": "响应详情",
  "shopee.workspace.issues.drawer.impact-title": "影响范围",
  "shopee.workspace.issues.drawer.impact-orders": "受影响订单",
  "shopee.workspace.issues.drawer.impact-products": "受影响商品",
  "shopee.workspace.issues.drawer.impact-revenue": "受影响营收",
  "shopee.workspace.issues.drawer.suggestions-title": "处理建议",
  "shopee.workspace.issues.suggest.check-api": "检查 Shopee API 连接",
  "shopee.workspace.issues.suggest.check-status": "检查 Shopee 系统状态",
  "shopee.workspace.issues.suggest.retry-sync": "几分钟后重试同步",
  "shopee.workspace.issues.suggest.contact-support": "如果问题持续存在请联系支持团队",
  "shopee.workspace.issues.drawer.note-title": "内部备注",
  "shopee.workspace.issues.confirm.title": "确认处理问题",
  "shopee.workspace.issues.confirm.desc": "您确定要执行此操作吗？",
  "shopee.workspace.issues.confirm.items": "{label}（{count} 项）",
  "shopee.workspace.issues.confirm.ok": "确认",
  "shopee.workspace.issues.confirm.queued": "修复任务已加入队列",
  "shopee.workspace.issues.kpi.all": "全部问题",
  "shopee.workspace.issues.kpi.all-sub": "发现的问题总数",
  "shopee.workspace.issues.kpi.unresolved-sub": "需立即核查",
  "shopee.workspace.issues.kpi.in-progress": "处理中的问题",
  "shopee.workspace.issues.kpi.in-progress-sub": "目前正在处理",
  "shopee.workspace.issues.kpi.resolved": "已解决的问题",
  "shopee.workspace.issues.kpi.resolved-sub": "已成功解决",
  "shopee.workspace.issues.kpi.critical": "严重问题",
  "shopee.workspace.issues.kpi.critical-sub": "高与严重级别",
  "shopee.workspace.issues.action.configure-alerts": "配置告警",
  "shopee.workspace.issues.action.system-logs": "系统日志",
  "shopee.workspace.issues.col.channel-source": "渠道 / 来源",
  "shopee.workspace.issues.col.type": "问题类型",
  "shopee.workspace.issues.col.severity": "级别",
  "shopee.workspace.issues.col.object": "对象",
  "shopee.workspace.issues.col.message": "错误信息",
  "shopee.workspace.listing.description-template": "{name} - 优质商品",
  "shopee.workspace.listing.err.no-shop": "尚未选择 Shopee 店铺",
  "shopee.workspace.listing.err.no-product": "尚未选择 VMASS 商品",
  "shopee.workspace.listing.err.name-length": "商品名称须为 5-120 个字符",
  "shopee.workspace.listing.err.desc-length": "描述至少需要 25 个字符",
  "shopee.workspace.listing.err.price": "价格必须大于 0",
  "shopee.workspace.listing.err.variant-price": "所有规格的价格都必须大于 0",
  "shopee.workspace.listing.err.weight": "重量须在 0.01 至 50 公斤之间",
  "shopee.workspace.listing.err.no-category": "尚未选择 Shopee 类目",
  "shopee.workspace.listing.err.brand-load-failed": "无法加载 Shopee 品牌",
  "shopee.workspace.listing.err.no-brand": "尚未选择 Shopee 品牌",
  "shopee.workspace.listing.err.no-logistics": "尚未选择物流渠道",
  "shopee.workspace.listing.err.missing-attribute": "缺少属性：{attribute}",
  "shopee.workspace.listing.err.dimensions": "三个尺寸均需填写且大于 0",
  "shopee.workspace.listing.update-queued": "listing 更新请求已加入队列",
  "shopee.workspace.listing.publish-queued": "商品已加入发布到 Shopee 的队列",
  "shopee.workspace.listing.label.shop": "Shopee 店铺 *",
  "shopee.workspace.listing.no-shops": "暂无可用 Shopee 店铺",
  "shopee.workspace.listing.primary-mark": "主店铺",
  "shopee.workspace.listing.shop-hint": "类目、品牌和物流数据将根据所选店铺加载。",
  "shopee.workspace.listing.label.brand": "Shopee 品牌",
};

export default zhCn;
